<template>
    <div>
        <div id="overlayConfetti" @click="off()" style="display: none;">
            <div id="confettiBox" style="display: none; position: fixed;top: 0;right: 0;bottom: 0;left: 0;z-index: 1;">
                <div style="border-radius: 10px;width: 24%;max-height: 10rem;background: #01B1AF;position: absolute;top: 0;
    right: 0;bottom: 0;left: 0;margin: auto;display: flex;align-items: center;justify-content: center;">
                    <div class="text-white" style="text-align: center;">
                        <a class="" @click="off()" style="position: absolute; right: 20px; top: 10px;"><span style="font-size: 23px;">x</span></a>
                        <h4>🎉 Congrats! 🎉</h4>
                        <br>
                        <h5>You are a champion closer! 🎉</h5>
                        <div v-if="Date.now() < new Date(this.user.linkedin_token_expires_date) && this.user.linkedin_service == 1 ">
                            <button type="button" data-toggle="modal" data-target="#projectShareLinkedIn" class="btn btn-block" style="margin-top: 10px; box-shadow: 1px 1px 1px 1px #a0a0a0; padding: 10px 6px;color: #fff; background-color: #0a66c2">
                                <span style=""><b>Share On </b><img src="/images/linkedin-logo-2.png"
                                                                    alt="Share On Your LinkedIn Profile"
                                                                    style="width: 30px; margin-top: -5px;">
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <img :src="confettiPath" height="auto" width="100%" />
        </div>
        <flash-message></flash-message>
        <!-- Modal -->
        <div id="projectShareLinkedIn" class="modal fade" role="dialog">
            <div class="modal-dialog" style="max-width: 870px">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header" style="background-color: #0a66c2; color: #fff">
                        <h5 class="modal-title">Create a post</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form @submit.prevent="shareLinkedin" @keydown="formLinkedin.errors.clear($event.target.name)">
                        <div class="modal-body">
                            <div style="align-items: center; display: flex; margin-bottom: 15px;">
                                <div class="image-placeholder mr-4">
                                    <span role="img" class="profile-photo-preview" :style="previewStyle"></span>
                                </div>
                                <div class="mr-2">
                                    <h6>{{this.user.name}}</h6>
                                </div>
                                <div class="mr-2">
                                    <b-form-select v-model="formLinkedin.visibility" :options="optionsLinkedin" size="sm"></b-form-select>
                                    <div class="text-red text-xs" v-if="formLinkedin.errors.has('visibility')">{{
                                            formLinkedin.errors.get('visibility')
                                        }}
                                    </div>
                                    <input v-model="formLinkedin.project_google_image" type="hidden" name="project_google_image"
                                           class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                                </div>
                            </div>
                            <div class="mb-2">
                                <b-form-textarea
                                    id="textarea"
                                    v-model="formLinkedin.note"
                                    placeholder="Enter something..."
                                    rows="6"
                                    max-rows="6"
                                ></b-form-textarea>
                                <div class="text-red text-xs" v-if="formLinkedin.errors.has('note')">{{
                                        formLinkedin.errors.get('note')
                                    }}
                                </div>
                            </div>
                            <div style="position: relative">
                                <img v-if="formLinkedin.project_google_image" :src="formLinkedin.project_google_image" style="width: 840px;height: 500px;">
                            <img v-show="formLinkedin.project_google_image" src="http://wecision.com/enterprise/images/icons/closeIcon.png" style="position: absolute; top: 4px; right: 5px" @click.prevent="removeGoogleImage"/>
                                <div class="text-red text-xs" v-if="formLinkedin.errors.has('project_google_image')">{{
                                        formLinkedin.errors.get('project_google_image')
                                    }}
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none" style="background-color: #0a66c2 !important;"
                                :class="{'bg-teal-lighter cursor-not-allowed' : formLinkedin.errors.any(), 'bg-teal' : !formLinkedin.errors.any()}"
                                :disabled="formLinkedin.errors.any() || isActiveShareButton">
                                <span>Share On LinkedIn</span>
                            </button>
                        </div>
                    </form>

                </div>

            </div>
        </div>

        <div class="modal" id="pushContactToFoundationModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ externalCustomFieldModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closePushContactToFoundationModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <div v-for="(field, index) in external_custom_fields" v-if="field.is_foundation_custom_id">
                                    <label class="text-grey-darkest text-sm float-left">{{field.label_value}}</label>
                                    <input type="text" v-model="externalFoundationCustomFieldValue"
                                           class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                           required>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="sendPushContactToFoundationRequest(true)">
                            <i class="fa fa-spin fa-spinner text-white" v-if="foundationContactPushLoader" aria-hidden="true"></i>
                            Push To Foundation
                        </button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closePushContactToFoundationModal">Close</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div id="projectCommentModal" class="modal fade" role="dialog">
            <div class="modal-dialog" style="max-width: 870px">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 v-if="company_contact" class="modal-title text-lg">
                            Bid to comment: {{ company_contact.name }}
                        </h4>
                        <h4 v-else-if="sales_status" class="modal-title text-lg">
                            {{
                                projectCommentForm.sales_status ?
                                    sales_status.full_description :
                                    'Required comment for: "' + sales_status.full_description + '" Sales Status'
                            }}
                        </h4>
                        <h4 v-if="commentAddFrom" class="modal-title text-lg">
                            Call Log Comment
                        </h4>
                        <h4 v-else class="modal-title text-lg">General Comment</h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal" @click="closeProjectCommentModal()">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @keydown="projectCommentForm.errors.clear($event.target.name)">
                            <div v-if="sales_status && sales_status.dead && deadReasonCustomField" class="d-flex flex-row w-full mb-3 mt-2">
                                <strong class="w-1/5 m-auto">{{ deadReasonCustomField.label_value }}: </strong>
                                <multiselect
                                    class="cursor-pointer appearance-none focus:outline-none rounded text-grey-darkest text-sm w-2/3 field-height-update"
                                    :options="deadReasonCustomField.options"
                                    v-model="projectCommentForm.deadReason"
                                    :show-labels="false"
                                    track-by="id"
                                    label="name"
                                    value="id">
                                </multiselect>
                            </div>
                            <div class="mb-2">
                                <ckeditor-container placeholder="Send your colleagues on FollowUp notifications by typing @ followed by their name" id="comment" v-model="projectCommentForm.comment" :options="users"
                                                    @mention="addMention" mentionFrom="name"></ckeditor-container>
                                <div class="text-red text-xs" v-if="projectCommentForm.errors.has('comment')">{{
                                        projectCommentForm.errors.get('comment')
                                    }}
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <span v-if="this.projectCommentForm.saving">
                            <button type="button" disabled
                                    class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                <i class="fa fa-btn fa-spinner fa-spin"></i> Saving
                            </button>
                        </span>
                        <span v-else>
                            <button type="button" id="save-project-comment" name="save-project-comment"
                                    @click.prevent="projectCommentSaved"
                                    class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                Save
                            </button>
                        </span>
                    </div>
                </div>

            </div>
        </div>
        <!-- Modal -->
        <div id="newContactModal" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">New Contact </h4>
                        <button type="button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @keydown="newContactForm.errors.clear($event.target.name)">
                            <div class="mb-2 flex">
                                <div class="w-4/5">
                                    <label class="text-grey-darkest text-sm" for="new_contact_name"
                                           :class="{'text-red': newContactForm.errors.has('name')}">Name</label>
                                    <input v-model="newContactForm.name" id="new_contact_name" name="name"
                                           maxlength="64"
                                           class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                           :class="{'border-red': newContactForm.errors.has('name')}">
                                    <div class="text-red text-xs" v-if="newContactForm.errors.has('name')">{{
                                            newContactForm.errors.get('name')
                                        }}
                                    </div>
                                </div>
                                <div class="w-1/5 flex justify-center items-center">
                                    <div class="text-center cursor-pointer table mb-0"
                                         @click.prevent.stop="openNewCompaniesContactModal">
                                        <i class="fa fa-user fa-2x"></i>
                                        <i class="fa fa-plus-circle text-teal" style="margin-left: -22px"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="email"
                                       :class="{'text-red': newContactForm.errors.has('email')}">Email</label>
                                <input
                                    class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                    :class="{'border-red': newContactForm.errors.has('email')}"
                                    type="text" id="email" v-model="newContactForm.email">
                                <div class="text-red text-xs" v-if="newContactForm.errors.has('email')">{{
                                        newContactForm.errors.get('email')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="cell"
                                       :class="{'text-red': newContactForm.errors.has('cell')}">Cell</label>
                                <input
                                    class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                    type="text" id="cell" v-model="newContactForm.cell">
                                <div class="text-red text-xs" v-if="newContactForm.errors.has('cell')">{{
                                        newContactForm.errors.get('cell')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="new_contact_title"
                                       :class="{'text-red': newContactForm.errors.has('title')}">Title</label>
                                <input
                                    class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                    type="text" id="new_contact_title" v-model="newContactForm.title">
                                <div class="text-red text-xs" v-if="newContactForm.errors.has('title')">{{
                                        newContactForm.errors.get('title')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="new_contact_date"
                                       :class="{'text-red': newContactForm.errors.has('date')}">Follow Up</label>
                                <div class="flex">
                                    <datetime type="datetime" id="new_contact_date" name="date"
                                              v-model="newContactForm.date" use12-hour
                                              class="w-full"
                                              :format="masks.date_time_mask"
                                              input-class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                              @input="newContactForm.errors.clear('date')">
                                    </datetime>
                                    <button  type="button" v-if="newContactForm.date" @click.prevent.stop="removeNewContactDate"
                                            class="material-icons text-grey-darkest text-xl focus:outline-none">clear
                                    </button>
                                </div>
                                <div class="text-red text-xs" v-if="newContactForm.errors.has('date')">{{
                                        newContactForm.errors.get('date')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2" v-if="selectedCompany && !selectedCompany.is_residential">
                                <label class="text-sm text-grey-darkest -mb-0"
                                       :class="{'text-red': newContactForm.errors.has('contact_type')}">Contact
                                    Type</label>
                                <multiselect
                                    class="cursor-pointer"
                                    :options="contact_type_options"
                                    v-model="selectedTypeContact"
                                    :show-labels="false"
                                    @input="newContactForm.errors.clear('contact_type')"
                                    track-by="id"
                                    label="code"
                                    value="id">
                                </multiselect>
                                <div class="text-red text-xs" v-if="newContactForm.errors.has('contact_type')">{{
                                        newContactForm.errors.get('contact_type')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0"
                                       :class="{'text-red': newContactForm.errors.has('user')}">User</label>
                                <multiselect
                                    class="cursor-pointer"
                                    :options="usersForContact"
                                    v-model="selectedUserContact"
                                    :show-labels="false"
                                    @input="newContactForm.errors.clear('user')"
                                    track-by="id"
                                    label="name"
                                    value="id">
                                </multiselect>
                                <div class="text-red text-xs" v-if="newContactForm.errors.has('user')">{{
                                        newContactForm.errors.get('user')
                                    }}
                                </div>
                            </div>
                        </form>
                        <company-contact-modal ref="CompaniesContactModal" :masks="this.masks" :symbols="this.symbols"
                                               @selected="parseCompanyContact"></company-contact-modal>
                    </div>
                    <div class="modal-footer">
                        <button  type="button" @click.prevent="newContactSaved"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            Add
                        </button>
                        <button type="button"
                            class="bg-grey hover:bg-grey-darker px-3 py-1 rounded-full text-white focus:outline-none md:hidden">
                            Cancel
                        </button>
                    </div>
                </div>

            </div>
        </div>
        <!-- Modal -->
        <div id="generateProposalModal" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">Generate Proposal</h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <multiselect
                            id="generateProposal"
                            v-model="selectedContactForProposalGenerator"
                            :options="optionsForProposalGenerator"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="false"
                            :preserve-search="false"
                            :taggable="false"
                            open-direction="below"
                            placeholder="Pick a Contact"
                            :showLabels="false"
                            label="displayName"
                            track-by="id"
                            :preselect-first="false"
                            group-values="contact_options"
                            group-label="contact_type"
                            :group-select="false">
                        </multiselect>
                    </div>
                    <div class="modal-footer">
                        <button type="button" id="save-proposal-generator" name="save-proposal-generator"
                                @click.prevent="generateProposal"
                                class="btn btn-outline-primary rounded-full">
                            Generate Proposal
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Company Cam Model -->
        <div id="companyCamModal" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">Company Cam</h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="p-3">
                            <div class="flex justify-center my-3" v-if="companyCamSaveLoading">
                                <i class="fa  fa-2x fa-spinner fa-spin text-teal"></i>
                            </div>
                            <span v-else>
                                <div class="leading-tight" v-if="allCompanyCamProjects.length > 0">
                                <div class="flex justify-between">
                                    <div class="flex-col items-baseline">
                                        <div class="font-medium text-base text-grey-darkest">
                                            <b>Address exists in Company Cam</b>
                                        <p style="margin-bottom: 20px">Check the box to link the project</p>
                                        </div>
                                    </div>
                                    <button type="button" v-if="projectExistComapnyCam"  @click.prevent.stop="createCompanyCam()"
                                            class="focus:outline-none font-semibold bg-followup-nav text-white rounded-sm  text-break btn-sm" style="padding: 0px 30px;height: 45px;">
                                        Create new <br> Company cam
                                    </button>
                                </div>
                            </div>

                                <div class="flex justify-center my-3" v-if="companyCamSyncProjectLoading">
                                    <i class="fa  fa-2x fa-spinner fa-spin text-teal"></i>
                                </div>
                                <div v-else>
                                    <div v-if="allCompanyCamProjects.length > 0" v-for="(companyCamProject, index) in allCompanyCamProjects">
                                    <div class="w-100 d-flex" v-if="hasCompanyCamAccess && hasCompanyCamAccessToken && viewCompanyCamFlag && selectedCompanyCamProjectId && (companyCamProject.status == 'active')">
                                        <div style="width: 65%;">
                                            <div v-if="(selectedCompanyCamProjectId == companyCamProject.id)">
                                                <input type="checkbox" :title="companyCamProject.name" :id="'project-'+index" checked
                                                       :value="companyCamProject.id" name="CcProject" @click="selectedCcProject" />
                                                <label class="companyCam-label-style" style="cursor: pointer; color: #0f74a8; text-decoration: underline"
                                                       @click.prevent="viewCompanyCam">{{ companyCamProject.name }}</label>
                                            </div>
                                            <div v-else>
                                                <input type="checkbox" :title="companyCamProject.name" :id="'project-'+index"
                                                       :value="companyCamProject.id" name="CcProject" @click="selectedCcProject" />
                                                <label class="companyCam-label-style" style="cursor: pointer;">{{ companyCamProject.name }}</label>
                                            </div>

                                        </div>
                                        <div style="cursor: pointer;width: 35%;"
                                             v-if="(selectedCompanyCamProjectId == companyCamProject.id)" @click.prevent="uploadPhotos">
                                            <span style="font-size: 12px;font-weight: 500;margin-right: 10px;">Click to sync photos</span>
                                            <img src="/images/sync-solid.png" style=" width:auto; height:15px;"/>
                                        </div>
                                    </div>
                                    <div class="w-100" v-else-if="(companyCamProject.status == 'active')">
                                        <input type="checkbox" :title="companyCamProject.name" :id="'project-'+index"
                                               :value="companyCamProject.id" name="CcProject" @click="selectedCcProject" />
                                        <label class="companyCam-label-style" style="cursor: pointer;">{{ companyCamProject.name }}</label>
                                    </div>
                                </div>
                                    <div v-if="allCompanyCamProjects.length === 0">
                                        There is no project with your address.
                                        <div class="text-center mt-2">
                                            <button type="button" :disabled="companyCamSaveLoading" @click.prevent="createCompanyCam"
                                                    class="py-2 px-3 mr-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none lg:inline">
                                                Create In Company Cam
                                                <i v-if="companyCamSaveLoading"
                                                   class="fa fa-spin fa-spinner text-grey-darkest"
                                                   aria-hidden="true">
                                                </i>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal -->
        <div id="generateDataFormaModal" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">DataForma</h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <multiselect
                            v-model="selectedDataForma"
                            :options="dataFormaOptions"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="false"
                            :preserve-search="false"
                            :taggable="false"
                            open-direction="below"
                            placeholder="Select Option"
                            :showLabels="false"
                            label="name"
                            track-by="name"
                            :preselect-first="false">
                        </multiselect>
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click.prevent="generateDataForma"
                                class="btn btn-outline-primary rounded-full">
                            Send
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <b-modal no-close-on-backdrop size="lg" title="DataForma Integration" hide-footer @hidden="closeDataFormaModal"  v-model="showDataformaModal">
            <form>
                <span>1. Select an Option :</span>
                <label>
                    <input type="radio" value="create" name="dfOption" @click="selectDFOption" /> Create
                </label>
                <label>
                    <input type="radio" value="pull" name="dfOption" @click="selectDFOption" /> Pull
                </label>
                <div v-if="selectedDFOption === 'create'">
                    <span>2. Select an Object :</span>
                    <label>
                        <input v-model="createdSelectedDFOptions" type="radio" value="building" @click="changeDFOption"/> Building
                    </label>
                    <label>
                        <input v-model="createdSelectedDFOptions" type="radio" value="company" @click="changeDFOption"/> Company
                    </label>
                    <label>
                        <input v-model="createdSelectedDFOptions" type="radio" value="contact" @click="changeDFOption"/> Contact
                    </label>
                </div>
                <div v-if="selectedDFOption === 'pull'">
                    <span>2. Select an Object :</span>
                    <label>
                        <input type="radio" value="building" name="dfObject" @click="selectDFObject" /> Building
                    </label>
                    <label>
                        <input type="radio" value="company" name="dfObject" @click="selectDFObject" /> Company
                    </label>
                    <label>
                        <input type="radio" value="contact" name="dfObject" @click="selectDFObject" /> Contact
                    </label>
                </div>
            </form>
            <div v-if="selectedDFOption === 'pull' && (selectedDFObject === 'building' || selectedDFObject === 'contact'|| selectedDFObject === 'company')">
                <div class="w-100" v-if="selectedDFOption === 'pull'">
                    3. <input ref="filter" type="text"
                           class="p-2 rounded-full mt-2 mr-1 mb-3 text-sm max-width"
                           placeholder="Search your dataforma data" @input="debounceFilterDataForma" v-model="dataforma_search">
                    <span v-if="selectedDFObject === 'contact'">
                        4. <select class="input-select-design"
                                   v-model="selectedDFCompanyForContact">
                                <option v-for="item in allCompanies" :value="item.id">{{item.name }} </option>
                          </select>
                    </span>
                    <span class="ml-2 mt-2" style="color: red;" v-if="pullDataError !== ''">{{pullDataError}}</span>
                    <div v-if="saveDataformaLoader" class="dataforma-overlay">
                        <i class="fa fa-3x fa-spinner fa-spin text-teal loader-center"></i>
                    </div>
                    <table class="table table-striped" v-if="selectedDFObject === 'building'">
                        <thead>
                        <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Address</th>
                            <th scope="col">City</th>
                            <th scope="col">State</th>
                            <th scope="col">Zip</th>
                            <th scope="col"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="dataformaTableLoader">
                            <td colspan="6" style="text-align: center">
                                <i class="fa fa-2x fa-spinner fa-spin text-teal"></i>
                            </td>
                        </tr>
                        <tr v-if="dataforma_search_result.length === 0 && dataformaTableLoader === false">
                            <td colspan="6" style="text-align: center">
                                No result found
                            </td>
                        </tr>
                        <tr v-else v-for="building in dataforma_search_result">
                            <th scope="row">{{building.name}}</th>
                            <th>{{ building.street1 }}</th>
                            <td>{{ building.city }}</td>
                            <td>{{building.state}}</td>
                            <td>{{ building.zip }}</td>
                            <td>
<!--                                <input type="checkbox" v-if="dataforma_building_id === building.id" checked :value="building.id"
                                       @click="selectDFProject" name="dfProject"/>-->
                                <input type="checkbox" :value="building.id" name="dfProject" @click="selectDFProject" />
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <table class="table table-striped" v-if="selectedDFObject === 'company'">
                        <thead>
                        <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Website</th>
                            <th scope="col">Cell</th>
                            <th scope="col">Phone</th>
                            <th scope="col">Fax</th>
                            <th scope="col"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="dataformaTableLoader">
                            <td colspan="6" style="text-align: center">
                                <i class="fa fa-2x fa-spinner fa-spin text-teal"></i>
                            </td>
                        </tr>
                        <tr v-if="dataforma_search_result.length === 0 && dataformaTableLoader === false">
                            <td colspan="6" style="text-align: center">
                                No result found
                            </td>
                        </tr>
                        <tr v-else v-for="company in dataforma_search_result">
                            <th scope="row">{{company.name}}</th>
                            <th>{{ (company.website === "") ? '-' : company.website }}</th>
                            <td>{{ (company.phone1Id === 0) ? '-' : company.phone1Id }}</td>
                            <td>{{ (company.phone2Id === 0) ? '-' : company.phone2Id }}</td>
                            <td>{{ (company.phone3Id === 0) ? '-' : company.phone3Id }}</td>
                            <td>
<!--                                <input type="checkbox" v-if="dataforma_building_id === building.id" checked :value="building.id"
                                       @click="selectDFProject" name="dfProject"/>-->
                                <input type="checkbox" v-model="selectedDFCompany" :value="company.id" name="dfCompany"/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <table class="table table-striped" v-if="selectedDFObject === 'contact'">
                        <thead>
                        <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Phone</th>
                            <th scope="col">Title</th>
                            <th scope="col"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="dataformaTableLoader">
                            <td colspan="6" style="text-align: center">
                                <i class="fa fa-2x fa-spinner fa-spin text-teal"></i>
                            </td>
                        </tr>
                        <tr v-if="dataforma_search_result.length === 0 && dataformaTableLoader === false">
                            <td colspan="6" style="text-align: center">
                                No result found
                            </td>
                        </tr>
                        <tr v-else v-for="contact in dataforma_search_result">
                            <th scope="row">{{contact.firstName}}</th>
                            <th>{{ (contact.emailAddresses && contact.emailAddresses.length > 0) ? contact.emailAddresses[0].email : '-' }}</th>
                            <td>{{ (contact.phoneNumbers && contact.phoneNumbers.length > 0) ? contact.phoneNumbers[0].localNumber : '-' }}</td>
                            <td>{{ (contact.salutation === "") ? '-' : contact.salutation }}</td>
                            <td>
                                <!--                                <input type="checkbox" v-if="dataforma_building_id === building.id" checked :value="building.id"
                                                                       @click="selectDFProject" name="dfProject"/>-->
                                <input type="checkbox" v-model="selectedDFContact" :value="contact.id" name="dfCompany"/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="mt-2" style="text-align: right">
                    <button v-if="!saveDataformaLoader && selectedDFOption === 'pull'" type="button" @click.prevent="pullDataForma(selectedDFObject)"
                            class="btn btn-outline-primary rounded-full">
                        Pull
                    </button>
                    <button v-if="selectedDFOption === 'pull' && saveDataformaLoader" type="button"
                            class="btn btn-outline-primary rounded-full">
                        Pull
                        <i v-if="saveDataformaLoader"
                           class="fa fa-spin fa-spinner text-grey-darkest"
                           aria-hidden="true">
                        </i>
                    </button>
                </div>
            </div>
            <div v-if="selectedDFOption === 'create' && createdSelectedDFOptions != ''">
                <div class="w-100">
                        <div v-if="getDataformaTypesLoader" class="dataforma-overlay">
                            <i class="fa fa-3x fa-spinner fa-spin text-teal loader-center"></i>
                        </div>
                        <div v-else-if="!getDataformaTypesLoader && dataforma_all_types.length > 0">
                            <span v-if="createdSelectedDFOptions === 'building'">
                            <span>3. Select a building type :</span><select class="appearance-none bg-white border-1 focus:outline-none p-1 rounded text-grey-darkest"
                                                                                     v-model="dataformaType">
                                <option selected></option>
                                <option v-for="item in dataforma_all_types" :value="item.id">{{
                                            item.listValue
                                        }} </option>
                              </select>
                            </span>
                            <span v-if="createdSelectedDFOptions === 'company'">
                            <span>3. Select a company type :</span><select class="appearance-none bg-white border-1 focus:outline-none p-1 rounded text-grey-darkest"
                                                                                    v-model="dataformaType">
                                <option selected></option>
                                <option v-for="item in dataforma_all_types" :value="item.id">{{
                                            item.listValue
                                        }} </option>
                              </select>
                            </span>
                            <span v-if="createdSelectedDFOptions === 'contact'">
                            <span>3. Select a contact type :</span><select class="appearance-none bg-white border-1 focus:outline-none p-1 rounded text-grey-darkest"
                                                                                    v-model="dataformaType">
                                <option selected></option>
                                <option v-for="item in dataforma_all_types" :value="item.id">{{
                                            item.listValue
                                        }} </option>
                              </select>
                            </span>
                        </div>
                    </div>

                <span class="ml-2 mt-2 text-capitalize" style="color: red;" v-if="dfObjectExist !== ''" v-html="dfObjectExist"></span>
                <div v-for="error in dfErrors" v-if="error !== 'LAST_NAME: cannot be blank'">
                    <span class="ml-2 mt-2 text-capitalize" style="color: red;">
                        {{error.replace('STREET_1', 'ADDRESS').replace('FIRST_NAME', 'CONTACT')}}
                    </span>
                    <br>
                </div>
                <div class="mt-2" style="text-align: right">
                    <button v-if="createdSelectedDFOptions != ''  && !dataformaLoader && dfObjectExist === '' && dataformaType != '' && !getDataformaTypesLoader" type="button" @click.prevent="createDataForma(false)"
                            class="btn btn-outline-primary rounded-full">
                        {{ dfObjectExist === '' ? 'Create' :  'Create Anyway'}}
                    </button>
                    <button v-if="createdSelectedDFOptions != '' && !dataformaLoader && dfObjectExist !== '' && dataformaType != '' && !getDataformaTypesLoader" type="button"  @click.prevent="createDataForma(true)"
                            class="btn btn-outline-primary rounded-full">
                        {{ dfObjectExist === '' ? 'Create' :  'Create Anyway'}}
                    </button>
                    <button v-if="createdSelectedDFOptions != '' && dataformaLoader" type="button"
                            class="btn btn-outline-primary rounded-full">
                        {{ dfObjectExist === '' ? 'Create' :  'Create Anyways'}}
                        <i v-if="dataformaLoader"
                           class="fa fa-spin fa-spinner text-grey-darkest"
                           aria-hidden="true">
                        </i>
                    </button>
                </div>
            </div>
        </b-modal>

        <form @keydown="form.errors.clear($event.target.name)">
            <div class="flex justify-between items-center text-teal hover:text-teal-dark font-base text-xs mb-4 frozen-form-button pb-1 pt-2">
                <div class="flex">
                    <div @click="goBack"
                         class="py-2 px-3 flex cursor-pointer border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden mr-1">
                        Back
                        <!--<span class="hidden md:inline ml-1">to List</span>-->
                    </div>
                    <div v-if="projectPosition !== 'first' && projectPosition !== 'only'"
                         id="previous-project"
                         @click="changeProject('previous')"
                         class="px-3 flex cursor-pointer border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden mr-1">
                        <div class="flex justify-center items-center">
                            <i class="fa fa-chevron-left"></i>
                        </div>
                    </div>
                    <div v-if="projectPosition !== 'last' && projectPosition !== 'only'"
                         Record Details id="next-project"
                         @click="changeProject('next')"
                         class="px-3 flex cursor-pointer border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden">
                        <div class="flex justify-center items-center">
                            <i class="fa fa-chevron-right"></i>
                        </div>
                    </div>
                </div>
                <div class="d-flex align-items-center">
                <!--<button  type="button" @click.prevent="openDataFormaModal"
                            v-if="hasDataFormaAccess && viewDataFormaFlag===false"
                            class="py-2 px-3 mr-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden lg:inline">
                        Send To DataForma
                    </button>-->
                    <project-vista
                        v-if="vistaAccess"
                        ref="ProjectVistaComponent"
                        :project="project"
                        :vista-access="(vistaAccess)? 'true':'false'"
                        :project-sales-status-state="projectSalesStatusState"
                        :company-contacts="companyContactWithCompanyNameAtStart"
                        :vista-job-number-custom-field-id="vistaJobNumberCustomFieldId"
                        :erp-push-project-initiated-by-sales-status="erpPushProjectInitiatedBySalesStatus"
                        v-on:pushProjectCancelled="pushProjectCancelled"
                        :erp-connections="erpConnections"
                        :can-erp-create="canErpCreate"
                        :can-erp-update="canErpUpdate"
                        :can-erp-sync="canErpSync"
                    ></project-vista>
                    <project-spectrum
                        v-if="spectrumAccess && spectrumProjectMapping"
                        ref="ProjectSpectrumComponent"
                        :project="project"
                        :spectrum-access="(spectrumAccess)? 'true':'false'"
                        :project-sales-status-state="projectSalesStatusState"
                        :company-contacts="form.company_contacts"
                        :spectrum-project-mapping="spectrumProjectMapping"
                        :spectrum-job-number-custom-field-id="spectrumJobNumberCustomFieldId"
                        :has-spectrum-company-contact-mapping="hasSpectrumCompanyContactMapping"
                        :has-spectrum-residential-contact-mapping="hasSpectrumResidentialContactMapping"
                        :spectrum-customer-code-id="spectrumCustomerCodeId"
                        :spectrum-custom-id-auto-generated="spectrumCustomIdAutoGenerated"
                        @spectrum-refresh-project-contacts="refreshProjectCompanyContacts"
                        v-on:pushProjectCancelled="pushProjectCancelled"
                        :can-erp-create="canErpCreate"
                        :can-erp-update="canErpUpdate"
                        :can-erp-sync="canErpSync"
                    ></project-spectrum>

					<project-sage-100
                        v-if="sageAccess && sageProjectMapping"
                        ref="ProjectSageComponent"
                        :sageProjectMapping="sageProjectMapping"
                        :project="project"
                        :project-sales-status-state="projectSalesStatusState"
                        :company-contacts="form.company_contacts"
                        :sage-job-number-custom-field-id="sageJobNumberCustomFieldId"
                        v-on:pushProjectCancelled="pushProjectCancelled"
                        :can-erp-create="canErpCreate"
                        :can-erp-update="canErpUpdate"
                        :can-erp-sync="canErpSync"
                    ></project-sage-100>
					<sage-300-project
                        v-if="agaveErp && agaveErp.third_party_name == 'sage-300-cre' && agaveErp.project_field"
                        :mapping="agaveErp.project_field"
                        :custom-job-number-field-id="getSafe(() => agaveErp.project_field.custom_job_field.follow_up_field)"

                        :custom-customer-code-field-id="getSafe(() => agaveErp.company_field.custom_customer_field.follow_up_field)"
                        :custom-customer-code-field-name="getSafe(() => agaveErp.company_field.custom_customer_field.follow_up_field_label)"
                        :custom-contact-code-field-id="getSafe(() => agaveErp.company_field.custom_contact_field.follow_up_field)"
                        :custom-contact-code-field-name="getSafe(() => agaveErp.company_field.custom_contact_field.follow_up_field_label)"

                        :custom-residential-customer-code-field-id="getSafe(() => agaveErp.contact_field.custom_customer_field.follow_up_field)"
                        :custom-residential-customer-code-field-name="getSafe(() => agaveErp.contact_field.custom_customer_field.follow_up_field_label)"
                        :custom-residential-contact-code-field-id="getSafe(() => agaveErp.contact_field.custom_contact_field.follow_up_field)"
                        :custom-residential-contact-code-field-name="getSafe(() => agaveErp.contact_field.custom_contact_field.follow_up_field_label)"

                        ref="Sage300Project"
                        :project="project"
                        :company-contacts="form.company_contacts"
                        v-on:pushProjectCancelled="pushProjectCancelled"
                        :can-erp-create="canErpCreate"
                        :can-erp-update="canErpUpdate"
                        :can-erp-sync="canErpSync"
                    ></sage-300-project>
                    <project-foundation
                        v-if="foundationAccess && foundationProjectMapping"
                        ref="ProjectFoundationComponent"
                        :project="project"
                        :foundation-access="foundationAccess ? 'true' : 'false'"
                        :project-sales-status-state="projectSalesStatusState"
                        :company-contacts="form.company_contacts"
                        :foundation-project-mapping="foundationProjectMapping"
                        :foundation-job-number-custom-field-id="foundationJobNumberCustomFieldId"
                        :has-foundation-company-contact-mapping="hasFoundationCompanyContactMapping"
                        :has-foundation-residential-contact-mapping="hasFoundationResidentialContactMapping"
                        :is-project-sequential-id-mapped-to-foundation="isProjectSequentialIdMappedToFoundation"
                        :foundation-company-customer-code-custom-field="foundationCompanyCustomerCodeCustomField"
                        :foundation-residential-contact-customer-code-custom-field="foundationResidentialContactCustomerCodeCustomField"
                        v-on:pushProjectCancelled="pushProjectCancelled"
                        :can-erp-create="canErpCreate"
                        :can-erp-update="canErpUpdate"
                        :can-erp-sync="canErpSync"
                    ></project-foundation>

                    <project-computerEase
                        v-if="computerEaseAccess"
                        ref="ProjectComputerEaseComponent"
                        :project="project"
                        :computer-ease-access="(computerEaseAccess)? 'true':'false'"
                        :project-sales-status-state="projectSalesStatusState"
                        :computer-ease-project-mapping="computerEaseProjectMapping"
                    ></project-computerEase>

                    <div class="dropdown">
                        <button type="button" v-if="quickBookAccess && canEdit"
                                class="py-2 px-3 standard-dropdown border-1 border-teal hover:bg-followup-nav  rounded-full hover:text-white mx-1 text-teal text-followup-nav focus:outline-none"
                                id="quickBookDropDown" data-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false">
                            <i v-if="loadingQB" class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i>
                            QB Actions <i class="fa fa-caret-down mx-1"></i>
                        </button>
                        <div class="standard-dropdown dropdown-menu dropdown-menu-right" aria-labelledby="quickBookDropDown">
                            <button type="button" class="dropdown-item py-2" @click="qbEmailBilling()">
                                Email Billing
                            </button>
                            <button type="button" class="dropdown-item py-2" @click="createQBEstimateModal()">
                                Create Estimate
                            </button>
                            <button type="button" v-if="quickBookEstimatesList.length > 0" class="dropdown-item py-2" @click="editQBEstimateModal()">
                                View Estimates
                            </button>
                            <button type="button" class="dropdown-item py-2" @click="fetchQBInvoicesModal()" v-if="!project.quick_book_project_id">
                                Link to Quickbooks
                            </button>
                            <button type="button" class="dropdown-item py-2" @click="syncQBProjectInvoice()" v-else>
                                Sync Income Summary
                            </button>
                        </div>
                    </div>

                    <button type="button" @click.prevent="pushPullDataFoundation()" v-if="foundationProjectDataPullAccess && canEdit"
                            class="py-2 px-3 mr-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden lg:inline">
                        <i v-if="foundationLoading" class="fa fa-spin fa-spinner text-grey-darkest"
                           aria-hidden="true"></i>
                        Sync From Foundation
                    </button>
                    <button type="button" @click.prevent="showHoverProperty" v-if="hoverJobId && canEdit"
                            class="py-2 px-3 mr-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden lg:inline">
                        View Hover
                    </button>
                    <button type="button" @click.prevent="pushToHover" v-if="team.has_hover_access && user.hover_response_code && !hoverJobId && canEdit"
                            class="py-2 px-3 mr-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden lg:inline">
                        Hover
                        <i v-if="hoverLoading" class="fa fa-spin fa-spinner text-grey-darkest"
                                   aria-hidden="true"></i>
                    </button>
                    <button type="button" @click.prevent="sendToXScope" v-if="team.has_xscope_access && canEdit"
                            class="py-2 px-3 mr-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden lg:inline">
                        {{ form.xscope_project_id ? 'Update' : 'New' }} X-SCOPE Measure
                        <i v-if="xScopeLoading" class="fa fa-spin fa-spinner text-grey-darkest"
                                   aria-hidden="true"></i>
                    </button>
                    <button type="button" @click.prevent="redirectToXScopeProject" v-if="team.has_xscope_access && form.xscope_project_id && canEdit"
                            class="py-2 px-3 mr-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden lg:inline">
                        View X-SCOPE Measure
                    </button>
                    <button type="button" @click.prevent="showDataFormaModal"
                            v-if="hasDataFormaAccess && viewDataFormaFlag===false && canEdit"
                            class="py-2 px-3 mr-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden lg:inline">
                        DataForma
                    </button>
                    <button type="button" :disabled="stackSaveLoading" @click.prevent="createStack"
                            v-if="hasStackAccess && hasStackAccessToken && viewStackFlag === false && canEdit"
                            class="py-2 px-3 mr-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden lg:inline">
                        Create in STACK
                        <i v-if="stackSaveLoading"
                           class="fa fa-spin fa-spinner text-grey-darkest"
                           aria-hidden="true">
                        </i>
                    </button>
                    <button type="button" @click.prevent="openCompanyCamModal" v-if="hasCompanyCamAccess && hasCompanyCamAccessToken && canEdit"
                            class="py-2 px-3 mr-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden lg:inline">
                        Company Cam
                    </button>
                    <button
                        v-if="hasPricingAccess" data-testid="pricingImport"
                        class="py-2 px-3 mr-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden lg:inline"
                        @click.prevent="launchProject">Pricing Import
                    </button>
                    <button type="button" :disabled="ProcoreSaveLoading"  @click.prevent="pushPocoreProject" v-if="hasProcoreAccess && hasProcoreAccessToken && viewProcoreFlag === false && canEdit"
                            class="py-2 px-3 mr-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden lg:inline">
                        Push to Procore
                        <i v-if="ProcoreSaveLoading"
                           class="fa fa-spin fa-spinner text-grey-darkest"
                           aria-hidden="true">
                        </i>
                    </button>
                    <button type="button" @click.prevent="viewProcore" v-if="viewProcoreFlag && canEdit"
                            class="py-2 px-3 mr-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden lg:inline">
                        View in Procore
                    </button>
<!--                    <button type="button" :disabled="companyCamSaveLoading" @click.prevent="CompanyCamGetProjects"
                            v-if="hasCompanyCamAccess && hasCompanyCamAccessToken && viewCompanyCamFlag === false"
                    <!--                    <button type="button" :disabled="companyCamSaveLoading" @click.prevent="CompanyCamGetProjects"
                                                v-if="hasCompanyCamAccess && hasCompanyCamAccessToken && viewCompanyCamFlag === false"
                                                class="py-2 px-3 mr-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden lg:inline">
                                            Company Cam
                                            <i v-if="companyCamSaveLoading"
                                               class="fa fa-spin fa-spinner text-grey-darkest"
                                               aria-hidden="true">
                                            </i>
                                        </button>-->
                    <button type="button" @click.prevent="viewDataForma"
                            v-if="viewDataFormaFlag && canEdit"
                            class="py-2 px-3 mr-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden lg:inline">
                        View DataForma
                    </button>
                    <button  type="button" @click.prevent="viewStack"
                            v-if="viewStackFlag && canEdit"
                            class="py-2 px-3 mr-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden lg:inline">
                        View in STACK
                    </button>
                    <button type="button" @click.prevent="openGenerateProposalModal"
                            v-if="hasProposalGeneratorAccess && canEdit && hasProposalButtonAccess"
                            class="py-2 px-3 mr-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden lg:inline">
                        Generate Proposal
                    </button>
                    <a v-if="project.project_management == null && hasManagementAccess && canEdit" :href="createProjectManagement"
                       class="hover:no-underline py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav text-followup-nav hover:text-white rounded-full mr-1 focus:outline-none hidden lg:inline">
                        Create New Project Management
                    </a>
                    <a v-else-if="hasManagementAccess && canEdit" :href="switchToProjectManagement"
                       class="hover:no-underline py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav text-followup-nav hover:text-white rounded-full mr-1 focus:outline-none hidden lg:inline">
                        PM Record
                    </a>
                    <button type="button" @click.prevent="()=>{project.has_bid_id ? estimatingEdgeDetail() : estimatingEdgeCreate()}"
                            v-if="showEstimatingButton() && canEdit"
                            class="py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden lg:inline"
                            :class="{'cursor-not-allowed':loading_estimating_edge}"
                            :disabled="loading_estimating_edge && !canEdit">
                        {{ `${project.has_bid_id ? 'Refresh Bid-The EDGE™' : 'New Bid-The EDGE™'}` }}
                        <i v-if="loading_estimating_edge" class="fa fa-spin fa-spinner text-grey-darkest"
                           aria-hidden="true"></i>
                    </button>

                    <button type="button" @click.prevent="()=>{syncFCSIntegration()}"
                            v-if="hasFCS() && canEdit"
                            class="py-2 px-3 mr-1 border-1 rounded-full focus:outline-none hidden lg:inline"
                            :class="{
                                'cursor-not-allowed': loading_fcs,
                                'border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav': is_fcs_sync,
                                'btn-outline-warning': !is_fcs_sync,
                            }"
                            :disabled="loading_fcs && !canEdit">Sync FCS
                        <i v-if="loading_fcs" class="fa fa-spin fa-spinner text-grey-darkest"
                           aria-hidden="true"></i>
                    </button>

                    <button type="button" @click.prevent="()=>{syncRoofChiefIntegration()}"
                            v-if="hasRoofChiefConfigurated && canEdit"
                            class="mx-1 py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden lg:inline"
                            :disabled="loading_roof_chief && !canEdit">Roof Chief Integration
                        <i v-if="loading_roof_chief" class="fa fa-spin fa-spinner text-grey-darkest"
                           aria-hidden="true"></i>
                    </button>

                    <a v-if="canEdit" :href="`/project/create`"
                       class="hover:no-underline py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav text-followup-nav hover:text-white rounded-full mr-1 focus:outline-none hidden lg:inline">
                        New
                    </a>

                    <a :href="`/project/${project.id}/resource-files`" v-if="canViewProjectDocument"
                       class="hover:no-underline py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav text-followup-nav hover:text-white rounded-full mr-1 focus:outline-none hidden lg:inline">
                        Documents ({{ documentsQtd }})
                    </a>

                    <button v-if="canEdit" type="button" @click.prevent="saved(false)" dusk="save-project-button" :disabled="savingProject"
                            class="py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none">
                        <span v-if="savingProject"><i class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i>Saving</span>
                        <span v-else>Save</span>
                    </button>

                    <div class="dropdown">
                        <button type="button"
                                class="standard-dropdown border-2 border-teal bg-teal font-semibold p-2 rounded-full text-white ml-1"
                                id="projectDropdown" data-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false">
                            <i class="fa fa-caret-down mx-2"></i>
                        </button>
                        <div class="standard-dropdown dropdown-menu dropdown-menu-right" aria-labelledby="projectDropdown">
                            <a v-if="canEdit" :href="`/project/${project.id}/copy`" class="dropdown-item">
                                Copy
                            </a>
                            <a v-if="canEdit" :href="`/project/${project.id}/copy-related`" class="dropdown-item">
                                Copy as Related File
                            </a>
                            <button type="button" @click.prevent="print" class="dropdown-item">
                                Print
                            </button>
                            <button v-if="canDelete" type="button" @click.prevent="destroy" class="dropdown-item">
                                Delete
                            </button>
                        </div>
                    </div>


                    <div class="dropdown show">
                        <button type="button"
                            class="border-2 border-teal bg-teal font-semibold p-2 rounded-full text-white ml-1 lg:hidden"
                            id="dropdownMenuLink" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">
                            <i class="fa fa-caret-down mx-2"></i>
                        </button>

                        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuLink">
                            <button type="button" @click.prevent="showDataFormaModal"
                                    v-if="hasDataFormaAccess && viewDataFormaFlag===false"
                                    class="dropdown-item">
                                DataForma
                            </button>
                            <button type="button" @click.prevent="openCompanyCamModal" v-if="hasCompanyCamAccess && hasCompanyCamAccessToken && canEdit"
                                    class="dropdown-item">
                                Company Cam
                            </button>
                            <button type="button" @click.prevent="openGenerateProposalModal"
                                    v-if="hasProposalGeneratorAccess && hasProposalButtonAccess"
                                    class="dropdown-item">
                                Generate Proposal
                            </button>
                            <a v-if="project.project_management == null && hasManagementAccess"
                               :href="createProjectManagement"
                               class="dropdown-item">
                                Create New Project Management
                            </a>
                            <a v-else-if="hasManagementAccess" :href="switchToProjectManagement"
                               class="dropdown-item">
                                PM Record
                            </a>
                            <button type="button"
                                @click.prevent="()=>{project.has_bid_id ? estimatingEdgeDetail() : estimatingEdgeCreate()}"
                                v-if="showEstimatingButton()"
                                class="dropdown-item"
                                :class="{'cursor-not-allowed':loading_estimating_edge}"
                                :disabled="loading_estimating_edge">
                                {{ `${project.has_bid_id ? 'Refresh Bid-The EDGE™' : 'New Bid-The EDGE™'}` }}
                                <i v-if="loading_estimating_edge" class="fa fa-spin fa-spinner text-grey-darkest"
                                   aria-hidden="true"></i>
                            </button>

                            <button type="button" @click.prevent="()=>{syncFCSIntegration()}"
                                    v-if="hasFCS()"
                                    class="dropdown-item"
                                    :class="{
                                        'cursor-not-allowed': loading_fcs,
                                        'border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav': is_fcs_sync,
                                        'btn-outline-warning': !is_fcs_sync,
                                    }"
                                    :disabled="loading_fcs">Sync FCS
                                <i v-if="loading_fcs" class="fa fa-spin fa-spinner text-grey-darkest"
                                   aria-hidden="true"></i>
                            </button>
                            <a href="/project/create" class="dropdown-item">
                                New File
                            </a>
                            <button type="button" @click.prevent="print" class="dropdown-item">
                                Print
                            </button>
                            <a :href="`/project/${project.id}/copy`" class="dropdown-item">
                                Copy
                            </a>
                            <button v-if="canDelete" type="button" @click.prevent="destroy" class="dropdown-item">
                                Delete
                            </button>
                            <a v-if="canViewProjectDocument" :href="`/project/${project.id}/resource-files`" class="dropdown-item">
                                Documents ({{ documentsQtd }})
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex justify-between items-start lg:mb-4 flex-wrap flex-lg-nowrap mt-5">
                <div class="flex-col w-full lg:w-1/3">
                    <div class="rounded bg-white shadow-md mb-4">
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span>Project Information ID-{{ project.custom_project_id ? project.custom_project_id : project.sequential_team_id }}</span>
                            <span class="float-right" title="Legacy ID"
                                  v-if="project.legacy_id && userLegacy">{{ project.legacy_id }}</span>
                        </div>
                        <div class="pt-4 pb-2 px-3">
                            <div class="flex items-end justify-between">
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/5 p-0 m-0 flex items-center"
                                           :class="{'text-red' : form.errors.has('name')}" for="name">Name</label>
                                    <div class="w-2/5 md:w-3/5 lg:w-2/5 xl:w-3/5">
                                        <input v-model="form.name" type="text" name="name" id="name"
                                               class="rounded p-2 text-grey-darkest text-sm focus:outline-none border-1 w-full field-height-update"
                                               :class="{'border-red': form.errors.has('name'), 'bg-qualified':project.pre_qualified}">
                                    </div>

                                    <div class="w-2/5 md:w-1/5 lg:w-2/5 xl:w-1/5 flex items-center justify-center">
                                        <input type="checkbox" id="bid_bond" name="bid_bond" true-value="1"
                                               false-value="0" class="ml-1"
                                               v-model="form.bid_bond"
                                               @change="resetValidationErrors('bid_bond')">
                                        <label class="-mb-0 text-grey-darkest text-sm ml-1"
                                               :class="{'text-red' : form.errors.has('bid_bond')}" for="bid_bond">Bid
                                            Bond</label>
                                    </div>
                                    <div class="flex w-full">
                                        <div class="w-1/5"></div>
                                        <div class="text-red text-xs" v-if="form.errors.has('name')">{{
                                                form.errors.get('name')
                                            }}
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="mb-2 ml-2 leading-tight w-full row">
                                <label class="text-grey-darkest text-sm w-1/5 p-0 m-0 flex items-center"
                                       :class="{'text-red' : form.errors.has('address')}" for="address">
                                    Address
                                </label>
                                <div class="flex w-4/5">
<!--                                    <input v-model="form.address" type="text" name="address" id="address"
                                           class="rounded p-2 text-grey-darkest text-sm focus:outline-none border-1 w-4/5"
                                           :class="{'border-red': form.errors.has('address')}">-->
                                    <input id="searchTextField" v-model="form.address" type="text" size="50" name="address"
                                           class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1 field-height-update">
                                    <div class="cursor-pointer w-1/5 flex justify-center items-center">
                                        <a :href="`https://maps.google.com/?q=${form.address} ${form.city} ${form.state} ${form.zip}`"
                                           target="_blank">
                                            <i class="fa fa-map fa-lg"></i>
                                        </a>
                                    </div>
                                </div>
                                <div class="text-red text-xs" v-if="form.errors.has('address')">{{
                                        form.errors.get('address')
                                    }}
                                </div>
                                <input v-model="form.lat" type="hidden" name="lat"
                                       class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1 field-height-update">
                                <input v-model="form.lng" type="hidden" name="lng"
                                       class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1 field-height-update">
                                <input v-model="form.project_google_image" type="hidden" name="project_google_image"
                                       class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1 field-height-update">
                            </div>
                            <div class="flex mb-2 flex-wrap">
                                <div class="mb-2 pl-2 leading-tight w-1/3 pr-1">
                                    <label class="text-grey-darkest text-sm"
                                           :class="{'text-red' : form.errors.has('city')}" for="city">City</label>
                                    <input v-model="form.city" type="text" name="city" id="city"
                                           class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1 field-height-update"
                                           :class="{'border-red': form.errors.has('city')}">
                                    <div class="text-red text-xs" v-if="form.errors.has('city')">{{
                                            form.errors.get('city')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 leading-tight w-1/3 pr-1">
                                    <label class="text-grey-darkest text-sm"
                                           :class="{'text-red' : form.errors.has('state')}" for="state">State</label>
                                    <input v-model="form.state" type="text" name="state" id="state"
                                           maxlength="2"
                                           class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1 field-height-update"
                                           :class="{'border-red': form.errors.has('state')}">
                                    <div class="text-red text-xs" v-if="form.errors.has('state')">{{
                                            form.errors.get('state')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 leading-tight w-1/3 pr-1">
                                    <label class="text-grey-darkest text-sm"
                                           :class="{'text-red' : form.errors.has('zip')}" for="zip">Zip</label>
                                    <input v-model="form.zip" type="text" name="zip" id="zip"
                                           class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1 field-height-update"
                                           :class="{'border-red': form.errors.has('zip')}">
                                    <div class="text-red text-xs" v-if="form.errors.has('zip')">{{
                                            form.errors.get('zip')
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div class="mb-2 ml-2 leading-tight w-full row">
                                <div class="w-100">
                                    <div class="d-flex align-items-center">
                                        <label class="text-grey-darkest text-sm w-1/5 p-0 m-0 flex items-center" style="width: 25%;"
                                               :class="{'text-red' : form.errors.has('contact_name')}" for="contact_name">Contact</label>

                                        <input @input="debounceFilter" @keyup="focusOn();focusOut()" @blur="focusOutOnBlur()" v-model="form.contact_name" type="text" name="contact_name" id="contact_name"
                                               class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-4/5 field-height-update"
                                               :class="{'border-red': form.errors.has('contact_name')}" autocomplete="off">
                                        <div class="text-red text-xs" v-if="form.errors.has('contact_name')">
                                            {{form.errors.get('contact_name') }}
                                        </div>
                                        <div class="w-1/5 text-center cursor-pointer"
                                             @click.prevent.stop="openNewModal()">
                                            <i class="fa fa-user fa-2x"></i>
                                            <i class="fa fa-plus-circle text-teal" style="margin-left: -22px"></i>
                                        </div>
                                    </div>
                                    <div id="searchContacts_list">
                                        <div v-if="searchContactsLoader" class="search-contacts-loader">
                                            <i class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i>
                                        </div>
                                        <div style="cursor: pointer;" class="d-flex justify-content-between p-1 contactDiv" v-for="contact in searchContacts" @click="populateContacts(contact)">
                                            <div class="searchContactsListContactDetail" :title="contact.name">{{ contact.name }}</div>
                                            <div class="searchContactsListContactDetail" :title="contact.email" style="color: blue;">{{ contact.email }}</div>
                                            <div class="searchContactsListContactDetail" :title="contact.cell">
                                                <formatted-phone
                                                    v-if="contact.cell"
                                                    :phone="contact.cell"
                                                    :masks="masks"/></div>
                                            <div class="searchContactsListContactDetail" :title="contact.company.name">{{contact.company.name}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex w-full">
                                    <div class="w-1/5"></div>
                                    <div class="text-red text-xs" v-if="form.errors.has('contact_name')">{{
                                            form.errors.get('contact_name')
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div class="mb-2 ml-2 leading-tight w-full row">
                                <label class="text-grey-darkest text-sm w-1/5 p-0 m-0 flex items-center"
                                       :class="{'text-red' : form.errors.has('contact_email')}" for="contact_email">
                                    Email
                                </label>
                                <div class="w-4/5 flex">
                                    <input v-model="form.contact_email" type="text" name="contact_email"
                                           id="contact_email"
                                           class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-4/5 field-height-update"
                                           :class="{'border-red': form.errors.has('contact_email')}">
                                    <div class="cursor-pointer w-1/5 text-center">
                                        <a :href="'mailto:'+form.contact_email+mailSubject" target="_blank"
                                           class="material-icons text-3xl">mail</a>
                                    </div>
                                </div>
                                <div class="text-red text-xs" v-if="form.errors.has('contact_email')">{{
                                        form.errors.get('contact_email')
                                    }}
                                </div>
                            </div>

                            <div class="flex flex-wrap">
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/5 p-0 m-0 flex items-center"
                                           :class="{'text-red' : form.errors.has('contact_phone')}" for="contact_phone">
                                        Phone
                                    </label>
                                    <div class="w-4/5 flex">
                                        <template v-if="masks.v_mask_phone && masks.v_mask_phone.length > 0">
                                            <input v-model="form.contact_phone" type="text" name="contact_phone"
                                                   v-mask="masks.v_mask_phone"
                                                   id="contact_phone"
                                                   class="rounded p-2 md:p-1 text-grey-darkest text-sm focus:outline-none border-1 w-4/5 field-height-update"
                                                   :class="{'border-red': form.errors.has('contact_phone')}">
                                        </template>

                                        <template v-else>
                                            <input v-model="form.contact_phone" type="text" name="contact_phone"
                                                   id="contact_phone"
                                                   class="rounded p-2 md:p-1 text-grey-darkest text-sm focus:outline-none border-1 w-4/5 field-height-update"
                                                   :class="{'border-red': form.errors.has('contact_phone')}">
                                        </template>
                                        <div class="cursor-pointer w-1/5 text-center md:hidden">
                                            <a @click="callLogs(form.contact_phone, 'phone')"
                                               class="material-icons text-3xl">smartphone</a>
                                        </div>
                                    </div>

                                    <div class="text-red text-xs" v-if="form.errors.has('contact_phone')">{{
                                            form.errors.get('contact_phone')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/5 p-0 m-0 flex items-center"
                                           :class="{'text-red' : form.errors.has('contact_cell')}" for="contact_cell">
                                        Cell
                                    </label>

                                    <div class="w-4/5 flex">
                                        <template v-if="masks.v_mask_phone && masks.v_mask_phone.length > 0">
                                            <input v-model="form.contact_cell" type="text" name="contact_cell"
                                                   v-mask="masks.v_mask_phone"
                                                   id="contact_cell"
                                                   class="rounded p-2 md:p-1 text-grey-darkest text-sm focus:outline-none border-1 w-4/5 field-height-update"
                                                   :class="{'border-red': form.errors.has('contact_cell')}">
                                        </template>

                                        <template v-else>
                                            <input v-model="form.contact_cell" type="text" name="contact_cell"
                                                   id="contact_cell"
                                                   class="rounded p-2 md:p-1 text-grey-darkest text-sm focus:outline-none border-1 w-4/5 field-height-update"
                                                   :class="{'border-red': form.errors.has('contact_cell')}">
                                        </template>
                                        <div class="cursor-pointer w-1/5 text-center md:hidden">
                                            <a @click="callLogs(form.contact_cell, 'cell')"
                                               class="material-icons text-3xl">smartphone</a>
                                        </div>
                                    </div>

                                    <div class="text-red text-xs" v-if="form.errors.has('contact_cell')">{{
                                            form.errors.get('contact_cell')
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-wrap">
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/5 p-0 m-0 flex items-center"
                                           :class="{'text-red' : form.errors.has('contact_fax')}"
                                           for="contact_fax">
                                        Fax
                                    </label>

                                    <div class="w-4/5 flex">
                                        <template v-if="masks.v_mask_phone && masks.v_mask_phone.length > 0">
                                            <input v-model="form.contact_fax" type="text" name="contact_fax"
                                                   v-mask="masks.v_mask_phone"
                                                   id="contact_fax"
                                                   class="rounded p-2 md:p-1 text-grey-darkest text-sm focus:outline-none border-1 w-4/5 field-height-update"
                                                   :class="{'border-red': form.errors.has('contact_fax')}">
                                        </template>

                                        <template v-else>
                                            <input v-model="form.contact_fax" type="text" name="contact_fax"
                                                   id="contact_fax"
                                                   class="rounded p-2 md:p-1 text-grey-darkest text-sm focus:outline-none border-1 w-4/5 field-height-update"
                                                   :class="{'border-red': form.errors.has('contact_fax')}">
                                        </template>
                                        <div class="cursor-pointer w-1/5 text-center md:hidden">
                                            <a :href="`tel:${form.contact_fax}`" target="_blank"
                                               class="material-icons text-3xl">smartphone</a>
                                        </div>
                                    </div>

                                    <div class="text-red text-xs" v-if="form.errors.has('contact_fax')">{{
                                            form.errors.get('contact_fax')
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="rounded bg-white shadow-md mb-4 lg:hidden">
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span>Sales Activities</span>
                        </div>
                        <div class="pt-4 pb-2 px-3">
                            <div v-if="form.sales_behaviors.length > 0" v-for="(item, index) in form.sales_behaviors"
                                 class="flex mb-2 inline-block">
                                <div v-if="atLeastOneHasDate" class="col-1 px-1 flex items-center">
                                    <input v-if="item.date && !item.follow_up" type="checkbox" id="" name=""
                                           true-value="1" false-value="0" class="sales-behavior-checkbox"
                                           :disabled="checked_proposal_delivered === item.id"
                                           v-model="item.completed"
                                           @change="checkIsProposalDelivered(item);checkIsSalesActivityCompleted(item);">
                                </div>
                                <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center"
                                       :class="atLeastOneHasDate ? 'col-5' : 'col-6'">{{ item.name }}:</label>
                                <div v-show="hasCalendarAccess==false" class="flex px-1"
                                     :class="atLeastOneHasDate ? 'col-5' : 'col-6'">
                                    <datepicker v-model="item.date"
                                                @keypress.enter.prevent="closeCalendar()"
                                                :ref=item.name
                                                :disabled="checked_proposal_delivered === item.id"
                                                :format="masks.date_mask"
                                                :use-utc="true"
                                                :week-start="7"
                                                :wrapper-class="item.date && checked_proposal_delivered !== item.id ? 'fullscreen-when-on-mobile w-4/5' : 'fullscreen-when-on-mobile w-full'"
                                                input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update">
                                    </datepicker>

                                    <button type="button" v-if="item.date && checked_proposal_delivered !== item.id"
                                            @click="removeDate(item.name, index)"
                                            class="material-icons text-grey-darkest text-xl focus:outline-none">clear
                                    </button>
                                </div>
                                <div v-show="hasCalendarAccess" class="flex px-1"
                                     :class="atLeastOneHasDate ? 'col-5' : 'col-6'">
                                    <datetime v-if="item.end_date" type="datetime" name="date"
                                              v-model="item.end_date" use12-hour
                                              :ref=item.name
                                              class="w-full"
                                              :week-start="7"
                                              :format="masks.date_time_mask"
                                              :minute-step="15"
                                              input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update"
                                              @input="form.errors.clear('start_date')">
                                    </datetime>
                                    <datetime v-if="!item.end_date" type="datetime" name="date"
                                              v-model="item.date" use12-hour
                                              :ref=item.name
                                              class="w-full"
                                              :week-start="7"
                                              :format="masks.date_time_mask"
                                              :minute-step="15"
                                              input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update"
                                              @input="form.errors.clear('start_date')">
                                    </datetime>
                                    <button  type="button" v-if="item.date && checked_proposal_delivered !== item.id"
                                            @click="removeDateTimePicker(index)"
                                            class="material-icons text-grey-darkest text-xl focus:outline-none">clear
                                    </button>
                                </div>
                                <div class="text-teal cursor-pointer flex justify-center items-center col-1 px-1"
                                     @click.prevent.stop="openEmailModal(item,form.name)">
                                    <i v-if="item.date" class="fa fa-calendar"></i>
                                </div>
                            </div>
                            <div v-if="form.sales_behaviors.length === 0" class="mb-2">
                                <div class="text-grey-darkest text-sm">
                                    Your company does not currently have any sales behaviors.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="enablePrequalification" class="rounded bg-white shadow-md mb-4">
                        <div class="border-b-2 py-2 px-3"
                             :class="{'bg-primary border-primary text-white':!project.pre_qualified, 'bg-qualified': project.pre_qualified}">
                            <span>Prequalifications</span>
                            <span
                                class="float-right"
                                v-if="project.pre_qualified"
                            >
                                (Pre-Qualified)
                            </span>
                        </div>
                        <div class="pt-4 pb-2 px-3">
                            <div class="flex flex-wrap">
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('relate_and_connect_id')}"
                                           for="relate_and_connect_id">Relate & Connect</label>
                                    <select name="relate_and_connect_id" id="relate_and_connect_id"
                                            v-model="form.relate_and_connect_id"
                                            class="appearance-none bg-white border-1 focus:outline-none p-1 rounded text-grey-darkest text-sm w-1/2 md:w-2/3 field-height-update"
                                            :class="{'border-red': form.errors.has('relate_and_connect_id')}"
                                            @change="resetValidationErrors('relate_and_connect_id');()=>pre_qualified_edited = true">
                                        <option selected></option>
                                        <option v-for="item in selects.relate_and_connect" :value="item.id">{{
                                                item.full_description
                                            }}
                                        </option>
                                    </select>
                                    <div class="text-red text-xs" v-if="form.errors.has('relate_and_connect_id')">{{
                                            form.errors.get('relate_and_connect_id')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('rules_of_engagement_id')}"
                                           for="rules_of_engagement_id">Rules of Engagement</label>
                                    <select name="rules_of_engagement_id" id="rules_of_engagement_id"
                                            v-model="form.rules_of_engagement_id"
                                            class="appearance-none bg-white border-1 focus:outline-none p-1 rounded text-grey-darkest text-sm w-1/2 md:w-2/3 field-height-update"
                                            :class="{'border-red': form.errors.has('rules_of_engagement_id')}"
                                            @change="resetValidationErrors('rules_of_engagement_id');()=>pre_qualified_edited=true">
                                        <option selected></option>
                                        <option v-for="item in selects.rules_of_engagement" :value="item.id">{{
                                                item.full_description
                                            }}
                                        </option>
                                    </select>
                                    <div class="text-red text-xs" v-if="form.errors.has('rules_of_engagement_id')">{{
                                            form.errors.get('rules_of_engagement_id')
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-wrap">
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('find_problems_id')}"
                                           for="find_problems_id">Find Problems</label>
                                    <select name="find_problems_id" id="find_problems_id"
                                            v-model="form.find_problems_id"
                                            class="appearance-none bg-white border-1 focus:outline-none p-1 rounded text-grey-darkest text-sm w-1/2 md:w-2/3 field-height-update"
                                            :class="{'border-red': form.errors.has('find_problems_id')}"
                                            @change="resetValidationErrors('find_problems_id');()=>pre_qualified_edited=true">
                                        <option selected></option>
                                        <option v-for="item in selects.find_problems" :value="item.id">{{
                                                item.full_description
                                            }}
                                        </option>
                                    </select>
                                    <div class="text-red text-xs" v-if="form.errors.has('find_problems_id')">{{
                                            form.errors.get('find_problems_id')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('money_step_id')}" for="money_step_id">Money
                                        Step</label>
                                    <select name="money_step_id" id="money_step_id"
                                            v-model="form.money_step_id"
                                            class="appearance-none bg-white border-1 focus:outline-none p-1 rounded text-grey-darkest text-sm w-1/2 md:w-2/3 field-height-update"
                                            :class="{'border-red': form.errors.has('money_step_id')}"
                                            @change="resetValidationErrors('money_step_id');()=>pre_qualified_edited=true">
                                        <option selected></option>
                                        <option v-for="item in selects.money_step" :value="item.id">{{
                                                item.full_description
                                            }}
                                        </option>
                                    </select>
                                    <div class="text-red text-xs" v-if="form.errors.has('money_step_id')">{{
                                            form.errors.get('money_step_id')
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-wrap">
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('decision_process_id')}"
                                           for="decision_process_id">Decision Process</label>
                                    <select name="decision_process_id" id="decision_process_id"
                                            v-model="form.decision_process_id"
                                            class="appearance-none bg-white border-1 focus:outline-none p-1 rounded text-grey-darkest text-sm w-1/2 md:w-2/3 field-height-update"
                                            :class="{'border-red': form.errors.has('decision_process_id')}"
                                            @change="resetValidationErrors('decision_process_id');()=>pre_qualified_edited=true">
                                        <option selected></option>
                                        <option v-for="item in selects.decision_process" :value="item.id">{{
                                                item.full_description
                                            }}
                                        </option>
                                    </select>
                                    <div class="text-red text-xs" v-if="form.errors.has('decision_process_id')">{{
                                            form.errors.get('decision_process_id')
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="record-details" class="rounded bg-white shadow-md mb-4">
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span>Record Details</span>
                        </div>
                        <div class="py-3 px-3">
                            <div v-if="Object.keys(recordDetailFieldLabels).length > 0" class="row">
                                <div v-for="label in Object.keys(recordDetailFieldLabels)" class="col-xs-12 col-md-12 pr-0">
                                    <div v-if="label === 'base-bid'" class="flex align-items-baseline py-1 px-2">
                                        <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                               :class="{'text-red' : form.errors.has('base_bid')}" for="base_bid">{{ getFieldLabel(recordDetailFieldLabels, 'base-bid') }}</label>
                                        <div class="flex flex-column w-1/2 md:w-2/3">
                                            <currency-input
                                                id="base_bid"
                                                name="base_bid"
                                                v-model="form.base_bid"
                                                @change="baseBidUpdate($event)"
                                                locale="us"
                                                :currency="null"
                                                class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update"
                                                :class="{'border-red': form.errors.has('base_bid')}">
                                            </currency-input>
                                            <div class="text-red text-xs" v-if="form.errors.has('base_bid')">
                                                {{ form.errors.get('base_bid') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="changeOrderKey && hasPipelineGraph && label === 'final-base-bid'" class="flex align-items-baseline py-1 px-2">
                                        <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                               :class="{'text-red' : form.errors.has('base_bid_total')}" for="base_bid">{{ getFieldLabel(recordDetailFieldLabels, 'final-base-bid') }}</label>
                                        <div class="flex flex-column w-1/2 md:w-2/3">
                                            <currency-input
                                                id="base_bid_total"
                                                name="base_bid_total"
                                                v-model="form.base_bid_total"
                                                locale="us"
                                                :currency="null"
                                                :disabled="true"
                                                class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update"
                                                :class="{'border-red': form.errors.has('base_bid_total')}">
                                            </currency-input>
                                            <div class="text-red text-xs" v-if="form.errors.has('base_bid_total')">
                                                {{ form.errors.get('base_bid_total') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="label === 'contract-amount'" class="flex align-items-baseline py-1 px-2">
                                        <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                               :class="{'text-red' : form.errors.has('contract_amount')}"
                                               for="contract_amount">{{ getFieldLabel(recordDetailFieldLabels, 'contract-amount') }}</label>
                                        <div class="flex flex-column w-1/2 md:w-2/3">
                                            <currency-input
                                                id="contract_amount"
                                                name="contract_amount"
                                                v-model="form.contract_amount"
                                                locale="us"
                                                :currency="null"
                                                class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update"
                                                :class="{'border-red': form.errors.has('contract_amount')}">
                                            </currency-input>
                                            <div class="text-red text-xs" v-if="form.errors.has('contract_amount')">
                                                {{ form.errors.get('contract_amount') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="changeOrderKey && hasSumContractAmount && label === 'final-contract-amount'" class="flex align-items-baseline py-1 px-2">
                                        <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                               :class="{'text-red' : form.errors.has('contract_amount_total')}"
                                               for="contract_amount">{{ getFieldLabel(recordDetailFieldLabels, 'final-contract-amount') }}</label>
                                        <div class="flex flex-column w-1/2 md:w-2/3">
                                            <currency-input
                                                id="contract_amount_total"
                                                name="contract_amount_total"
                                                v-model="form.contract_amount_total"
                                                locale="us"
                                                :currency="null"
                                                :disabled="true"
                                                class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update"
                                                :class="{'border-red': form.errors.has('contract_amount_total')}">
                                            </currency-input>
                                            <div class="text-red text-xs" v-if="form.errors.has('contract_amount_total')">
                                                {{ form.errors.get('contract_amount_total') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="team.has_probability_access && label === 'estimated-contract-date'" class="flex align-items-baseline py-1 px-2">
                                        <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                               :class="{'text-red' : form.errors.has('estimated_contract_date')}">{{ getFieldLabel(recordDetailFieldLabels, 'estimated-contract-date') }}</label>
                                        <div class="flex flex-column w-1/2 md:w-2/3">
                                            <div class="flex">
                                                <datepicker v-model="form.estimated_contract_date" :format="masks.date_mask"
                                                            @keypress.enter.prevent="closeCalendar()"
                                                            :use-utc="true"
                                                            :wrapper-class="isAdmin && form.estimated_contract_date ? 'w-4/5 fullscreen-when-on-mobile' : 'w-full fullscreen-when-on-mobile'"
                                                            :input-class="form.errors.has('estimated_contract_date') ? 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-red' : 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1'"
                                                            @input="resetValidationErrors('estimated_contract_date')">
                                                </datepicker>
                                                <button type="button" v-if="isAdmin && form.estimated_contract_date" @click="form.estimated_contract_date = ''"
                                                        class="material-icons text-grey-darkest text-xl focus:outline-none w-1/5">
                                                    clear
                                                </button>
                                            </div>
                                            <div class="text-red text-xs" v-if="form.errors.has('estimated_contract_date')">
                                                {{ form.errors.get('estimated_contract_date') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="label === 'contract-date'" class="flex align-items-baseline py-1 px-2">
                                        <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                               :class="{'text-red' : form.errors.has('contract_date')}">{{ getFieldLabel(recordDetailFieldLabels, 'contract-date') }}</label>
                                        <div class="flex flex-column w-1/2 md:w-2/3">
                                            <div class="flex">
                                                <datepicker v-model="form.contract_date" :format="masks.date_mask"
                                                            @keypress.enter.prevent="closeCalendar()"
                                                            :use-utc="true"
                                                            :wrapper-class="isAdmin && form.contract_date ? 'w-4/5 fullscreen-when-on-mobile' : 'w-full fullscreen-when-on-mobile'"
                                                            :input-class="form.errors.has('contract_date') ? 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-red field-height-update' : 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update'"
                                                            @input="resetValidationErrors('contract_date')">
                                                </datepicker>
                                                <button type="button" v-if="isAdmin && form.contract_date" @click="form.contract_date = ''"
                                                        class="material-icons text-grey-darkest text-xl focus:outline-none w-1/5">
                                                    clear
                                                </button>
                                            </div>
                                            <div class="text-red text-xs" v-if="form.errors.has('contract_date')">
                                                {{ form.errors.get('contract_date') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="label === 'login-date'" class="flex align-items-baseline py-1 px-2">
                                        <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                               :class="{'text-red' : form.errors.has('login_date')}">{{ getFieldLabel(recordDetailFieldLabels, 'login-date') }}</label>
                                        <div class="flex flex-column w-1/2 md:w-2/3">
                                            <datepicker
                                                v-model="form.login_date" :format="masks.date_mask"
                                                @keypress.enter.prevent="closeCalendar()"
                                                wrapper-class="fullscreen-when-on-mobile"
                                                input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update"
                                                :disabled="!isAdmin">
                                            </datepicker>
                                            <div class="text-red text-xs" v-if="form.errors.has('login_date')">
                                                {{ form.errors.get('login_date') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="label === 'gross-margin'" class="flex align-items-baseline py-1 px-2">
                                        <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                               :class="{'text-red' : form.errors.has('gross_margin_percentage')}"
                                               for="gross_margin_percentage">{{ getFieldLabel(recordDetailFieldLabels, 'gross-margin') }} %</label>
                                        <div class="flex flex-column w-1/2 md:w-2/3">
                                            <currency-input
                                                id="gross_margin_percentage"
                                                name="gross_margin_percentage"
                                                v-model="form.gross_margin_percentage"
                                                locale="us"
                                                :currency="null"
                                                class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update"
                                                :class="{'border-red': form.errors.has('gross_margin_percentage')}">
                                            </currency-input>
                                            <div class="text-red text-xs" v-if="form.errors.has('gross_margin_percentage')">
                                                {{ form.errors.get('gross_margin_percentage') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="label === 'labor-hours'" class="flex align-items-baseline py-1 px-2">
                                        <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                               :class="{'text-red' : form.errors.has('labor_hours')}" for="labor_hours">{{ getFieldLabel(recordDetailFieldLabels, 'labor-hours') }}</label>
                                        <div class="flex flex-column w-1/2 md:w-2/3">
                                            <currency-input
                                                id="labor_hours"
                                                name="labor_hours"
                                                v-model="form.labor_hours"
                                                locale="us"
                                                :currency="null"
                                                class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update"
                                                :class="{'border-red': form.errors.has('labor_hours')}">
                                            </currency-input>
                                            <div class="text-red text-xs" v-if="form.errors.has('labor_hours')">
                                                {{ form.errors.get('labor_hours') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="label === 'dead-date'" class="flex align-items-baseline py-1 px-2">
                                        <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                               :class="{'text-red' : form.errors.has('dead_date')}">{{ getFieldLabel(recordDetailFieldLabels, 'dead-date') }}
                                        </label>
                                        <div class="flex flex-column w-1/2 md:w-2/3">
                                            <div class="flex">
                                                <datepicker v-model="form.dead_date" :format="masks.date_mask" :use-utc="true"
                                                            @keypress.enter.prevent="closeCalendar()"
                                                            :wrapper-class="isAdmin && form.dead_date ? 'w-4/5 fullscreen-when-on-mobile' : 'w-full fullscreen-when-on-mobile'"
                                                            :input-class="form.errors.has('dead_date') ? 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-red field-height-update' : 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update'"
                                                            @input="resetValidationErrors('dead_date')">
                                                </datepicker>
                                                <button type="button" v-if="isAdmin && form.dead_date" @click="form.dead_date = ''"
                                                        class="material-icons text-grey-darkest text-xl focus:outline-none w-1/5">
                                                    clear
                                                </button>
                                            </div>
                                            <div class="text-red text-xs" v-if="form.errors.has('dead_date')">
                                                {{ form.errors.get('dead_date') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="label === 'completed' && quickBookAccess && team.quick_book_complete_percentage" class="flex align-items-baseline py-1 px-2">
                                        <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                               for="project_complete_percentage">{{ getFieldLabel(recordDetailFieldLabels, 'completed') }} %</label>
                                        <div class="flex flex-column w-1/2 md:w-2/3">
                                            <select name="complete_percentage" id="project_complete_percentage"
                                                    v-model="form.complete_percentage"
                                                    class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm field-height-update">
                                                <option selected></option>
                                                <option v-for="option in changeOrderCompletePercentages" :value="option">{{ option }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <project-record-detail-custom-fields
                                    ref="ProjectRecordDetailCustomFields"
                                    :project="project"
                                    :masks="masks"
                                    :customFieldErrors="form.errors"
                                >
                                </project-record-detail-custom-fields>
                            </div>
                        </div>
                    </div>
                    <div class="rounded bg-white shadow-md mb-4" v-if="(quickBookInvoiceData || quickBookCostData) && quickBookAccess">
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span><img class="qb-small-logo-project mr-1" src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/qb-logo-small.png">QB Income vs Cost <span class="cursor-pointer" v-if="project.quick_book_project_id" @click="syncQBProjectInvoice()"><i class="fa fa-refresh" aria-hidden="true"></i></span> <span v-if="project.quick_book_project_id" class="float-right"><button class="btn btn-primary text-xs p-0 px-1 bg-white text-teal hover:text-black shadow-none active:text-black" @click.prevent="openQuickBookInvoiceCostDetailModal()" style="color:#4dc0b5 !important; ">View Details</button></span> <span v-else class="float-right"><button class="btn btn-primary text-xs p-0 px-1 bg-white text-red hover:text-black shadow-none active:text-black" @click.prevent="fetchQBInvoicesModal()">Project Not Linked</button></span></span>
                        </div>
                        <!--<div class="pb-2 px-3" v-if="quickBookInvoiceData.invoiceData.length > 0">
                            <div :class="(index % 2 === 0)? 'row py-1 text-sm':'row bg-grey-light py-1 text-sm'" v-for="(invoiceDetail, index) in quickBookInvoiceData.invoiceData">
                                <div class="col-md-8 text-left">
                                    {{ invoiceDetail[0] }}
                                </div>
                                <div class="col-md-4 text-right">
                                    ${{ invoiceDetail[1] }}
                                </div>
                            </div>
                        </div>-->
                        <div class="pb-0 px-3" v-if="quickBookCostData && quickBookInvoiceData">
                            <div class="row py-2 text-sm border-b-1">
                                <div class="col-md-8 text-left">
                                    Income
                                </div>
                                <div class="col-md-4 text-right">
                                    ${{quickBookInvoiceData.invoiceTotal}}
                                </div>
                            </div>
                            <div class="row py-2 text-sm border-b-1">
                                <div class="col-md-8 text-left">
                                    Expense
                                </div>
                                <div class="col-md-4 text-right">
                                    ${{quickBookCostData.costTotal}}
                                </div>
                            </div>
                            <div class="row py-2 text-sm">
                                <div class="col-md-8 text-left">
                                    Profit
                                </div>
                                <div class="col-md-4 text-right">
                                    ${{quickBookInvoiceData.invoiceTotal - quickBookCostData.costTotal}}
                                </div>
                            </div>
                        </div>
                        <div class="pt-4 pb-2 px-3 text-center" v-else>
                            No invoice detail found
                        </div>
                    </div>

                    <sage-100-income-vs-cost ref="SageIncomeCost" v-if="sageAccess && canEdit" :project="project"></sage-100-income-vs-cost>
                    <sage-300-income-vs-cost ref="Sage300IncomeCost" v-if="agaveErp && agaveErp.third_party_name == 'sage-300-cre' && canEdit" :project="project"></sage-300-income-vs-cost>
                    <spectrum-income-vs-cost ref="SpectrumIncomeCost" v-if="spectrumAccess && canEdit" :project="project"></spectrum-income-vs-cost>
                    <vista-income-cost ref="VistaIncomeCost" v-if="vistaAccess && canEdit" :project="project" :erpConnectionId="erpConnectionId" ></vista-income-cost>
                    <foundation-income-cost ref="FoundationIncomeCost" v-if="foundationAccess && canEdit" :project="project"></foundation-income-cost>


                    <div v-if="changeOrderKey" id="change-order" class="rounded bg-white shadow-md">
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span>Change Orders</span>
                        </div>
                        <div class="pt-4 pb-2 px-3">
                            <span v-for="(item,index) in change_orders" >
                                <div>
                                    <div class="bg-primary text-white text-center py-1 w-1/5 mb-2 rounded-sm float-left">{{index+1}}</div>

<!--                                    check default connection-->
<!--                                    if yes then call api -> check mappings ->buttons disable/enable-->
<!--                                    if no then open connections popup -> select connection -> call api ->check mappings ->buttons disable/enable-->
                                    <div class="w-3/5 float-right d-flex flex-column mb-3 align-items-end" v-if="vistaAccess">

                                        <template v-if="!erpConnectionId && erpConnections.length > 1">
                                             <button class="btn btn-primary float-right mb-1 btn-sm"
                                                     @click.prevent="openVistaConnectionSelection(true)">
                                                Sync From Vista
                                            </button>
                                        </template>

                                        <template v-else>
                                            <button v-if="vistaProjectConnectionData.hasVistaContractChangeOrderMapped && vistaProjectConnectionData.hasVistaContractChangeOrderFieldsMapped !== null" class="btn btn-primary float-right mb-1 btn-sm" :disabled="isSyncChangeOrderDisabled" :title="changeOrderTooltipText" @click.prevent="syncChangeOrderFromVistaContract(index, item)">Sync From Vista Contract</button>
                                            <button v-else class="btn btn-primary float-right mb-1 btn-sm" :disabled="isSyncChangeOrderDisabled" :title="changeOrderTooltipText" @click.prevent="syncChangeOrderFromVista(index)">Sync From Vista</button>

                                        </template>

                                        <p class="text-right text-xs font-bold" v-if="item.vista_aco_no">Synced Vista ACO No: {{ item.vista_aco_no }}</p>
                                        <p class="text-right text-xs font-bold" v-if="item.vista_contract_id">Synced Vista Contract No: {{ item.vista_contract_id }}</p>
                                    </div>

                                    <div class="dropdown d-flex flex-column align-items-end" v-if="spectrumAccess">
                                        <button type="button"
                                                :disabled="isSpectrumSyncChangeOrderDisabled"
                                                :title="spectrumChangeOrderTooltipText"
                                                class="btn btn-primary focus:outline-none"
                                                id="spectrumOptionDropDown2" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false">
                                                Spectrum<i class="fa fa-caret-down mx-1"></i>
                                        </button>
                                        <div class="standard-dropdown dropdown-menu dropdown-menu-right" aria-labelledby="spectrumOptionDropDown2">
                                            <button type="button" class="dropdown-item py-2"
                                                :disabled="!!item.spectrum_change_request_no || item.id == 0"
                                                @click.prevent="pushChangeOrderToSpectrum(index)" >
                                                Push to Spectrum
                                            </button>
                                            <button type="button" class="dropdown-item py-2"
                                                :disabled="!item.agave_id"
                                                @click.prevent="updateChangeOrderToSpectrum(index)" >
                                                Update to Spectrum
                                            </button>
                                            <button type="button" class="dropdown-item py-2"
                                                @click.prevent="syncChangeOrderFromSpectrum(index)" >
                                                Sync From Spectrum
                                            </button>
                                        </div>
                                        <p class="text-right text-xs font-bold" v-if="item.spectrum_change_request_no">Synced Spectrum Change Request No: {{ item.spectrum_change_request_no }}</p>
                                    </div>

                                    <div class="w-3/5 float-right d-flex flex-column mb-3 align-items-end" v-if="agaveErp && agaveErp.third_party_name == 'sage-300-cre'">
                                        <button class="btn btn-primary float-right mb-1 btn-sm" data-toggle="tooltip" data-placement="top" :disabled="isSage300SyncChangeOrderDisabled" :title="sage300ChangeOrderTooltipText" @click.prevent="$refs.Sage300Project.syncSage300ChangeOrder(item)">Sync From Sage 300</button>
                                        <p class="text-right text-xs font-bold" v-if="item.agave_change_order">Synced Sage 300 Change Request No: {{ item.agave_change_order }}</p>
                                    </div>

                                    <div class="w-3/5 float-right d-flex flex-column mb-3 align-items-end" v-if="agaveErp && agaveErp.third_party_name == 'sage-100-contractor'">
                                        <button class="btn btn-primary float-right mb-1 btn-sm" data-toggle="tooltip" data-placement="top" :disabled="isSage100SyncChangeOrderDisabled" :title="sage100ChangeOrderTooltipText" @click.prevent="$refs.ProjectSageComponent.syncSage100ChangeOrder(item)">Sync From Sage 100</button>
                                        <p class="text-right text-xs font-bold" v-if="item.agave_change_order">Synced Sage 100 Change Order No: {{ item.agave_change_order }}</p>
                                    </div>

                                    <div class="w-3/5 float-right d-flex flex-column mb-3 align-items-end" v-if="foundationAccess">
                                        <button class="btn btn-primary float-right mb-1 btn-sm" data-toggle="tooltip" data-placement="top" :disabled="isFoundationSyncChangeOrderDisabled" :title="foundationChangeOrderTooltipText" @click.prevent="syncChangeOrderFromFoundation(index)">Sync From Foundation</button>
                                        <p class="text-right text-xxs font-bold" v-if="item.agave_foundation_change_order">Synced Foundation Change Order No: {{ item.agave_foundation_change_order }}</p>
                                    </div>

                                </div>
                                <div :id="`removeOrder`+index">
                                    <div class="mb-2 ml-2 leading-tight w-full row overflow-hidden row">
                                        <div class="col-10 p-0 m-0">
                                            <input type="text" v-model="item.name" class="focus:text-black focus:border-teal text-black form-control m-0 p-0 border-t-0 border-b-1 border-teal border-l-0 border-r-0 rounded-0 shadow-none" v-if="item.edit_change_order_name">
                                            <h6 class="mb-2 col-10 p-0" v-else>{{(item.name)? item.name:'Change Order '}} <span v-if="!item.name">{{index+1}}</span> </h6>
                                        </div>
                                        <div class="col-1 p-0 m-0">
                                            <span class="col-2 hover:text-teal text-right cursor-pointer" title="Edit Change Order Name" v-if="!item.edit_change_order_name"><i @click="editChangeOrderName(index)" class="material-icons">edit</i></span>
                                            <span class="col-2 hover:text-teal text-right cursor-pointer" v-else><i @click="saveChangeOrderName(index)" class="material-icons">save</i></span>
                                        </div>
                                        <div class="col-1 p-0 m-0">
                                            <span class="hover:text-red col-2 text-right cursor-pointer"><i @click="deleteOrder(index)" class="material-icons">delete</i></span>
                                        </div>
                                    </div>
                                    <div class="mb-2 ml-2 leading-tight w-full row">
                                        <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                            for="sales_status_id">{{ getFieldLabel(fieldLabels, 'sales-status')}}</label>
                                            <select name="sales_status_order" :id="`sales_status_order_`+index"
                                                v-model="item.sales_status_id"
                                                class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3 field-height-update"
                                                @change="resetChangeOrderValidations(index)">
                                            <option selected></option>
                                            <option v-for="status in selects.sales_status" :value="status.id">{{
                                                    status.full_description
                                                }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="flex flex-wrap">
                                        <div class="mb-2 ml-2 leading-tight w-full row">
                                            <label class="text-grey-darkest text-sm w-1/2 md:w-1/3" for="base_bid">Base
                                                Bid</label>
                                            <currency-input
                                                :id="`base_bid`+index"
                                                name="base_bid_amount"
                                                v-model="item.base_bid"
                                                locale="us"
                                                :currency="null"
                                                class="rounded w-1/2 md:w-2/3 p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update">
                                            </currency-input>
                                        </div>
                                        <div class="mb-2 ml-2 leading-tight w-full row">
                                            <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                                   for="contract_amount" :class="{'text-red': customErrors[`change_order_contract_amount${index}`] != null}">Contract Amount</label>
                                            <currency-input
                                                :id="`contract_amount_`+index"
                                                name="amount"
                                                v-model="item.contract_amount"
                                                locale="us"
                                                :currency="null"
                                                class="rounded w-1/2 md:w-2/3 p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update"
                                                :class="{'border-red': customErrors[`change_order_contract_amount${index}`] != null}"
                                                @input="resetChangeOrderContractAmountValidations(index, `change_order_contract_amount${index}`)">
                                            </currency-input>
                                            <div class="text-red text-xs" v-show="customErrors[`change_order_contract_amount${index}`] != null">{{ customErrors[`change_order_contract_amount${index}`] }}</div>
                                        </div>
                                        <div class="mb-2 ml-2 leading-tight w-full row">
                                            <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                                   for="contract_amount">Gross Margin %</label>
                                            <currency-input
                                                :id="`gross_margin_percentage`+index"
                                                name="amount"
                                                v-model="item.gross_margin_percentage"
                                                locale="us"
                                                :currency="null"
                                                class="rounded w-1/2 md:w-2/3 p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update">
                                            </currency-input>
                                        </div>
                                    </div>
                                    <div class="flex flex-wrap">
                                        <div class="mb-2 ml-2 leading-tight w-full row">
                                            <label class="text-grey-darkest text-sm w-1/2 md:w-1/3" :class="{'text-red': customErrors[`change_order_contract_date${index}`] != null}">Contract Date</label>
                                            <div class="w-1/2 md:w-2/3 flex">
                                                <datepicker v-model="item.contract_date" :format="masks.date_mask" :use-utc="true"
                                                            @keypress.enter.prevent="closeCalendar()"
                                                            :wrapper-class="form.contract_date ? 'w-4/5 fullscreen-when-on-mobile' : 'w-full fullscreen-when-on-mobile'"
                                                            :input-class="['cursor-pointer', 'rounded', 'w-full', 'p-1', 'text-grey-darkest', 'text-sm', 'focus:outline-none', 'border-1', 'field-height-update', {'border-red': customErrors[`change_order_contract_date${index}`] != null}]"
                                                            @selected="resetChangeOrderContractAmountValidations(index, `change_order_contract_date${index}`)">>
                                                </datepicker>
                                                <button type="button" v-if="item.contract_date" @click="change_orders[index].contract_date = ''"
                                                        class="material-icons text-grey-darkest text-xl focus:outline-none w-1/5">
                                                    clear
                                                </button>
                                            </div>
                                            <div class="text-red text-xs" v-show="customErrors[`change_order_contract_date${index}`] != null">{{ customErrors[`change_order_contract_date${index}`] }}</div>
                                        </div>
                                    </div>
                                    <div class="flex flex-wrap">
                                        <div class="mb-2 ml-2 leading-tight w-full row">
                                            <label class="text-grey-darkest text-sm w-1/2 md:w-1/3">Bid Date</label>
                                            <div class="w-1/2 md:w-2/3 flex">
                                                <datepicker v-model="item.bid_date" :format="masks.date_mask" :use-utc="true"
                                                            @keypress.enter.prevent="closeCalendar()"
                                                            :wrapper-class="form.bid_date ? 'w-4/5 fullscreen-when-on-mobile' : 'w-full fullscreen-when-on-mobile'"
                                                            :input-class="'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update'">
                                                </datepicker>
                                                <button type="button" v-if="item.bid_date" @click="change_orders[index].bid_date = ''"
                                                        class="material-icons text-grey-darkest text-xl focus:outline-none w-1/5">
                                                    clear
                                                </button>
                                            </div>
                                        </div>
                                    </div>
<!--                                    <div class="mb-2 ml-2 leading-tight w-full row" v-if="quickBookAccess">-->
<!--                                            <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"-->
<!--                                                   for="contract_amount">Cost Code</label>-->
<!--                                            <currency-input-->
<!--                                                :id="`cost_code_`+index"-->
<!--                                                name="amount"-->
<!--                                                v-model="item.cost_code"-->
<!--                                                locale="us"-->
<!--                                                :currency="null"-->
<!--                                                class="rounded w-1/2 md:w-2/3 p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update">-->
<!--                                            </currency-input>-->
<!--                                    </div>-->
                                    <div class="mb-2 ml-2 leading-tight w-full row change-order-complete-percentage-multiselect" v-if="quickBookAccess && team.quick_book_complete_percentage">
                                            <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                                   for="contract_amount">Completed %</label>
                                        <select name="complete_percentage" id="complete_percentage"
                                                v-model="item.complete_percentage"
                                                class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3 field-height-update"
                                                :id="`complete_percentage`+index"
                                                >
                                                <option selected></option>
                                                <option v-for="option in changeOrderCompletePercentages" :value="option">{{
                                                        option
                                                    }}
                                                </option>
                                        </select>
                                    </div>
                                    <!-- ------------------Change Order Custom Fields-------- -->
                                    <template v-for="custom_field in change_order_custom_fields">
                                        <div class="mb-2 ml-2 leading-tight w-full row" v-if="custom_field.type == 1 || custom_field.type == 3">
                                            <label class="text-grey-darkest text-sm w-1/2 md:w-1/3" for="sales_status_id">{{ custom_field.label_value }}</label>
                                                <select :name="custom_field.name" :id="custom_field.id"
                                                    v-model="item.custom_field_data[custom_field.id]"
                                                    class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3 field-height-update"
                                                    >
                                                <option v-for="option in custom_field.options" :value="option.id">{{ option.name }}</option>
                                            </select>
                                        </div>

                                        <div class="mb-2 ml-2 leading-tight w-full row" v-else-if="custom_field.type == 4">
                                            <label class="text-grey-darkest text-sm w-1/2 md:w-1/3">{{ custom_field.label_value }}</label>
                                            <div class="w-1/2 md:w-2/3 flex">
                                                <datepicker v-model="item.custom_field_data[custom_field.id]"
                                                            :format="masks.date_mask"
                                                            :use-utc="true"
                                                            @keypress.enter.prevent="closeCalendar()"
                                                            :wrapper-class="item.custom_field_data[custom_field.id] ? 'w-4/5 fullscreen-when-on-mobile' : 'w-full fullscreen-when-on-mobile'"
                                                            :input-class="'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update'">
                                                </datepicker>
                                                <button type="button" @click="item.custom_field_data[custom_field.id] = ''"
                                                        class="material-icons text-grey-darkest text-xl focus:outline-none w-1/5">
                                                    clear
                                                </button>
                                            </div>
                                        </div>

                                        <div class="mb-2 ml-2 leading-tight w-full row" v-else-if="custom_field.type == 2">
                                            <label class="text-grey-darkest text-sm w-1/2 md:w-1/3" for="contract_amount">{{ custom_field.label_value }}</label>
                                            <input v-model="item.custom_field_data[custom_field.id]" class="rounded w-1/2 md:w-2/3 p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update"></input>
                                        </div>

                                    </template>
                                    <!-- ------------------Change Order Custom Fields-------- -->
                                </div>
                            </span>
                            <div class="flex flex-wrap">
                                <button type="button" @click="ChangeOrder()" class="btn btn-primary" style="margin-left: 255px;">Add Change Order</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex-col w-full lg:w-1/3 lg:mx-4 my-4 my-lg-0">
                    <div class="rounded bg-white shadow-md mb-4">
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span>Project Data</span>
                        </div>
                        <div class="pt-4 pb-2 px-3">
                            <div v-if="Object.keys(fieldLabels).length > 0">
                                <div class="flex flex-wrap" style="flex-flow: column wrap;">
                                    <div v-for="label in Object.keys(fieldLabels)">
                                        <div v-if="label == 'sales-status'">
                                            <div class="mb-2 ml-2 leading-tight w-full row flex-item">
                                            <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                                :class="{'text-red' : form.errors.has('sales_status_id')}"
                                                for="sales_status_id"> {{ getFieldLabel(fieldLabels, 'sales-status')}}</label>
                                            <select name="sales_status_id" id="sales_status_id"
                                                    v-model="form.sales_status_id"
                                                    :style="{'background-color':project.status_background_color+' !important', 'border' : project.status_border_color+' 1px solid'}"
                                                    class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3 field-height-update"
                                                    :class="{'border-red': form.errors.has('sales_status_id')}"
                                                    @change="resetValidationErrors('sales_status_id')">
                                                <option selected></option>
                                                <option v-for="item in selects.sales_status" :value="item.id">{{
                                                        item.full_description
                                                    }}
                                                </option>
                                            </select>
                                            <div class="text-red text-xs" v-if="form.errors.has('sales_status_id')">{{
                                                    form.errors.get('sales_status_id')
                                                }}
                                            </div>
                                        </div>
                                        </div>
                                        <div v-if="label == 'marketing-status'">
                                            <div class="mb-2 ml-2 leading-tight w-full row flex-item">
                                            <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                                :class="{'text-red' : form.errors.has('marketing_status_id')}"
                                                for="marketing_status_id"> {{ getFieldLabel(fieldLabels, 'marketing-status')}}</label>
                                            <select name="marketing_status_id" id="marketing_status_id"
                                                    v-model="form.marketing_status_id"
                                                    class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3 field-height-update"
                                                    :class="{'border-red': form.errors.has('marketing_status_id')}"
                                                    @change="resetValidationErrors('marketing_status_id')">
                                                <option selected></option>
                                                <option v-for="item in selects.marketing_status" :value="item.id">{{
                                                        item.full_description
                                                    }}
                                                </option>
                                            </select>
                                            <div class="text-red text-xs" v-if="form.errors.has('marketing_status_id')">{{
                                                    form.errors.get('marketing_status_id')
                                                }}
                                            </div>
                                        </div>
                                        </div>
                                        <div v-if="label == 'pre-bid'">
                                            <div class="mb-2 ml-2 leading-tight w-full row flex-item">
                                            <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                                :class="{'text-red' : form.errors.has('pre_bid')}"> {{ getFieldLabel(fieldLabels, 'pre-bid')}}</label>
                                            <div class="w-1/2 md:w-2/3 flex">
                                                <datepicker
                                                    v-model="form.pre_bid"
                                                    :format="masks.date_mask"
                                                    @keypress.enter.prevent="this.closeCalendar()"
                                                    :wrapper-class="isAdmin && form.pre_bid ? 'w-4/5 fullscreen-when-on-mobile' : 'w-full fullscreen-when-on-mobile'"
                                                    :input-class="form.errors.has('pre_bid') ? 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-red field-height-update' : 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update'"
                                                    @input="resetValidationErrors('pre_bid')">
                                                </datepicker>
                                                <button type="button" v-if="isAdmin && form.pre_bid" @click="form.pre_bid = ''"
                                                        class="material-icons text-grey-darkest text-xl focus:outline-none w-1/5">
                                                    clear
                                                </button>
                                            </div>
                                            <div class="text-red text-xs" v-if="form.errors.has('pre_bid')">{{
                                                    form.errors.get('pre_bid')
                                                }}
                                            </div>
                                        </div>
                                        </div>
                                        <div v-if="label == 'bid-date'">
                                            <div class="mb-2 ml-2 leading-tight w-full row flex-item">
                                            <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                                :class="{'text-red' : form.errors.has('bid_date')}">{{ getFieldLabel(fieldLabels, 'bid-date')}}</label>
                                            <div class="w-1/2 md:w-2/3 flex">
                                                <datepicker v-model="form.bid_date" :format="masks.date_mask"
                                                            @keypress.enter.prevent="closeCalendar()"
                                                            :use-utc="true"
                                                            :wrapper-class="isAdmin && form.bid_date ? 'w-4/5 fullscreen-when-on-mobile' : 'w-full fullscreen-when-on-mobile'"
                                                            :input-class="form.errors.has('bid_date') ? 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-red field-height-update' : 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update'"
                                                            @input="resetValidationErrors('bid_date')"></datepicker>
                                                <button type="button" v-if="isAdmin && form.bid_date" @click="form.bid_date = ''"
                                                        class="material-icons text-grey-darkest text-xl focus:outline-none w-1/5">
                                                    clear
                                                </button>
                                            </div>

                                            <div class="text-red text-xs" v-if="form.errors.has('bid_date')">{{
                                                    form.errors.get('bid_date')
                                                }}
                                            </div>
                                        </div>
                                        </div>
                                        <div v-if="label == 'lead-source'">
                                            <div class="mb-2 ml-2 leading-tight w-full row flex-item">
                                            <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                                :class="{'text-red' : form.errors.has('lead_from_id')}" for="lead_from_id">{{ getFieldLabel(fieldLabels, 'lead-source')}}</label>
                                            <select name="lead_from_id" id="lead_from_id"
                                                    v-model="form.lead_from_id"
                                                    class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3 field-height-update"
                                                    :class="{'border-red': form.errors.has('lead_from_id')}"
                                                    @change="resetValidationErrors('lead_from_id')">
                                                <option selected></option>
                                                <option v-for="item in selects.lead_from" :value="item.id">{{
                                                        item.full_description
                                                    }}
                                                </option>
                                            </select>
                                            <div class="text-red text-xs" v-if="form.errors.has('lead_from_id')">{{
                                                    form.errors.get('lead_from_id')
                                                }}
                                            </div>
                                        </div>
                                        </div>
                                        <div v-if="label == 'estimator'">
                                            <div class="mb-2 ml-2 leading-tight w-full row flex-item">
                                            <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                                :class="{'text-red' : form.errors.has('estimator_id')}" for="estimator_id">{{ getFieldLabel(fieldLabels, 'estimator')}}</label>
                                            <select name="estimator_id" id="estimator_id"
                                                    v-model="form.estimator_id"
                                                    class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3 field-height-update"
                                                    :class="[(form.errors.has('estimator_id') ? 'border-red' : '')]"
                                                    @change="resetValidationErrors('estimator_id')">
                                                <option selected></option>
                                                <option v-for="item in selects.all_users" v-if="item.id === form.estimator_id || item.pivot.active" :value="item.id" :disabled="!item.pivot.active">
                                                    {{ item.pivot.active ? item.name : item.name + ' - Inactive' }}
                                                </option>
                                            </select>

                                            <div class="text-red text-xs" v-if="form.errors.has('estimator_id')">{{
                                                    form.errors.get('estimator_id')
                                                }}
                                            </div>
                                        </div>
                                        </div>
                                        <div v-if=" label =='account-manager'">
                                            <div class="mb-2 ml-2 leading-tight w-full row flex-item">
                                            <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                                :class="{'text-red' : form.errors.has('account_manager_id')}"
                                                for="account_manager_id">{{ getFieldLabel(fieldLabels,'account-manager')}}</label>
                                            <select name="account_manager_id" id="account_manager_id"
                                                    v-model="form.account_manager_id"
                                                    class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3 field-height-update"
                                                    :class="[(form.errors.has('account_manager_id') ? 'border-red' : '')]"
                                                    @change="resetValidationErrors('account_manager_id')">
                                                <option selected></option>
                                                <option v-for="item in selects.all_users" v-if="item.id === form.account_manager_id || item.pivot.active" :value="item.id" :disabled="!item.pivot.active">
                                                    {{ item.pivot.active ? item.name : item.name + ' - Inactive' }}
                                                </option>
                                            </select>
                                            <div class="text-red text-xs" v-if="form.errors.has('account_manager_id')">{{
                                                    form.errors.get('account_manager_id')
                                                }}
                                            </div>
                                        </div>
                                        </div>
                                        <div v-if="label == 'take-off-person'">
                                            <div class="mb-2 ml-2 leading-tight w-full row flex-item">
                                            <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                                :class="{'text-red' : form.errors.has('take_off_person_id')}"
                                                for="take_off_person_id"> {{ getFieldLabel(fieldLabels,'take-off-person')}}</label>
                                            <select name="take_off_person_id" id="take_off_person_id"
                                                    v-model="form.take_off_person_id"
                                                    class="appearance-none bg-white border-1 focus:outline-none p-1 rounded text-grey-darkest text-sm w-1/2 md:w-2/3 field-height-update"
                                                    :class="[(form.errors.has('take_off_person_id') ? 'border-red' : '')]"
                                                    @change="resetValidationErrors('take_off_person_id')">
                                                <option selected></option>
                                                <option v-for="item in selects.all_users" v-if="item.id === form.take_off_person_id || item.pivot.active" :value="item.id" :disabled="!item.pivot.active">
                                                    {{ item.pivot.active ? item.name : item.name + ' - Inactive' }}
                                                </option>
                                            </select>
                                            <div class="text-red text-xs" v-if="form.errors.has('take_off_person_id')">{{
                                                    form.errors.get('take_off_person_id')
                                                }}
                                            </div>
                                        </div>
                                        </div>
                                        <div v-if="label == 'products-and-services'">
                                            <div class="mb-2 ml-2 leading-tight w-full row flex-item">
                                            <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                                :class="{'text-red' : form.errors.has('products_and_services_id')}"
                                                for="products_and_services_id">{{ getFieldLabel(fieldLabels,'products-and-services')}}</label>
                                            <select name="products_and_services_id" id="products_and_services_id"
                                                    v-model="form.products_and_services_id"
                                                    class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3 field-height-update"
                                                    :class="{'border-red': form.errors.has('products_and_services_id')}"
                                                    @change="resetValidationErrors('products_and_services_id')">
                                                <option selected></option>
                                                <option v-for="item in selects.products_and_services" :value="item.id">{{
                                                        item.full_description
                                                    }}
                                                </option>
                                            </select>
                                            <div class="text-red text-xs" v-if="form.errors.has('products_and_services_id')">{{
                                                    form.errors.get('products_and_services_id')
                                                }}
                                            </div>
                                        </div>
                                        </div>
                                        <div v-if="label == 'client-profile'">
                                            <div class="mb-2 ml-2 leading-tight w-full row flex-item">
                                            <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                                :class="{'text-red' : form.errors.has('client_profile_id')}"
                                                for="client_profile_id"> {{ getFieldLabel(fieldLabels,'client-profile')}}</label>
                                            <select name="client_profile_id" id="client_profile_id"
                                                    v-model="form.client_profile_id"
                                                    class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3 field-height-update"
                                                    :class="{'border-red': form.errors.has('client_profile_id')}"
                                                    @change="resetValidationErrors('client_profile_id')">
                                                <option selected></option>
                                                <option v-for="item in selects.client_profile" :value="item.id">{{
                                                        item.full_description
                                                    }}
                                                </option>
                                            </select>
                                            <div class="text-red text-xs" v-if="form.errors.has('client_profile_id')">{{
                                                    form.errors.get('client_profile_id')
                                                }}
                                            </div>
                                        </div>
                                        </div>
                                        <div v-if="label == 'contract-type'">
                                            <div class="mb-2 ml-2 leading-tight w-full row flex-item"  >
                                            <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                                :class="{'text-red' : form.errors.has('contract_type_id')}"
                                                for="contract_type_id">{{ getFieldLabel(fieldLabels,'contract-type')}}</label>
                                            <select name="contract_type_id" id="contract_type_id"
                                                    v-model="form.contract_type_id"
                                                    class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3 field-height-update"
                                                    :class="{'border-red': form.errors.has('contract_type_id')}"
                                                    @change="resetValidationErrors('contract_type_id')">
                                                <option selected></option>
                                                <option v-for="item in selects.contract_type" :value="item.id">{{
                                                        item.full_description
                                                    }}
                                                </option>
                                            </select>
                                            <div class="text-red text-xs" v-if="form.errors.has('contract_type_id')">{{
                                                    form.errors.get('contract_type_id')
                                                }}
                                            </div>
                                        </div>
                                        </div>
                                        <div v-if=" label =='office'">
                                            <div class="mb-2 ml-2 leading-tight w-full row flex-item">
                                            <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                                :class="{'text-red' : form.errors.has('office_id')}"
                                                for="office_id">{{ getFieldLabel(fieldLabels,'office')}}</label>
                                            <select name="office_id" id="office_id"
                                                    v-model="form.office_id"
                                                    class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3 field-height-update"
                                                    :class="{'border-red': form.errors.has('office_id')}"
                                                    @change="resetValidationErrors('office_id')">
                                                <option selected></option>
                                                <option v-for="item in selects.office" :value="item.id">{{
                                                        item.full_description
                                                    }}
                                                </option>
                                            </select>
                                            <div class="text-red text-xs" v-if="form.errors.has('office_id')">{{
                                                    form.errors.get('office_id')
                                                }}
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <project-custom-fields ref="CustomFields" :project="project"  @change-custom-field="changeCustomField" :customFieldErrors="form.errors" :selects="selects" :salesStatusId="form.sales_status_id" :masks="masks" :foundationContactSyncAccess="foundationContactSyncAccess" :foundationAutoGeneratedAccess="foundationAutoGeneratedAccess" status="update" v-on:custom-field-response="projectCustomFieldResponse"  :vista-job-number-custom-field-id="vistaJobNumberCustomFieldId" @vista-job-number-changed="vistaJobNumberChanged" :vista-access="vistaAccess" :sage-job-number-custom-field-id="sageJobNumberCustomFieldId" :sage-access="sageAccess" :sage-project-mapping="sageProjectMapping" :agave-erp="agaveErp"
                                                       :spectrum-job-number-custom-field-id="spectrumJobNumberCustomFieldId" @spectrum-job-number-changed="spectrumJobNumberChanged" :spectrum-access="spectrumAccess" :spectrum-project-mapping="spectrumProjectMapping" :is-spectrum-set-to-auto-generate="isSpectrumSetToAutoGenerate" :foundationJobNumberCustomFieldId="foundationJobNumberCustomFieldId" :foundationAccess="foundationAccess" :foundationProjectMapping="foundationProjectMapping" @foundationJobNumberChanged="foundationJobNumberChanged" :team="team">
                                </project-custom-fields>
                            </div>
                        </div>
                    </div>
                    <div v-if="hasEstimatingAccess" class="rounded bg-white shadow-md mb-4">
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span>The EDGE™ Estimator</span>
                            <a :href="this.edgeEstimateUrl" class="right" target="_blank" v-if="project.has_bid_id && project.has_tenant_id"><i class="fa fa-external-link-square" style="color:#FFFFFF;float: right;margin-top: 5px;" aria-hidden="true"></i></a>
                        </div>
                        <div class="pt-4 pb-2 px-3 mb-2">
                            <multiselect
                                :options="estimates"
                                label="title"
                                v-model="selectedEstimate"
                                class="mb-2"
                                @input="getGrossMarginPercentage"
                            >

                            </multiselect>

                            <div class="mb-2 ml-2 leading-tight w-full row">
                                <label
                                    class="text-grey-darkest text-sm w-1/5 p-0 m-0 flex items-center w-2/5 md:w-2/5 lg:w-2/5 xl:w-1/3"
                                >
                                    Gross Price
                                </label>
                                <div class="w-2/5 md:w-3/5 lg:w-2/5 xl:w-2/3">
                                    <currency-input
                                        id="gross_price"
                                        :value="selectedEstimate ? selectedEstimate.gross_price : 0.00"
                                        locale="us"
                                        :currency="null"
                                        disabled
                                        class="rounded p-2 text-grey-darkest text-sm focus:outline-none border-1 w-full field-height-update">
                                    </currency-input>
<!--                                    <input
                                        :value="selectedEstimate ? parseFloat(selectedEstimate.gross_price).toFixed(2) : ''"
                                        type="text"
                                        class="rounded p-2 text-grey-darkest text-sm focus:outline-none border-1 w-full"
                                        disabled
                                    >-->
                                </div>
                            </div>
                            <div class="mb-2 ml-2 leading-tight w-full row">
                                <label
                                    class="text-grey-darkest text-sm w-1/5 p-0 m-0 flex items-center w-2/5 md:w-2/5 lg:w-2/5 xl:w-1/3"
                                >
                                    Net Cost
                                </label>
                                <div class="w-2/5 md:w-3/5 lg:w-2/5 xl:w-2/3">
                                    <currency-input
                                        id="net_cost"
                                        :value="selectedEstimate ? selectedEstimate.net_cost : 0.00"
                                        locale="us"
                                        :currency="null"
                                        disabled
                                        class="rounded p-2 text-grey-darkest text-sm focus:outline-none border-1 w-full field-height-update">
                                    </currency-input>
<!--                                    <input
                                        :value="selectedEstimate ? Number(parseFloat(selectedEstimate.net_cost).toFixed(2)) : ''"
                                        type="text"
                                        class="rounded p-2 text-grey-darkest text-sm focus:outline-none border-1 w-full"
                                        disabled
                                    >-->
                                </div>
                            </div>
                            <div class="mb-2 ml-2 leading-tight w-full row">
                                <label
                                    class="text-grey-darkest text-sm w-1/5 p-0 m-0 flex items-center w-2/5 md:w-2/5 lg:w-2/5 xl:w-1/3"
                                >
                                    Selling Price
                                </label>
                                <div class="w-2/5 md:w-3/5 lg:w-2/5 xl:w-2/3">
                                    <currency-input
                                        id="selling_price"
                                        :value="selectedEstimate ? selectedEstimate.selling_price : 0.00"
                                        locale="us"
                                        :currency="null"
                                        disabled
                                        class="rounded p-2 text-grey-darkest text-sm focus:outline-none border-1 w-full field-height-update">
                                    </currency-input>
<!--                                    <input
                                        :value="selectedEstimate ? Number(parseFloat(selectedEstimate.selling_price).toFixed(2)) : ''"
                                        type="text"
                                        class="rounded p-2 text-grey-darkest text-sm focus:outline-none border-1 w-full"
                                        disabled
                                    >-->
                                </div>
                            </div>
                            <div class="mb-2 ml-2 leading-tight w-full row">
                                <label
                                    class="text-grey-darkest text-sm w-1/5 p-0 m-0 flex items-center w-2/5 md:w-2/5 lg:w-2/5 xl:w-1/3"
                                >
                                    Scenario Type
                                </label>
                                <div class="w-2/5 md:w-3/5 lg:w-2/5 xl:w-2/3">
                                    <input
                                        :value="selectedEstimate ? selectedEstimate.scenario_type : ''"
                                        type="text"
                                        class="rounded p-2 text-grey-darkest text-sm focus:outline-none border-1 w-full field-height-update"
                                        disabled
                                    >
                                </div>
                            </div>
                            <div class="mb-2 ml-2 leading-tight w-full row">
                                <label
                                    class="text-grey-darkest text-sm w-1/5 p-0 m-0 flex items-center w-2/5 md:w-2/5 lg:w-2/5 xl:w-1/3"
                                >
                                    Per Hour
                                </label>
                                <div class="w-2/5 md:w-3/5 lg:w-2/5 xl:w-2/3">
                                    <input
                                        :value="selectedEstimate ? Number(parseFloat(selectedEstimate.per_hour).toFixed(2)) : 0.0"
                                        type="text"
                                        class="rounded p-2 text-grey-darkest text-sm focus:outline-none border-1 w-full field-height-update"
                                        disabled
                                    >
                                </div>
                            </div>
                            <div class="mb-2 ml-2 leading-tight w-full row">
                                <label
                                    class="text-grey-darkest text-sm w-1/5 p-0 m-0 flex items-center w-2/5 md:w-2/5 lg:w-2/5 xl:w-1/3"
                                >
                                    Per Manday
                                </label>
                                <div class="w-2/5 md:w-3/5 lg:w-2/5 xl:w-2/3">
                                    <input
                                        :value="selectedEstimate ? Number(parseFloat(selectedEstimate.per_manDay).toFixed(2)) : 0.0"
                                        type="text"
                                        class="rounded p-2 text-grey-darkest text-sm focus:outline-none border-1 w-full field-height-update"
                                        disabled
                                    >
                                </div>
                            </div>
                            <div class="mb-2 ml-2 leading-tight w-full row">
                                <label
                                    class="text-grey-darkest text-sm w-1/5 p-0 m-0 flex items-center w-2/5 md:w-2/5 lg:w-2/5 xl:w-1/3"
                                >
                                    Per Crewday
                                </label>
                                <div class="w-2/5 md:w-3/5 lg:w-2/5 xl:w-2/3">
                                    <input
                                        :value="selectedEstimate ? Number(parseFloat(selectedEstimate.per_crewday).toFixed(2)) : 0.0"
                                        type="text"
                                        class="rounded p-2 text-grey-darkest text-sm focus:outline-none border-1 w-full field-height-update"
                                        disabled
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="hasProposalGeneratorAccess" class="rounded bg-white shadow-md">
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span>Proposals</span>
                        </div>
                        <div class="py-4 px-2">
                            <div v-if="project.proposals.length === 0" class="text-grey-darkest text-sm">There are no
                                proposals to show.
                            </div>
                            <div v-for="proposal in proposalData"
                                 class="flex justify-between px-1 py-3 hover:bg-grey-lighter pointer" :id="'proposal-single-div-'+proposal.id">
                                <div class="text-grey-darkest text-sm p-name" :title="proposal.name" :class="(proposal.signed_at)? 'proposal-name-list-disabled':''"><input @blur="updateProposalName(proposal.id)" :disabled="proposal.signed_at ? true:false" type="text" v-model="proposal.name" class="proposal-name-list" :id="'proposal'+proposal.id"></div>
                                <div v-if="proposal.sent_for_signing_at" :id="'proposal-view-'+proposal.id">
                                    <button  type="button" @click.prevent="editProposal(proposal)"
                                             class="btn btn-sm btn-outline-primary rounded-full signed-div-button" :id="'proposal-view-button'+proposal.id">
                                        View
                                    </button>
                                    <button v-if="proposal.signed_at"  type="button" @click.prevent="showSignInformation(proposal.id)"
                                             class="btn btn-sm btn-outline-info rounded-full signed-div-button" :id="'proposal-view-button'+proposal.id">
                                        Signature Timestamp
                                    </button>
                                    <button v-else  type="button" @click.prevent="showSignInformation(proposal.id)"
                                            class="btn btn-sm btn-outline-info rounded-full signed-div-button" :id="'proposal-view-button'+proposal.id">
                                        Sending Timestamp
                                    </button>
                                </div>
                                <div v-else>
                                    <button type="button" @click.prevent="deleteProposal(proposal)"
                                            class="btn btn-sm btn-outline-danger rounded-full">
                                        Delete
                                    </button>
                                    <button type="button" @click.prevent="editProposal(proposal)"
                                            class="btn btn-sm btn-outline-primary rounded-full">
                                        Edit
                                    </button>
                                </div>
                                <div v-if="proposal.signed_at"  class="text-grey-darkest text-sm signed-div" @click="showViewButton(proposal.id)" :id="'proposal-sign-info-'+proposal.id">Signed: {{ (proposal.signed_time)? proposalSignedTime(proposal.signed_at,proposal.signed_time):'' }}
                                    <br>
                                    <span style="color: #999;">Signer Ip: {{(proposal.signer_ip)? proposal.signer_ip:''}}</span>
                                </div>
                                <div v-else  class="text-grey-darkest text-sm signed-div" @click="showViewButton(proposal.id)" :id="'proposal-sign-info-'+proposal.id">Sent: {{ (proposal.sent_for_signing_at)? proposalSenderTime(proposal.sent_for_signing_at):'' }}
                                    <br>
                                    <span style="color: #999;">Sender Ip: {{(proposal.sender_ip)? proposal.sender_ip:''}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex-col hidden lg:inline lg:w-1/3">
                    <div class="rounded bg-white shadow-md mb-4">
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span>Sales Activities</span>
                        </div>
                        <div class="pt-4 pb-2 px-3">
                            <div v-if="form.sales_behaviors.length > 0" v-for="(item, index) in form.sales_behaviors"
                                 class="flex mb-2 inline-block" :key="index">
                                <div v-if="atLeastOneHasDate" class="col-1 px-1 flex items-center">
                                    <input v-if="(item.date && typeof item.date === 'string') && !item.follow_up"
                                           type="checkbox"
                                           id=""
                                           name=""
                                           true-value="1"
                                           false-value="0"
                                           class="sales-behavior-checkbox"
                                           :use-utc="true"
                                           :disabled="checked_proposal_delivered === item.id || checkIfLockableActivity(item.id)"
                                           @change="checkIsProposalDelivered(item);checkIsSalesActivityCompleted(item);"
                                           v-model="item.completed"
                                    />
                                </div>
                                <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center"
                                       :class="(form.errors.has(item.name)) ? 'text-red col-6' : atLeastOneHasDate ? 'col-5' : 'col-6'">{{ item.name }}:</label>
                                <div v-show="hasCalendarAccess==false" class="flex px-1"
                                     :class="atLeastOneHasDate ? 'col-5' : 'col-6'">
                                    <datepicker v-model="item.date"
                                                @keypress.enter.prevent="closeCalendar()"
                                                :ref=item.name
                                                :disabled="checked_proposal_delivered === item.id"
                                                :format="masks.date_mask"
                                                :use-utc="true"
                                                :week-start="7"
                                                :wrapper-class="item.date && checked_proposal_delivered !== item.id ? 'fullscreen-when-on-mobile w-4/5' : 'fullscreen-when-on-mobile w-full'"
                                                :input-class="form.errors.has(item.name) ? 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-red field-height-update' : 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update'">
                                    </datepicker>
                                    <button type="button" v-if="item.date && checked_proposal_delivered !== item.id"
                                            @click="removeDate(item.name, index)"
                                            class="material-icons text-grey-darkest text-xl focus:outline-none">clear
                                    </button>
                                </div>
                                <div v-show="hasCalendarAccess" class="flex px-1"
                                     :class="atLeastOneHasDate ? 'col-5' : 'col-6'">
<!--                                    <datetime v-if="item.end_date" type="datetime" name="date"
                                              v-model="item.end_date" use12-hour
                                              :ref=item.name
                                              :disabled="checked_proposal_delivered === item.id"
                                              class="w-full"
                                              :week-start="7"
                                              :format="masks.date_time_mask"
                                              :minute-step="15"
                                              :input-class="form.errors.has(item.name) ? 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-red field-height-update' : 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update'"
                                              @input="form.errors.clear('start_date'); resetValidationErrors(item.name);">
                                    </datetime>-->
                                    <projectDatetime v-if="item.end_date" type="datetime"
                                                     name="date" :id="`datetime-${index}`"
                                                     v-model="item.end_date" use12-hour
                                                     :ref="`datepicker-${index}`"
                                                     autofill="off"
                                                     class="w-full"
                                                     :week-start="7"
                                                     :format="masks.date_time_mask"
                                                     :use-utc="true"
                                                     :minute-step="15"
                                                     :input-class="form.errors.has(item.name) ? 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-red' : 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1'"
                                                     @input="form.errors.clear('start_date'); resetValidationErrors(item.name);">
                                    </projectDatetime>

<!--                                    <datetime v-if="!item.end_date" type="datetime" name="date"
                                              v-model="item.date" use12-hour
                                              :ref=item.name
                                              :disabled="checked_proposal_delivered === item.id"
                                              class="w-full"
                                              :week-start="7"
                                              :format="masks.date_time_mask"
                                              :minute-step="15"
                                              :input-class="form.errors.has(item.name) ? 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-red field-height-update' : 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update'"
                                              @input="form.errors.clear('start_date'); resetValidationErrors(item.name);">
                                    </datetime>-->
                                    <projectDatetime v-if="!item.end_date" type="datetime"
                                                     name="date" :id="`datetime-${index}`"
                                                     v-model="item.date" use12-hour
                                                     :ref="`datepicker-${index}`"
                                                     autofill="off"
                                                     class="w-full"
                                                     :week-start="7"
                                                     :format="masks.date_time_mask"
                                                     :use-utc="true"
                                                     :minute-step="15"
                                                     :input-class="form.errors.has(item.name) ? 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-red' : 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1'"
                                                     @input="form.errors.clear('start_date'); resetValidationErrors(item.name);">
                                    </projectDatetime>
                                    <button type="button" v-if="(item.date  &&  typeof item.date === 'string') && checked_proposal_delivered !== item.id"
                                            @click="removeDateTimePicker(index)"
                                            class="material-icons text-grey-darkest text-xl focus:outline-none">clear
                                    </button>
                                </div>

                                <div class="text-teal cursor-pointer flex justify-center items-center col-1 px-1"
                                     @click.prevent.stop="openEmailModal(item,form.name)">
                                    <i v-if="item.date  &&  typeof item.date === 'string'" class="fa fa-calendar"></i>
                                </div>
                            </div>
                            <div v-if="form.sales_behaviors.length === 0" class="mb-2">
                                <div class="text-grey-darkest text-sm">
                                    Your company does not currently have any sales behaviors.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="hail-impact" class="rounded bg-white shadow-md" v-if="hailReconAccess">
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span>Hail Recon</span>
                        </div>
                        <div class="pt-4 pb-2 px-3">
                            <div class="flex flex-wrap">
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('hail_impact')}" for="hail_impact">
                                        Hail Impact
                                    </label>
                                    <input type="text"
                                           id="hail_impact"
                                           v-model="form.hail_impact"
                                           locale="us"
                                           :currency="null"
                                           class="rounded w-1/2 md:w-2/3 p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update"
                                           :class="{'border-red': form.errors.has('hail_impact')}">
                                    <div class="text-red text-xs" v-if="form.errors.has('hail_impact')">{{
                                            form.errors.get('hail_impact')
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="rounded bg-white shadow-md mb-4" id="externalEmailSectionDiv">
                <external-email-section :project="project" :email="form.contact_email" :canEdit="canEdit" :allContacts="allContacts" :exchange="exchange"
                                        @refresh-comments="fetchCommentsRecursive()" :hasSequencesAccess="hasSequencesAccess" :externalEmailService="externalEmailService"
                                        :change-order-key="changeOrderKey" :change-orders="project.change_orders" :quick-book-access="quickBookAccess" ref="ExternalEmailSectionReference"
                                        :team="team"
                                        :sales-activities="this.selects.sales_activities"
                                        :field-labels="this.fieldLabels"
                                        :project-data-field-visibility="projectDataFieldVisibility"
                >
                </external-email-section>
            </div>

            <div class="rounded bg-white shadow-md mb-4">
                <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                    <span>Company Information</span>
                </div>

                <company-information
                    ref="ProjectCompanyInformation"
                    :project="project"
                    :errors="form.errors"
                    :masks="masks"
                    :usersForContact="usersForContact"
                    :allContactTypes="all_contact_types"
                    :foundationCustomerAccess="foundationCustomerAccess"
                    :sageIntacctContactSyncAccess="sageIntacctContactSyncAccess"
                    :foundationContactSyncedErrorMsg="foundationContactSyncedErrorMsg"
                    :sageIntacctContactSyncedErrorMsg="sageIntacctContactSyncedErrorMsg"
                    :foundationContactSyncAccess="foundationContactSyncAccess"
                    :sectionType="'projectEdit'"
                    :resetValidationErrors="resetValidationErrors"
                    :symbols="symbols"
                    :canEdit="canEdit"
                    :addComment="addComment"
                    @companyAddCheck="companyAddCheck"
                    :companyContactIds="companyContactIds"
                    :team="team"
                    :mailSubject="mailSubject"
                    :companyWonStatusRequired="companyWonStatusRequired"
                    :fieldLabels="fieldLabels"
                    :teamResidentialContactType="teamResidentialContactType"
                    :canCreateCompany="canCreateCompany"
                ></company-information>

<!--                <div class="py-4 px-3 flex flex-wrap flex-lg-nowrap items-stretch ">-->
<!--                    <div class="flex-col w-full lg:w-1/3 pr-4">-->
<!--                        <div class="mb-1 text-grey-darkest text-sm">To add a contact, first pick a company</div>-->
<!--                        <div class="mb-4 leading-tight">-->
<!--                            <multiselect-->
<!--                                id="companies"-->
<!--                                v-model="selectedCompany"-->
<!--                                @input="fetchContacts"-->
<!--                                :options="allCompanies"-->
<!--                                :multiple="false"-->
<!--                                :close-on-select="true"-->
<!--                                :clear-on-select="false"-->
<!--                                :preserve-search="false"-->
<!--                                :taggable="true"-->
<!--                                open-direction="below"-->
<!--                                placeholder="Pick a company"-->
<!--                                tag-placeholder="Add this company"-->
<!--                                :showLabels="false"-->
<!--                                label="name"-->
<!--                                track-by="id"-->
<!--                                @tag="openCompanyCreateModal"-->
<!--                                :preselect-first="false"-->
<!--                                :class="form.errors.has('company_contacts') ? 'required-field-color' : ''">-->
<!--                            </multiselect>-->
<!--                            <div class="text-red text-xs" v-if="form.errors.has('company_contacts')">{{-->
<!--                                form.errors.get('company_contacts')}}-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div v-if="selectedCompany">-->
<!--                            <div class="flex justify-content-between pb-4">-->
<!--                                <div class="mb-1 text-grey-darkest text-sm">Now add contacts to the current project-->
<!--                                </div>-->
<!--                                <button v-if="canEdit && selectedCompany" type="button" @click.prevent.stop="addNewContact()"-->
<!--                                        class="cursor-pointer border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:text-white p-2 rounded-full text-base text-followup-nav">-->
<!--                                    New Contact-->
<!--                                </button>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div v-if="contacts.length > 0">-->

<!--                            <div class="leading-tight">-->
<!--                                <div @click.prevent.stop="addOrRemoveContact(contact);resetCompanyContactStatusValidation();" v-for="contact in contacts"-->
<!--                                     class="p-2 hover:bg-grey-lighter flex justify-between items-center rounded cursor-pointer">-->
<!--                                    <div class="flex-col items-baseline">-->
<!--                                        <div class="font-medium mr-3 text-base text-grey-darkest">{{ contact.name }}-->
<!--                                        </div>-->
<!--                                        <div class="text-sm text-grey-darkest">-->
<!--                                            {{-->
<!--                                                contact.cell ? symbols.currency_name == 'Dollars' ? contact.cell.replace(/^(\d{3})(\d{3})(\d{4}).*/, '($1) $2-$3') : contact.cell.replace(/[^\d]/g, "") : ''-->
<!--                                            }}-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                    <button type="button" v-if="!contactAddedAlready(contact) && canEdit"-->
<!--                                            @click.prevent.stop="addOrRemoveContact(contact);resetCompanyContactStatusValidation();"-->
<!--                                            class="cursor-pointer border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:text-white material-icons p-1 rounded-full text-base text-followup-nav">-->
<!--                                        add-->
<!--                                    </button>-->
<!--                                    <span v-else-if="canEdit" @click.prevent.stop="addOrRemoveContact(contact);resetCompanyContactStatusValidation();"-->
<!--                                          class="cursor-pointer border-2 border-red focus:outline-none font-semibold hover:bg-red hover:text-white material-icons p-1 rounded-full text-base text-red">-->
<!--                                        close-->
<!--                                    </span>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="hidden lg:flex border-1 border-grey mr-4"></div>-->
<!--                    <div class="flex-1">-->
<!--                        <hr class="lg:hidden">-->
<!--                        <table class="w-full">-->
<!--                            <thead>-->
<!--                            <tr>-->
<!--                                <th v-if="foundationContactSyncAccess" class="pb-2 pl-2 font-medium uppercase text-xs text-grey-darkest border-b border-grey-light">Foundation Sync</th>-->
<!--                                <th v-if="sageIntacctContactSyncAccess" class="pb-2 pl-2 font-medium uppercase text-xs text-grey-darkest border-b border-grey-light">Sage Intacct Sync</th>-->
<!--                                <th class="pb-2 pl-2 font-medium uppercase text-xs text-grey-darkest border-b border-grey-light">-->
<!--                                    Company Name-->
<!--                                </th>-->
<!--                                <th class="pb-2 font-medium uppercase text-xs text-grey-darkest border-b border-grey-light">-->
<!--                                    Contact Name-->
<!--                                </th>-->
<!--                                <th class="pb-2 font-medium uppercase text-xs text-grey-darkest border-b border-grey-light hidden lg:table-cell">-->
<!--                                    Email/Phone-->
<!--                                </th>-->
<!--                                <th class="pb-2 font-medium uppercase text-xs text-grey-darkest border-b border-grey-light hidden xl:table-cell">-->
<!--                                    Follow Up-->
<!--                                </th>-->
<!--                                <th class="pb-2 font-medium uppercase text-xs text-grey-darkest border-b border-grey-light hidden xl:table-cell">-->
<!--                                    Status-->
<!--                                </th>-->
<!--                                <th class="pb-2 hidden xl:table-cell"></th>-->
<!--                            </tr>-->
<!--                            </thead>-->
<!--                            <tbody>-->
<!--                            <tr v-for="(contact, index) in form.company_contacts"-->
<!--                                class="hover:bg-grey-lighter rounded hidden xl:table-row"-->
<!--                                :class="companyContactIds.includes(contact.id) ? 'required-field-color' : ''">-->
<!--                                <td v-if="foundationCustomerAccess" class="text-center">-->
<!--                                    <input v-if="contact.foundation_customer_no"-->
<!--                                           type="radio"-->
<!--                                           v-model="form.foundationContactSelectedContact"-->
<!--                                           :value="contact.id"-->
<!--                                           :name="'contact' + contact.id"-->
<!--                                           :key="contact.id">-->
<!--                                    <button type="button" v-else @click="contactPushToFoundation(contact)" class="cursor-pointer border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:text-white px-1 py-2 rounded-full text-base text-followup-nav" style="font-size: 11px">-->
<!--                                        <i :class="'fa fa-spin fa-spinner text-grey-darkest push-to-foundation-loader-' + contact.id" aria-hidden="true" style="display: none;"></i>-->
<!--                                        Push To Foundation-->
<!--                                    </button>-->
<!--                                </td>-->
<!--                                <td v-if="sageIntacctContactSyncAccess" class="text-center">-->
<!--                                    <input v-if="contact.sage_intacct_customer_no"-->
<!--                                           type="radio"-->
<!--                                           v-model="form.sageIntacctContactSelectedContact"-->
<!--                                           :value="contact.id"-->
<!--                                           :name="'contact' + contact.id"-->
<!--                                           :key="contact.id">-->
<!--                                    <button type="button" v-else @click="contactPushToSageIntacct(contact)" class="cursor-pointer border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:text-white px-1 py-2 rounded-full text-base text-followup-nav" style="font-size: 11px">-->
<!--                                        <i :class="'fa fa-spin fa-spinner text-grey-darkest push-to-foundation-loader-' + contact.id" aria-hidden="true" style="display: none;"></i>-->
<!--                                        Push To Sage Intacct-->
<!--                                    </button>-->
<!--                                </td>-->
<!--                                <td class="pl-2 text-sm text-grey-darkest cursor-pointer"-->
<!--                                    @click.prevent.stop="contact.company.is_residential ? goToContact(contact.company, contact) : goToCompany(contact.company)">-->
<!--                                    <div>-->
<!--                                        {{ contact.company.name }}-->
<!--                                    </div>-->
<!--                                    <div>-->
<!--                                        {{-->
<!--                                            contact.company.phone ?-->
<!--                                               symbols.currency_name == 'Dollars' ? contact.company.phone.replace(/^(\d{3})(\d{3})(\d{4}).*/, '($1) $2-$3') : contact.company.phone.replace(/[^\d]/g, "") : ''-->
<!--                                        }}-->
<!--                                    </div>-->
<!--                                </td>-->
<!--                                <td class="text-sm text-grey-darkest cursor-pointer"-->
<!--                                    @click.prevent.stop="goToContact(contact.company, contact)">-->
<!--                                    {{ contact.name }}, {{ contact.title }} <img v-if="contact.is_connected_as_quick_book_contact && team.is_quick_book_connected" class="qb-small-logo-project" src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/qb-logo-small.png">-->
<!--                                </td>-->
<!--                                <td class="text-sm font-light text-grey-darkest">-->
<!--                                    <div class="flex-col">-->
<!--                                        <div><a :href="'mailto:'+contact.email+mailSubject"-->
<!--                                                class="text-grey-darkest hover:text-grey-darkest">{{-->
<!--                                                contact.email-->
<!--                                            }}</a></div>-->
<!--                                        <div>-->
<!--                                            <a :href="`tel:${contact.cell}`"-->
<!--                                               class="text-grey-darkest hover:text-grey-darkest">-->
<!--                                                {{-->
<!--                                                    contact.cell ? symbols.currency_name == 'Dollars' ? contact.cell.replace(/^(\d{3})(\d{3})(\d{4}).*/, '($1) $2-$3') :contact.cell.replace(/[^\d]/g, "") : ''-->
<!--                                                }}-->
<!--                                            </a>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </td>-->
<!--                                <td class="text-sm text-grey-darkest flex pt-2 text-sm">-->
<!--                                        <datetime type="datetime" id="date" name="date" v-model="contact.date" use12-hour-->
<!--                                              :format="masks.date_time_mask"-->
<!--                                              :week-start="7"-->
<!--                                              :input-class="(form.errors.has('company_contacts.'+index+'.date'))? 'bg-white leading-normal mt-2 tracking-wide shadow-sm appearance-none border-1 rounded px-2 text-grey-darkest w-full focus:outline-none border-red':'bg-white leading-normal mt-2 tracking-wide shadow-sm appearance-none border-1 rounded px-2 text-grey-darkest w-full focus:outline-none'"-->
<!--                                              @input="resetValidationErrors('company_contacts.'+index+'.date')">-->
<!--                                        </datetime>-->
<!--                                    <button type="button" v-if="contact.date" @click.prevent.stop="removeMeeting(index)"-->
<!--                                            class="material-icons text-grey-darkest text-xl focus:outline-none mt-2">-->
<!--                                        clear-->
<!--                                    </button>-->
<!--                                </td>-->
<!--                                <td>-->
<!--                                    <select v-model="contact.status" name="status" id="status"-->
<!--                                            :class="(form.errors.has('company_contacts.'+index+'.status')) ? 'bg-white border-1 focus:outline-none px-2 text-grey-darkest text-sm border-red' : 'bg-white border-1 focus:outline-none px-2 text-grey-darkest text-sm'"-->
<!--                                            @change="resetValidationErrors('company_contacts.'+index+'.status');checkAndRemoveKeys(contact);resetCompanyContactStatusValidation();">-->
<!--                                        <option default></option>-->
<!--                                        <option value="no-bid">No Bid</option>-->
<!--                                        <option value="pending">Pending</option>-->
<!--                                        <option :disabled="isWonDisabled(contact)" value="won">Won</option>-->
<!--                                        <option :disabled="isLostDisabled(contact)" value="lost">Lost</option>-->
<!--                                        <option :disabled="isLostDisabled(contact)" value="lost-gc-awarded">Lost – GC Awarded</option>-->
<!--                                        <option :disabled="isLostDisabled(contact)" value="lost-gc-not-awarded">Lost – GC Not Awarded</option>-->
<!--                                    </select>-->
<!--                                </td>-->
<!--                                <td class="pt-2">-->
<!--                                    <button v-if="canEdit" type="button" @click.prevent.stop="addComment(contact)"-->
<!--                                            class="focus:outline-none text-base font-light text-grey-darkest hover:text-grey-darkest material-icons">-->
<!--                                        add_comment-->
<!--                                    </button>-->
<!--                                    <button v-if="canEdit" type="button" @click.prevent.stop="addOrRemoveContact(contact);resetCompanyContactStatusValidation();"-->
<!--                                            class="focus:outline-none text-base font-light text-grey-darkest hover:text-grey-darkest material-icons">-->
<!--                                        delete-->
<!--                                    </button>-->
<!--                                </td>-->
<!--                            </tr>-->
<!--                            <tr v-for="(contact, index) in form.company_contacts"-->
<!--                                class="hover:bg-grey-lighter rounded xl:hidden"-->
<!--                                @click="openCompanyContactModal(contact, index)">-->
<!--                                <td class="pl-2 text-sm text-grey-darkest cursor-pointer">-->
<!--                                    {{ contact.company.name }}-->
<!--                                </td>-->
<!--                                <td class="text-sm text-grey-darkest cursor-pointer">-->
<!--                                    {{ contact.name }}, {{ contact.title }}-->
<!--                                </td>-->
<!--                                <td class="text-sm text-grey-darkest cursor-pointer hidden lg:table-cell">-->
<!--                                    {{ contact.email }} | {{ contact.cell }}-->
<!--                                </td>-->
<!--                            </tr>-->
<!--                            <company-contact-details ref="companyContactModal" :project="project"-->
<!--                                                     @save="saveContactData"-->
<!--                                                     @destroy="addOrRemoveContact"></company-contact-details>-->
<!--                            </tbody>-->
<!--                        </table>-->
<!--                        <span v-if="foundationCustomerAccess" class="text-danger" style="font-size: 12px;">{{ foundationContactSyncedErrorMsg }}</span>-->
<!--                        <span v-if="sageIntacctContactSyncAccess" class="text-danger" style="font-size: 12px;">{{ sageIntacctContactSyncedErrorMsg }}</span>-->
<!--                        <div v-show="companyWonStatusRequired !== null" class="text-red text-sm mt-4"> {{ companyWonStatusRequired }}</div>-->
<!--                    </div>-->
<!--                </div>-->
            </div>
            <div class="rounded bg-white shadow-md mb-4">
                <div class="rounded bg-white shadow-md">
                    <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                        <span>Related Projects</span>
                    </div>
                    <div class="py-4 px-3 flex flex-wrap flex-lg-nowrap items-stretch">
                        <div class="flex-col w-full lg:w-1/3 pr-4">
                            <div class="mb-4 leading-tight">
                                <label class="text-grey-darkest text-sm" for="relatedProjects">Select a Related Project</label>
                                <multiselect
                                    id="relatedProjects"
                                    v-model="selectedProject"
                                    :options="allProjects"
                                    :multiple="false"
                                    :close-on-select="true"
                                    :clear-on-select="false"
                                    :preserve-search="false"
                                    :taggable="true"
                                    open-direction="below"
                                    placeholder="Pick a project"
                                    tag-placeholder="Add this project"
                                    label="name"
                                    track-by="id"
                                    :preselect-first="false">
                                </multiselect>
                            </div>
                            <div v-if="selectedProject">
                                <hr class="lg:hidden">
                                <div class="leading-tight">
                                    <label class="text-grey-darkest text-sm"></label>
                                    <div @click.prevent.stop="addOrRemoveProject(selectedProject)"
                                         class="p-2 hover:bg-grey-lighter flex justify-between items-center rounded cursor-pointer">
                                        <div class="flex items-baseline">
                                            <div class="text-sm mr-3 text-base text-grey-darkest">{{ selectedProject.name }}</div>
                                            <div class="text-sm font-light text-grey-darkest hidden lg:inline">
                                                Project Information ID-{{ selectedProject.custom_project_id ? selectedProject.custom_project_id : selectedProject.sequential_team_id }}
                                            </div>
                                        </div>
                                        <button v-if="!projectAddedAlready(selectedProject) && canEdit"
                                                @click.prevent.stop="addProject(selectedProject)"
                                                class="border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:text-white material-icons p-1 rounded-full text-base text-followup-nav">
                                            add
                                        </button>
                                        <span v-else-if="canEdit" @click.prevent.stop="removeProject(selectedProject)"
                                              class="border-2 border-red focus:outline-none font-semibold hover:bg-red hover:text-white material-icons p-1 rounded-full text-base text-red">
                                        close
                                    </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="hidden lg:flex border-1 border-grey mr-4"></div>
                        <div class="flex-1">
                            <hr class="lg:hidden">
                            <table class="w-full">
                                <thead>
                                <tr>
                                    <th class="pb-2 pl-2 font-medium uppercase text-xs text-grey-darkest border-b border-grey-light">
                                        Project Name
                                    </th>
                                    <th class="pb-2 font-medium uppercase text-xs text-grey-darkest border-b border-grey-light pr-3">
                                        Contact Name
                                    </th>
                                    <th class="pb-2 font-medium uppercase text-xs text-grey-darkest border-b border-grey-light hidden lg:table-cell pr-3">
                                        Email
                                    </th>
                                    <th class="pb-2 font-medium uppercase text-xs text-grey-darkest border-b border-grey-light hidden lg:table-cell pr-3">
                                        Phone
                                    </th>
                                    <th class="pb-2 font-medium uppercase text-xs text-grey-darkest border-b border-grey-light hidden lg:table-cell">
                                        {{ getFieldLabel(fieldLabels, 'sales-status')}}
                                    </th>
                                    <th class="pb-2 hidden xl:table-cell"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="relatedProject in form.related_projects" :key="relatedProject.id" @click.prevent.stop="goToProject(relatedProject)"
                                    class="hover:bg-grey-lighter rounded cursor-pointer">
                                    <td class="text-sm text-grey-darkest pr-3">{{ relatedProject.name }}</td>
                                    <td class="text-sm font-light text-grey-darkest pr-3">
                                        {{ relatedProject.contact_name }}
                                    </td>
                                    <td class="text-sm font-light text-grey-darkest hidden lg:table-cell text-break pr-3">
                                        {{ relatedProject.contact_email }}
                                    </td>
                                    <td class="text-sm font-light text-grey-darkest hidden lg:table-cell text-break pr-3">
                                        {{ relatedProject.contact_phone }}
                                    </td>
                                    <td class="p-2 text-sm font-light text-grey-darkest hidden lg:table-cell text-break pr-3">
                                        {{ relatedProject.sales_status }}
                                    </td>
                                    <td class="pt-2">
                                        <button v-if="canDelete" @click.prevent.stop="removeProject(relatedProject)"
                                                class="focus:outline-none text-base font-light text-grey-darkest hover:text-grey-darkest material-icons">
                                            delete
                                        </button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <project-comments ref="projectcomments" :project="project" :isAdmin="isAdmin" :canEdit="canEdit" :user="user" :isPM="false" :deadReasonCustomField="deadReasonCustomField" :teamDeadSalesStatusIds="teamDeadSalesStatusIds"></project-comments>

        <div class="modal" id="exampleModal" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" style="border-radius: 12px; overflow: hidden;width: 400px;">
                    <div class="modal-header">
                        <div class="row">
                            <div class="col-md-12" style="text-align: center; font-size:20px; margin-top: 10px;">Add a Contact</div>
                            <div class="col-md-12" style="text-align: center; margin-top: 32px;">
                                <button type="button" class="btn btn-primary" style="padding: 20px;box-shadow: #989797 0px 0px 5px 2px;margin-right: 12px;"
                                        @click="openNewCompanyContactModal"> Company Contact</button>
                                <button type="button" class="btn btn-primary" style="padding: 20px;box-shadow: #989797 0px 0px 5px 2px;"
                                        @click="openEmailContactModal">Email Contact</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="procoreCompaniesModal" tabindex="-1" role="dialog" aria-labelledby="procoreCompaniesModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="procoreCompaniesModalLabel">Procore Company Not Selected</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>
                            You haven't been designated by any company for the Procore push process. Please select the relevant company from your settings to proceed with the push in Procore.
                        </p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-primary" @click="addProcoreCompany()">Go to Settings</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="addToAddressBookModal" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" style="border-radius: 12px; overflow: hidden;width: 400px;">
                    <div class="modal-header">
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <p class="m-4">Do you want to add this contact to Company Address Book?</p>
                                <button type="button" class="btn btn-primary mr-2"
                                        data-dismiss="modal" @click="addContactToAddressBook">Yes</button>
                                <button type="button" class="btn btn-danger ml-2"
                                        data-dismiss="modal" aria-label="Close" @click="saveWithoutContact()">No</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal -->
        <div id="newContactToAddressBookModal" class="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">Add To Company Address Book</h4>
                        <button type="button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal" @click="savedAfterCheck()">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @keydown="newAddressBookContactForm.errors.clear($event.target.name)">
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0"
                                       :class="{'text-red': newAddressBookContactForm.errors.has('existing_company')}">Add to Existing Company</label>
                                <multiselect class="cursor-pointer" id="existing" :options="allCompanies" v-model="newAddressBookContactForm.existing_company" :show-labels="false"
                                             @input="newAddressBookContactForm.errors.clear('existing_company')"
                                             @select="remove_validations();disableToggle()"
                                             @remove="removeDisable()"
                                             track-by="id" label="name" value="id"
                                             :disabled="is_true"
                                ></multiselect>
                                <div class="text-red" v-if="newAddressBookContactForm.errors.has('company_id')">{{ form.errors.get('company_id') }}</div>
                                <div class="text-red" v-show="customErrors.existing_company != null">{{ customErrors.existing_company }}</div>
                            </div>
                            <div class="mb-2">
                                <label class="text-grey-darkest text-sm" :class="{'text-red': newAddressBookContactForm.errors.has('new_company')}">Add New Company</label>
                                <input v-model="newAddressBookContactForm.new_company" id="new_company" name="new_company"
                                       class="leading-normal tracking-wide appearance-none border-1 rounded py-1 px-3 text-grey-darkest w-full focus:outline-none"
                                       :class="{'border-red': form.errors.has('new_company')}" @keypress="remove_validations();disableExistingCompany()" @keyup="enableDropdown()"
                                       @paste = "onPaste">
                                <div class="text-red" v-if="newAddressBookContactForm.errors.has('new_company')">{{ newAddressBookContactForm.errors.get('new_company') }}</div>
                                <div class="text-red" v-show="customErrors.new_company != null">{{ customErrors.new_company }}</div>
                            </div>

                            <div class="mb-2">
                                <label class="text-grey-darkest text-sm" for="address_book_contact_name"
                                       :class="{'text-red': newAddressBookContactForm.errors.has('name')}">Name</label>
                                <input v-model="newAddressBookContactForm.name" id="address_book_contact_name" name="name"
                                       maxlength="64"
                                       class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                       :class="{'border-red': newAddressBookContactForm.errors.has('name')}">
                                <div class="text-red text-xs" v-if="newAddressBookContactForm.errors.has('name')">{{
                                        newAddressBookContactForm.errors.get('name')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2" v-show="(teamResidentialContactType && teamResidentialContactType.id && newAddressBookContactForm.contact_types_id === teamResidentialContactType.id)">
                                <label class="text-grey-darkest text-sm" for="searchTextFieldContact"
                                       :class="{'text-red': newAddressBookContactForm.errors.has('address')}">Address</label>
                                <input v-model="newAddressBookContactForm.address" id="searchTextFieldContact" name="address"
                                       maxlength="64"
                                       class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                       :class="{'border-red': newAddressBookContactForm.errors.has('address')}">
                                <div class="text-red text-xs" v-if="newAddressBookContactForm.errors.has('address')">{{
                                        newAddressBookContactForm.errors.get('address')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2" v-show="(teamResidentialContactType && teamResidentialContactType.id && newAddressBookContactForm.contact_types_id === teamResidentialContactType.id)">
                                <label class="text-grey-darkest text-sm" for="address_book_contact_city"
                                       :class="{'text-red': newAddressBookContactForm.errors.has('city')}">City</label>
                                <input v-model="newAddressBookContactForm.city" id="address_book_contact_city" name="city"
                                       maxlength="64"
                                       class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                       :class="{'border-red': newAddressBookContactForm.errors.has('city')}">
                                <div class="text-red text-xs" v-if="newAddressBookContactForm.errors.has('city')">{{
                                        newAddressBookContactForm.errors.get('city')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2" v-show="(teamResidentialContactType && teamResidentialContactType.id && newAddressBookContactForm.contact_types_id === teamResidentialContactType.id)">
                                <label class="text-grey-darkest text-sm" for="address_book_contact_state"
                                       :class="{'text-red': newAddressBookContactForm.errors.has('state')}">State</label>
                                <input v-model="newAddressBookContactForm.state" id="address_book_contact_state" name="state"
                                       maxlength="64"
                                       class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                       :class="{'border-red': newAddressBookContactForm.errors.has('state')}">
                                <div class="text-red text-xs" v-if="newAddressBookContactForm.errors.has('state')">{{
                                        newAddressBookContactForm.errors.get('state')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2" v-show="(teamResidentialContactType && teamResidentialContactType.id && newAddressBookContactForm.contact_types_id === teamResidentialContactType.id)">
                                <label class="text-grey-darkest text-sm" for="address_book_contact_zip"
                                       :class="{'text-red': newAddressBookContactForm.errors.has('zip')}">Zip</label>
                                <input v-model="newAddressBookContactForm.zip" id="address_book_contact_zip" name="zip"
                                       maxlength="64"
                                       class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                       :class="{'border-red': newAddressBookContactForm.errors.has('zip')}">
                                <div class="text-red text-xs" v-if="newAddressBookContactForm.errors.has('zip')">{{
                                        newAddressBookContactForm.errors.get('zip')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="address_book_email"
                                       :class="{'text-red': newAddressBookContactForm.errors.has('email')}">Email</label>
                                <input
                                    class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                    :class="{'border-red': newAddressBookContactForm.errors.has('email')}"
                                    type="text" id="address_book_email" v-model="newAddressBookContactForm.email">
                                <div class="text-red text-xs" v-if="newAddressBookContactForm.errors.has('email')">{{
                                        newAddressBookContactForm.errors.get('email')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="address_book_cell"
                                       :class="{'text-red': newAddressBookContactForm.errors.has('cell')}">Cell</label>
                                <input
                                    class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                    type="text" id="address_book_cell" v-model="newAddressBookContactForm.cell">
                                <div class="text-red text-xs" v-if="newAddressBookContactForm.errors.has('cell')">{{
                                        newAddressBookContactForm.errors.get('cell')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="address_book_contact_title"
                                       :class="{'text-red': newAddressBookContactForm.errors.has('title')}">Title</label>
                                <input
                                    class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                    type="text" id="address_book_contact_title" v-model="newAddressBookContactForm.title">
                                <div class="text-red text-xs" v-if="newAddressBookContactForm.errors.has('title')">{{
                                        newAddressBookContactForm.errors.get('title')
                                    }}
                                </div>
                            </div>
                            <!--                            <div class="mb-2">-->
                            <!--                                <label class="text-sm text-grey-darkest -mb-0" for="new_contact_date"-->
                            <!--                                       :class="{'text-red': newAddressBookContactForm.errors.has('date')}">Follow Up</label>-->
                            <!--                                <div class="flex">-->
                            <!--                                    <datetime type="datetime" id="new_contact_date" name="date"-->
                            <!--                                              v-model="newAddressBookContactForm.date" use12-hour-->
                            <!--                                              class="w-full"-->
                            <!--                                              :week-start="7"-->
                            <!--                                              :format="masks.date_time_mask"-->
                            <!--                                              :use-utc="true"-->
                            <!--                                              input-class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"-->
                            <!--                                              @input="newAddressBookContactForm.errors.clear('date')">-->
                            <!--                                    </datetime>-->
                            <!--                                    <button v-if="newAddressBookContactForm.date" @click.prevent.stop="removeNewContactDate"-->
                            <!--                                            class="material-icons text-grey-darkest text-xl focus:outline-none">clear-->
                            <!--                                    </button>-->
                            <!--                                </div>-->
                            <!--                                <div class="text-red text-xs" v-if="newContactForm.errors.has('date')">{{-->
                            <!--                                        newContactForm.errors.get('date')-->
                            <!--                                    }}-->
                            <!--                                </div>-->
                            <!--                            </div>-->
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0"
                                       :class="{'text-red': newAddressBookContactForm.errors.has('contact_types_id')}">Contact Type</label>
                                <multiselect
                                    class="cursor-pointer"
                                    :options="all_contact_types"
                                    v-model="selectedAddressBookContactType"
                                    :show-labels="false"
                                    @input="newAddressBookContactForm.errors.clear('contact_types_id')"
                                    track-by="id"
                                    label="code"
                                    value="id">
                                </multiselect>
                                <div class="text-red text-xs" v-if="newAddressBookContactForm.errors.has('contact_types_id')">
                                    The contact type field is required.
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button @click.prevent="addressBookContactSaved" :disabled="addressBookContactSavedButton"
                                class="btn btn-primary">
                            <span v-if="adding_contact">
                                <i class="fa fa-btn fa-spinner fa-spin" ></i>
                                Adding Contact
                            </span>
                            <span v-else>
                                Add Contact
                            </span>
                        </button>
                        <button type="button" class="btn btn-danger ml-2"
                                data-dismiss="modal" aria-label="Close" @click="savedAfterCheck()">Cancel</button>
                    </div>
                </div>

            </div>
        </div>

        <company-contact-modal ref="CompanyContactModal" :masks="this.masks" :symbols="this.symbols"
                               @selected="parseContacts"></company-contact-modal>
        <external-email-file-modal ref="EmailFileModal" :team-id="teamId"></external-email-file-modal>
        <project-contact-modal ref="EmailContactModal" :masks="this.masks" :symbols="this.symbols" :exchange="exchange" :externalEmailService="externalEmailService"  @selected="parseContacts"></project-contact-modal>
        <company-create-modal ref="CompanyCreateModal" :masks="this.masks" :symbols="this.symbols" :exchange="exchange" :externalEmailService="externalEmailService" :foundationCustomerAccess="foundationCustomerAccess" :foundationAutoGeneratedAccess="foundationAutoGeneratedAccess" @inserted="fetchCompanies"></company-create-modal>
        <quick-book-estimate ref="QuickBookEstimateModal" :project="project" :selects="selects" :quick-book-estimates="quickBookEstimates" :team="team" v-if="quickBookAccess && canEdit" :company-contacts="form.company_contacts"></quick-book-estimate>
        <quick-book-income-cost ref="QuickBookIncomeCost" v-if="project.quick_book_project_id && quickBookAccess && canEdit" :project="project"></quick-book-income-cost>

        <div id="projectSaleBehaviorCompleteCommentModal" class="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog" style="max-width: 870px">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 v-if="tempSalesActivity" class="modal-title text-lg">
                            {{tempSalesActivity.name}} comment
                        </h4>
                    </div>
                    <div class="modal-body">
                        <form @keydown="projectCommentForm.errors.clear($event.target.name)">

                            <div class="mb-2">
                                <ckeditor-container placeholder="Send your colleagues on FollowUp notifications by typing @ followed by their name" id="comment" v-model="projectCommentForm.comment" :options="users"
                                                    @mention="addMention" mentionFrom="name"></ckeditor-container>
                                <div class="text-red text-xs" v-if="projectCommentForm.errors.has('comment')">{{
                                        projectCommentForm.errors.get('comment')
                                    }}
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <span v-if="this.projectCommentForm.saving">
                            <button type="button" disabled
                                    class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                <i class="fa fa-btn fa-spinner fa-spin"></i> Saving
                            </button>
                        </span>
                        <span v-else>
                            <button type="button" id="save-project-comment" name="save-project-comment"
                                    @click.prevent="projectSalesActivityCommentSaved"
                                    class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                Save
                            </button>
                        </span>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
import Form from "../../utils/form";
import Datepicker from 'vuejs-datepicker';
import Multiselect from 'vue-multiselect';
import {CurrencyInput} from 'vue-currency-input';
import VueTribute from 'vue-tribute';
import CKEditorContainer from '../shared/ckeditor-container';
import Swal from "sweetalert2";
import axios from 'axios';
import {specialCharacterCodeConstants, completePercentageConstants} from '../constants/constants.js';
import QuickBookIncomeCost from "../shared/quick-book-income-cost.vue";
import CompanyInformation from "./company-information.vue";
import VistaIncomeCost from "../shared/vista-income-cost.vue";
import FlatfileImporter from "@flatfile/adapter";
import config from "../../flatfile-env";
import * as parser from "parse-address";
import ProjectRecordDetailCustomFields from "./custom-fields/project-record-detail-custom-fields.vue";
import isEqual from 'lodash/isEqual';


let autocomplete=null;
let autocompleteContact=null;

export default {
    name: 'project-edit',
    props: [
        'company',
        'project',
        'hasEstimatingAccess',
        'hasManagementAccess',
        'fromEstimating',
        'hasProposalGeneratorAccess',
        'hasFcsConfigurated',
        'hasRoofChiefConfigurated',
        'userLegacy',
        'dashboard',
        'dashboardTab',
        'reportCard',
        'isAdmin',
        'canEdit',
        'canDelete',
        'updated',
        'masks',
        'documentsQtd',
        'enablePrequalification',
        'hasZapierConfigurated',
        'hasCalendarAccess',
        'hasDataFormaAccess',
        'hailReconAccess',
        'hasStackAccess',
        'hasStackAccessToken',
        'relatedProjects',
        'hasCompanyCamAccess',
        'hasCompanyCamAccessToken',
        'hasProcoreAccess',
        'hasProcoreAccessToken',
        'masks',
        'symbols',
        'confettiPath',
        'teamId',
        'hasSequencesAccess',
        'exchange',
        'user',
        'hasProposalButtonAccess',
        'changeOrderKey',
        'hasPipelineGraph',
        'hasSumContractAmount',
        'team',
        'externalEmailService',
        'fieldLabels',
        'contactToAddressBook',
        'foundationProjectDataPullAccess',
        'foundationContactSyncAccess',
        'foundationCustomerAccess',
        'foundationAutoGeneratedAccess',
        'isCompanyHasCustomCustomerNoField',
        'isCompanyCustomCustomerNoAutoGenerated',
        'isContactHasCustomCustomerNoField',
        'isContactCustomCustomerNoAutoGenerated',
        'sageIntacctContactSyncAccess',
        'vistaAccess',
        'projectSalesStatusState',
        'quickBookAccess',
        'sageIntacctContactSyncAccess',
        'quickBookEstimates',
        'fieldLabels',
        'isContactResidentialActive',
        'teamResidentialContactType',
        'vistaJobNumberCustomFieldId',
		'sageAccess',
        'sageProjectMapping',
        'sageJobNumberCustomFieldId',
        'teamDeadSalesStatusIds',
		'agaveErp',
        'spectrumAccess',
        'spectrumProjectMapping',
        'isSpectrumSetToAutoGenerate',
        'hasSpectrumCompanyContactMapping',
        'hasSpectrumResidentialContactMapping',
        'hasSpectrumChangeOrderMapping',
        'spectrumJobNumberCustomFieldId',
        'spectrumChangeOrderMappings',
        'spectrumCustomerCodeId',
        'spectrumCustomIdAutoGenerated',
        'vistaWorkOrderMappings',
        'foundationAccess',
        'foundationProjectMapping',
        'hasFoundationCompanyContactMapping',
        'hasFoundationResidentialContactMapping',
        'hasFoundationChangeOrderMapping',
        'foundationChangeOrderMappings',
        'foundationJobNumberCustomFieldId',
        'isProjectSequentialIdMappedToFoundation',
        'project_custom_fields',
        'change_order_custom_fields',
        'team_users',
        'project_custom_field_options',
        'hasPricingAccess',
        'getAllPricingFields',
        'team_custom_project_ids',
        'foundationCompanyCustomerCodeCustomField',
        'foundationResidentialContactCustomerCodeCustomField',
        'recordDetailFieldLabels',
        'projectDataFieldVisibility',
        'computerEaseAccess',
        'computerEaseProjectMapping',
        'projectErpSyncSettings',
        'workOrderErpSyncSettings',
        'erpConnections',
        'canErpCreate',
        'canErpUpdate',
        'canErpSync',
        'canCreateCompany',
        'canViewProjectDocument'
    ],
    components: {
        QuickBookIncomeCost,
        CompanyInformation,
        Datepicker, Multiselect, CurrencyInput, VueTribute, CKEditorContainer, specialCharacterCodeConstants, completePercentageConstants, VistaIncomeCost,
        ProjectRecordDetailCustomFields},

    data() {
        config.fileDataConfig.fields = config.fileDataConfig.fields.map(field => ({...field, label: this.getFieldLabelForFlatFile(this.fieldLabels , field.key)}))

        for (let i = 6; i <= 20; i++) {
            config.fileDataConfig.fields.push(
                { key: `company_name_${i}`, label: `Company Name ${i}` },
                { key: `company_phone_${i}`, label: `Company Phone ${i}` },
                { key: `company_contact_name_${i}`, label: `Company Contact Name ${i}` },
                { key: `company_contact_title_${i}`, label: `Company Contact Title ${i}` },
                {
                    key: `company_contact_email_${i}`,
                    label: `Company Contact Email ${i}`,
                    validators: [
                        {
                            validate: 'regex_matches',
                            regex: '^\\S+@\\S+$',
                            error: 'Email Must Be Valid'
                        }
                    ]
                },
                { key: `company_contact_phone_${i}`, label: `Company Contact Phone ${i}` },
                { key: `followup_${i}`, label: `Followup ${i}` },
                {
                    key: `status_${i}`,
                    label: `Status ${i}`,
                    type: "select",
                    options: [{ value: "", label: "" }]
                }

            );
        }

        return {
            importerClients: new FlatfileImporter(
                config.license,
                this.$root.currentTeam.custom_project_id_check ? config.fileDataConfig : { ...config.fileDataConfig, fields: config.fileDataConfig.fields.slice(1) }
            ),
            change_orders:[
                {
                    id: '',
                    sales_status_id: '',
                    base_bid: 0,
                    contract_amount: 0,
                    contract_date: '',
                    bid_date: '',
                    gross_margin_percentage: 0,
                    name: '',
                    cost_code: 0,
                    complete_percentage: null,
                    edit_change_order_name: false
                }
            ],
            address:'',
            form_changed: false,
            viewStackFlag: false,
            viewProcoreFlag: false,
            viewProcorePath: null,
            stackSaveLoading: false,
            ProcoreSaveLoading: false,
            viewStackPath: null,
            viewCompanyCamFlag: false,
            companyCamSaveLoading: false,
            viewCompanyCamPath: null,
            viewDataFormaFlag: false,
            viewDataFormaPath: null,
            dataFormaOptions: [
                {name: 'Create Client', code: 'createClient'},
                {name: 'Create Building', code: 'createBuilding'}
            ],
            optionsLinkedin:[
                { value: 'PUBLIC', text: 'PUBLIC' },
                { value: 'CONNECTIONS', text: 'CONNECTIONS' },
            ],
            allCompanies: [],
            contacts: [],
            searchContacts: [],
            contact_type_options: [],
            selectedTypeContact: null,
            selectedAddressBookContactType: null,
            selectedUserContact: null,
            users: [],
            estimates: [],
            selectedEstimate: null,
            edgeEstimateUrl:'#',
            selectedCompany: null,
            selectedContactForProposalGenerator: null,
            selectedDataForma: [],
            bidFromEstimating: this.fromEstimating,
            options: {
                format: this.masks.date_mask,
                useCurrent: false,
            },
            vueTributeOptions: {
                values: (text, cb) => {
                    this.filterUsers(text, cb);
                },
                allowSpaces: true,
                lookup: 'name',
                fillAttr: 'name',
                selectClass: 'selected-mention'
            },
            selects: {},
            form: '',
            editing: false,
            current_comment: null,
            company_contact: null,
            sales_status: null,
            projectCommentForm: new Form({
                id: null,
                comment: '',
                date: '',
                company_contact_id: null,
                sales_status_id: null,
                mentioned_users: [],
                saving: false,
                commentAddFrom:null,
                deadReason: null
            }),
            newContactForm: new Form({
                id: null,
                name: '',
                email: '',
                cell: '',
                title: '',
                date: null,
                completed: null,
                contact_types_id: null,
                user: null,
            }),
            newAddressBookContactForm: new Form({
                id: null,
                name: '',
                address: '',
                city: '',
                state: '',
                zip: '',
                lat: '',
                lng: '',
                email: '',
                cell: '',
                title: '',
                date: null,
                completed: null,
                contact_types_id: null,
                company_id: null,
                existing_company: null,
                new_company: null,
            }),
            customErrors : {
                'existing_company': null,
                'new_company': null
            },
            is_true: false,
            addressBookContactSavedButton: false,
            adding_contact: false,
            autocomplete:null,
            page: 1,
            filter: '',
            data: '',
            checked_proposal_delivered: false,
            storage_project_list: {
                list: [],
                current_index: -1
            },
            loading_fcs: false,
            loading_estimating_edge: false,
            pre_qualified_edited: false,
            is_fcs_sync: false,
            loading_roof_chief: false,
            selectedProject: null,
            allProjects: [],
            immediate_flag:true,
            allCompanyCamProjects: [],
            selectedCompanyCamProjectId: null,
            companyCamSyncLoading: false,
            companyCamSyncProjectLoading:false,
            showDataformaModal: false,
            selectedDFOption: '',
            selectedDFObject: '',
            selectedDFProject: '',
            selectedDFCompany: [],
            selectedDFContact: [],
            dfObjectExist: '',
            dataforma_building_id: 0,
            dataforma_client_id: 0,
            dataforma_contact_id: 0,
            dfErrors: [],
            dataforma_search_result: [],
            dataforma_search: null,
            dataformaLoader:false,
            dataformaTableLoader:false,
            saveDataformaLoader:false,
            getDataformaTypesLoader:true,
            dataforma_all_types: [],
            dataformaType:'',
            pullDataError:'',
            selectedDFCompanyForContact:null,
            proposalData: this.project.proposals,
            createdSelectedDFOptions: '',
            createError:false,
            formLinkedin: new Form({
                note: '',
                project_google_image: this.project.project_google_image ? this.project.project_google_image :'',
                visibility: 'PUBLIC',
                name: this.project.name ?? '',
                address: this.project.address ?? '',
            }),
            isActiveShareButton:false,
            checkCommentStatus: 0,
            isValidateRequiredField: {
                isRequired:false,
                isContractAmountRequired:false,
                isCompanyContactStatusRequired:false,
            },
            formErrorObj: {
                field: '',
                msg: ''
            },
            companyContactIds: [],
            projectExistComapnyCam:true,
            hoverJobId: this.project.hover_job_id,
            hoverLoading: false,
            feildlabale :[],
            commentAddFrom:null,
            callTo:null,
            xScopeLoading: false,
            usersForContact: [],
            savingProject: false,
            foundationLoading: false,
            foundationContactSyncedErrorMsg: '',
            foundationSyncAction: '',
            foundationLocationReload: true,
            contact_custom_fields: [],
            company_custom_fields: [],
            external_custom_fields: [],
            externalFoundationCustomFieldValue: null,
            externalCustomFieldModalTitle: '',
            selectedContactForPushFoundation: null,
            foundationContactPushLoader: false,
            selectedContactForPushSageIntacct: null,
            sageIntacctContactPushLoader: false,
            sageIntacctContactSyncedErrorMsg: '',
            sageIntacctSyncAction: '',
            specialCharacterCode: specialCharacterCodeConstants,
            checkValidations: true,
            all_contact_types: [],
            residential_contact_type: {},
            companyWonStatusRequired: null,
            ifProjectIsInContract: null,
            changeOrderCompletePercentages: completePercentageConstants,
            quickBookEstimatesList: (this.quickBookEstimates)? this.quickBookEstimates:[],
            loadingQB: false,
            projectDataFroQB:this.project,
            quickBookInvoiceData:null,
            completedSalesBehaviorsForSegment: [],
            quickBookCostData:null,
            quickBookInvoiceDiscountData:0,
            deadReasonCustomField: null,

            vistaLoading: false,
            selectedContactForVistaSync: null,
            fileDataCustomDateFields: [],
            project_sales_behaviors_name:[],
            status: [
                {
                    id: "pending", value: "Pending"
                },
                {
                    id: "won", value: "Won"
                },
                {
                    id: "lost", value: "Lost"
                }
            ],
            tempSalesActivity: null,
            searchContactsLoader: false,
            erpSyncSettingSalesStatusId: null,
            previousSelectedSalesStatusId: null,
            erpPushProjectInitiatedBySalesStatus: false,
            erpSyncSettingWorkOrderSalesStatusId: null,
            erpConnectionId: null,
            selectedConnection: null,
            vistaProjectConnectionData: {
                hasVistaProjectMapped: false,
                vistaProjectDirection: null,
                hasVistaCompanyMapped: false,
                hasVistaResidentialContactMapped: false,
                vistaJobNumberCustomFieldId: null,
                hasVistaChangeOrderMapped: false,
                vistaChangeOrderMappings: null,
                hasVistaWorkOrderMapped: false,
                vistaWorkOrderMappings: null,
                hasVistaWorkOrderFieldsMapped: false,
                hasVistaServiceSiteMapped: false,
                hasVistaServiceSiteFieldsMapped: false,
                checkCompanyContactMapping: true,
                hasVistaContractMapped: false,
                hasVistaContractFieldsMapped: false,
                hasVistaContractChangeOrderMapped: false,
                hasVistaContractChangeOrderFieldsMapped: false,
                vistaContractChangeOrderMappings: null,
                erpSyncSettingSalesStatusId: null,
                erpSyncSettingWorkOrderSalesStatusId: null,
            },
            projectAutomaticErpSyncWithSalesStatus: null,
        }
    },
    watch: {
        'form.contract_amount': function (value) {
            this.validateContractAmount();
        },
        form: {
            handler: function (val, oldVal) {
                const vue = this;
                // console.log('999999999999999999999999999999999999999999999999999', JSON.stringify(val) !== JSON.stringify(oldVal));
                if (JSON.stringify(val) !== JSON.stringify(oldVal)) {
                    console.log('Form changed:', val, 'to', oldVal);
                }
                vue.handleFormChanges(val, oldVal);
             /*   if (this.form_changed) {
                    window.onbeforeunload = function (event) {
                        if(vue.form_changed){
                            event.returnValue = false;
                        }
                    };
                } else if(oldVal !== '') {
                    this.form_changed = true
                }*/
            },
            deep: true
        },
        'form.sales_status_id': function (value, oldValue) {
            this.previousSelectedSalesStatusId = oldValue;

            const salesStatus = _.find(this.selects.sales_status, {id: value});
            if (typeof salesStatus !== "undefined") {
                this.adjustTextColor(this.project, value);
            }

            //ERP Sync Settings for project
            if(this.agaveErp && this.vistaAccess){
                const workOrderAutomaticErpSyncWithSalesStatus = _.filter(this.workOrderErpSyncSettings, { 'entity_action': 'push', 'entity_action_type': 'automatic', 'entity_action_depends_on': 'sales-status', 'sales_status_id': value});
                const projectAutomaticErpSyncWithSalesStatus = _.filter(this.projectErpSyncSettings, { 'entity_action': 'push', 'entity_action_type': 'automatic', 'entity_action_depends_on': 'sales-status', 'sales_status_id': value});

                console.log("projectAutomaticErpSyncWithSalesStatus", projectAutomaticErpSyncWithSalesStatus)
                console.log("workOrderAutomaticErpSyncWithSalesStatus", workOrderAutomaticErpSyncWithSalesStatus)
                if(projectAutomaticErpSyncWithSalesStatus && projectAutomaticErpSyncWithSalesStatus.length > 0 && !this.project.vista_project_no && this.previousSelectedSalesStatusId !== value && this.project.sales_status !== value){
                    this.erpPushProjectInitiatedBySalesStatus = true;
                    this.openVistaConnectionSelection(false, projectAutomaticErpSyncWithSalesStatus);
                }else if(workOrderAutomaticErpSyncWithSalesStatus && workOrderAutomaticErpSyncWithSalesStatus.length > 0 && !this.project.agave_work_order_no){
                    this.erpPushProjectInitiatedBySalesStatus = true;
                    this.$refs.ProjectVistaComponent.createSMWorkOrder('create-sm-work-order', workOrderAutomaticErpSyncWithSalesStatus);
                }
            }else if(this.agaveErp && !this.vistaAccess && value && this.erpSyncSettingSalesStatusId && !this.project.agave_work_order_no && oldValue !== value && this.project.sales_status !== value) {
                this.erpPushProjectInitiatedBySalesStatus = true;
                this.pushProjectToEnabledERP();
            }

            if (typeof salesStatus !== "undefined" && (salesStatus.dead === 1 || salesStatus.contract === 0)) {
                this.form.contract_date = null;
                return;
            }
            if (typeof salesStatus !== "undefined" && salesStatus.contract && !this.form.contract_date) {
                this.form.contract_date= moment().format('YYYY-MM-DD');
            }
        },
        selectedTypeContact: function (typeContact) {
            this.newContactForm.contact_types_id = typeContact.id;
        },
        selectedAddressBookContactType(type) {
            if (this.residential_contact_type.id === type.id){
                this.is_true = true;
                this.newAddressBookContactForm.existing_company = null;
                this.newAddressBookContactForm.new_company = null;
                document.getElementById("new_company").disabled = true;
            }else {
                this.is_true = false;
                document.getElementById("new_company").disabled = false;
            }

            this.newAddressBookContactForm.contact_types_id = type.id;
        },
        selectedUserContact: function (user) {
            this.newContactForm.user = user;
        },
        'form.contact_name': function (value) {
            if(this.form.errors.errors.contact_name && value !== null) {
                delete this.form.errors.errors.contact_name;
            }
        },
        'form.contact_email': function (value) {
            if(this.form.errors.errors.contact_email && value !== null) {
                delete this.form.errors.errors.contact_email;
            }
            if(this.project.contact.email !== this.form.contact_email){
                this.form.check_contact_in_address_book = 1;
            }else{
                this.form.check_contact_in_address_book = 0;
            }
        },
        'form.contact_phone': function (value) {
            if(this.form.errors.errors.contact_phone && value !== null) {
                delete this.form.errors.errors.contact_phone;
            }
        },
        'form.company_contacts': function (value) {
            if(this.form.company_contacts.length > 0) {
                this.resetValidationErrors('company_contacts');
                if(_.findIndex(this.form.company_contacts, function(contact) { return contact.foundation_customer_no !== null; }) === -1) {
                    this.foundationContactSyncedErrorMsg = 'None of the contacts added is synced with Foundation';
                }
                else {
                    this.foundationContactSyncedErrorMsg = '';
                }
                if(_.findIndex(this.form.company_contacts, function(contact) { return contact.sage_intacct_customer_no !== null; }) === -1) {
                    this.sageIntacctContactSyncedErrorMsg = 'None of the contacts added is synced with Sage Intacct';
                }
                else {
                    this.sageIntacctContactSyncedErrorMsg = '';
                }
            }
            else {
                this.foundationContactSyncedErrorMsg = '';
                this.sageIntacctContactSyncedErrorMsg = '';
            }
        },
        externalFoundationCustomFieldValue() {
            this.validateFoundationCustomerNumber();
        }
    },

    created() {
        this.fetchCompanies();
        this.fetchProjects();
        this.fetchCodes();
        this.fetchTeamUsers();
        this.findActiveProposalDelivered();
        this.getLocalCurrentListData();
        this.getContactTypes();
        this.getEstimates();
        this.form = this.initForm(this.project);
        this.proposalData.map((pro,index) => {
            pro.name = (pro.name == 'Untitled Report')? this.project.name+' v'+index++:pro.name
        });
        this.getDeadReasonCustomField();
        if(this.agaveErp) {
            this.getERPSyncSettingSalesStatusId();
        }
    },

    mounted() {
        if(this.hasPricingAccess){
            this.initializePricingFlatFile()
        }
        this.address = this.form.address;
        let self = this;
        self.dataforma_building_id = self.project.dataforma_building_id;
        self.dataforma_client_id = self.project.dataforma_client_id;
        self.dataforma_contact_id = self.project.contact ? self.project.contact.dataforma_contact_id : 0;
        self.getStackURL();
        self.getProcoreURL();
        self.getCompanyCamURL();
        $("#projectCommentModal").on('hidden.bs.modal', function () {
            self.projectCommentForm.reset();
            self.company_contact = null;
            this.current_comment = null;
            self.sales_status = null;
            self.projectCommentForm.sales_status = null;
            self.editing = false;
        });
        this.isFCSSynced();
        this.initAutocomplete();
        this.initAutocompleteContact();
        this.getFoundationSyncedProject();

        Bus.$on('openEmailContactModalParent', data => {
            $('#modal-contact').modal('hide');
            this.$refs.CompanyContactModal.close();
            this.$refs.EmailContactModal.open(this.project.id);

        });

        Bus.$on('openCompanyContactModal', data => {
            this.$refs.EmailContactModal.close();
            this.$refs.CompanyContactModal.open();

        });

        this.fetchContactCustomFields();
        this.fetchCompanyCustomFields();

        if(this.project.quick_book_invoice_data.invoiceDiscountData){
            this.quickBookInvoiceDiscountData = this.project.quick_book_invoice_data.invoiceDiscountData;
        }
        if(this.project.quick_book_invoice_data){
            console.log(this.project.quick_book_invoice_data.invoiceDiscountData);
            let data = {};
            if(this.project.quick_book_invoice_data.invoiceData){
                data = {
                    invoiceData: Object.entries(this.project.quick_book_invoice_data.invoiceData),
                    invoiceTotal: this.project.quick_book_invoice_data.invoiceTotal-this.project.quick_book_invoice_data.invoiceDiscountData
                };
            }else{
                data = {
                    invoiceData: null,
                    invoiceTotal: this.project.quick_book_invoice_data.invoiceTotal-this.project.quick_book_invoice_data.invoiceDiscountData
                }
            }
            this.quickBookInvoiceData = data;
            let cost = {};
            let costTotal = 0;
            if(this.project.quick_book_cost_data.costData){
                if(this.project.quick_book_bill_data.billData){
                    costTotal = this.project.quick_book_cost_data.costTotal + this.project.quick_book_bill_data.billTotal;
                }else{
                    costTotal = this.project.quick_book_cost_data.costTotal;
                }
                if(this.project.quick_book_hourly_time_cost_data){
                    costTotal = costTotal + this.project.quick_book_hourly_time_cost_data.hourlyTimeCostTotal;
                }

                cost = {
                    costData: Object.entries(this.project.quick_book_cost_data.costData),
                    costTotal: costTotal
                };
            }else{
                if(this.project.quick_book_bill_data.billData){
                    costTotal = this.project.quick_book_cost_data.costTotal + this.project.quick_book_bill_data.billTotal;
                }else{
                    costTotal = this.project.quick_book_cost_data.costTotal;
                }
                if(this.project.quick_book_hourly_time_cost_data){
                    costTotal = costTotal + this.project.quick_book_hourly_time_cost_data.hourlyTimeCostTotal;
                }
                cost = {
                    costData: null,
                    costTotal: costTotal
                }
            }
            this.quickBookCostData = cost;
        }
        if(this.project.quick_book_project_id){
            this.syncQBProjectInvoice();
        }

        document.addEventListener('keydown', function(event) {
        if (event.key === 'Enter') {
          event.preventDefault();
        }
      });

      $('[data-toggle="tooltip"]').tooltip();

        if(this.erpConnections.length == 1){
            this.erpConnectionId = this.project.erp_connection_id ? this.project.erp_connection_id : this.erpConnections[0].id;
        }else{
            this.erpConnectionId = this.project.erp_connection_id ?? null;

        }

        Bus.$on('vistaConnectionDataChanged', data =>{
            this.vistaProjectConnectionData = data
        })
    },
    computed: {

        customFieldValue: {
            get() {
                return this.originalValue;
            },
            set(newValue) {
                this.originalValue = newValue;
            }
        },

        previewStyle() {
            return `background-image: url(${this.user.photo_url})`;
        },

        allContacts() {
            let first = [{...this.project.contact, type: 'project_contact'}];
            let data = this.form.company_contacts.map(x => ({...x, type: 'company_contact'}));

            this.form_changed = false;
            window.onbeforeunload = null;

            return first.concat(data);
        },

        atLeastOneHasDate() {
            return _.some(this.form.sales_behaviors, (item) => item.date);
        },

        mailSubject() {
            let projectNameSplit = this.project.name.split('');
            let nameArray = [];
           this.specialCharacterCode.forEach(character => {
               projectNameSplit.forEach((item, index) => {
                  if(item == character.character){
                      nameArray.push({index: index, code: character.code});
                  }
               });
            });
            projectNameSplit.forEach((item, index) => {
                nameArray.forEach((character, ind) => {
                    if(index == character.index){
                        projectNameSplit[index] = character.code;
                    }
                })
            });

           let projName = projectNameSplit.join("");
            return `?subject=(${projName} - ${this.project.id})`;
        },

        projectPosition() {
            const isFirst = this.storage_project_list.current_index === 0;
            const isLast = this.storage_project_list.current_index === this.storage_project_list.list.length - 1;

            if (isFirst && isLast) return 'only';
            if (isFirst && !isLast) return 'first';
            if (isLast && !isFirst) return 'last';
            return null;
        },

        switchToProjectManagement() {
            return route('api.user-mode', {
                'path': `/project/edit`,
                'isManagement': 1,
                'projectId': this.project.id
            });
        },
        createProjectManagement() {
            return route('api.user-mode', {
                'path': `/project/create`,
                'isManagement': 1,
                'projectId': this.project.id
            });
        },

        optionsForProposalGenerator() {
            let contactArray = [];
            if(this.project.contact){
              let projectContact  = {
                      contact_type: 'Project Contact',
                      contact_options: [
                          {...this.project.contact, type: 'project_contact', displayName: this.project.contact.name},
                      ]
                  };
                contactArray.push(projectContact);
            }

            if(this.form.company_contacts.length > 0){
                let companyContactOptions = [];
                this.form.company_contacts.forEach(item => {
                    companyContactOptions.push({...item, type: 'company_contact', displayName: item.name+' ('+item.company_name+')'});
                });
                let companyContact  = {
                    contact_type: 'Company Contact',
                    contact_options: companyContactOptions
                };
                contactArray.push(companyContact);
            }
            return contactArray
        },

        isSyncChangeOrderDisabled() {
            let isDisabled = false;
            if((!this.vistaProjectConnectionData.vistaChangeOrderMappings || this.vistaProjectConnectionData.vistaChangeOrderMappings.direction ==='one-way-third-party') && (!this.vistaProjectConnectionData.vistaContractChangeOrderMappings || this.vistaProjectConnectionData.vistaContractChangeOrderMappings.direction ==='one-way-third-party') ){
                isDisabled = true;
            }
            return isDisabled;
        },
        changeOrderTooltipText() {
            let tooltip = '';
            if(!this.vistaProjectConnectionData.hasVistaChangeOrderMapped && !this.vistaProjectConnectionData.hasVistaContractChangeOrderMapped){
                tooltip ='Please map the Vista Change orders module to Followup in ERP settings and try again';
            }else if((this.vistaProjectConnectionData.hasVistaChangeOrderMapped && this.vistaProjectConnectionData.vistaChangeOrderMappings.direction ==='one-way-third-party') || this.vistaProjectConnectionData.hasVistaContractChangeOrderMapped && this.vistaProjectConnectionData.vistaContractChangeOrderMappings.direction ==='one-way-third-party') {
                tooltip ='Change the sync direction of the field mapping from Vista to Followup or 2 way and try again';
            }else if((this.vistaProjectConnectionData.hasVistaChangeOrderMapped  && !this.vistaProjectConnectionData.vistaChangeOrderMappings) || (this.vistaProjectConnectionData.hasVistaContractChangeOrderMapped && !this.vistaProjectConnectionData.vistaContractChangeOrderMappings)) {
                tooltip ='Please map at least one Vista field to a Followup field, and try again';
            }
            return tooltip;
        },
        isSpectrumSyncChangeOrderDisabled() {
            let isDisabled = false;
            if(!this.hasSpectrumChangeOrderMapping || this.spectrumChangeOrderMappings.direction ==='one-way-third-party' || (this.spectrumChangeOrderMappings.module_fields && this.spectrumChangeOrderMappings.module_fields.length === 0) ){
                isDisabled = true;
            }
            return isDisabled;
        },
        spectrumChangeOrderTooltipText() {
            let tooltip = '';
            if(!this.hasSpectrumChangeOrderMapping){
                tooltip ='Please map the Spectrum Change orders module to Followup in ERP settings and try again';
            }else if(this.spectrumChangeOrderMappings.direction ==='one-way-third-party') {
                tooltip ='Change the sync direction of the field mapping from Spectrum to Followup or 2 way and try again';
            }else if(this.spectrumChangeOrderMappings.module_fields && this.spectrumChangeOrderMappings.module_fields.length === 0) {
                tooltip ='Please map at least one Spectrum field to a Followup field, and try again';
            }
            return tooltip;
        },
        isSage300SyncChangeOrderDisabled() {
            let isDisabled = false;
            let changeOrderMapping = this.agaveErp.change_order_field;
            if(!changeOrderMapping || changeOrderMapping.direction === 'one-way-third-party' || (changeOrderMapping.module_fields && changeOrderMapping.module_fields.length === 0) ){
                isDisabled = true;
            }
            return isDisabled;
        },
        sage300ChangeOrderTooltipText() {
            let tooltip = '';
            let changeOrderMapping = this.agaveErp.change_order_field;
            if(!changeOrderMapping){
                tooltip ='Please map the Sage 300 Change orders module to Followup in ERP settings and try again';
            }else if(changeOrderMapping.direction === 'one-way-third-party') {
                tooltip ='Change the sync direction of the field mapping from Sage 300 to Followup or 2 way and try again';
            }else if(changeOrderMapping.module_fields && changeOrderMapping.module_fields.length === 0) {
                tooltip ='Please map at least one Sage 300 field to a Followup field, and try again';
            }
            return tooltip;
        },
        isSage100SyncChangeOrderDisabled() {
            let isDisabled = false;
            let changeOrderMapping = this.agaveErp.change_order_field;
            if(!changeOrderMapping || changeOrderMapping.direction === 'one-way-third-party' || (changeOrderMapping.module_fields && changeOrderMapping.module_fields.length === 0) ){
                isDisabled = true;
            }
            return isDisabled;
        },
        sage100ChangeOrderTooltipText() {
            let tooltip = '';
            let changeOrderMapping = this.agaveErp.change_order_field;
            if(!changeOrderMapping){
                tooltip ='Please map the Sage 100 Change orders module to Followup in ERP settings and try again';
            }else if(changeOrderMapping.direction === 'one-way-third-party') {
                tooltip ='Change the sync direction of the field mapping from Sage 100 to Followup or 2 way and try again';
            }else if(changeOrderMapping.module_fields && changeOrderMapping.module_fields.length === 0) {
                tooltip ='Please map at least one Sage 100 field to a Followup field, and try again';
            }
            return tooltip;
        },
        foundationChangeOrderTooltipText() {
            let tooltip = '';
            if(!this.hasFoundationChangeOrderMapping) {
                tooltip ='Please map the Foundation Change orders module to Followup in ERP settings and try again';
            }
            else if(this.foundationChangeOrderMappings.direction ==='one-way-third-party') {
                tooltip ='Change the sync direction of the field mapping from Foundation to Followup or 2 way and try again';
            }
            else if(this.foundationChangeOrderMappings.module_fields && this.foundationChangeOrderMappings.module_fields.length === 0) {
                tooltip ='Please map at least one Foundation field to a Followup field, and try again';
            }
            return tooltip;
        },
        isFoundationSyncChangeOrderDisabled() {
            let isDisabled = false;
            let changeOrderMapping = this.agaveErp.change_order_field;
            if(!changeOrderMapping || changeOrderMapping.direction === 'one-way-third-party' || (changeOrderMapping.module_fields && changeOrderMapping.module_fields.length === 0)) {
                isDisabled = true;
            }
            return isDisabled;
        },
        companyContactWithCompanyNameAtStart() {
            let companyContactOptions = [];
            if (this.form.company_contacts.length > 0) {
                // Create a completely independent copy of the array and its objects
                // let tempOptions = this.form.company_contacts.map(option => JSON.parse(JSON.stringify(option)));
                this.form.company_contacts.forEach(item => {
                    if (item && item.company_name && !item.is_residential_company) {
                        item.name = item.company_name + ' - '+item.name;
                    }
                });

                // companyContactOptions = tempOptions;
            }
            return this.form.company_contacts;
        },
    },

    methods: {
        companyAddCheck(val){
                this.form_changed = val;
        },
        handleFormChanges(newVal, oldVal) {
            if(oldVal !== "" && newVal !=="") {
                // console.log('0000000000000000000000000000000000000000000000000000', !isEqual(oldVal, newVal));
                this.form_changed = true;
                window.onbeforeunload = (event) => {
                    console.log('event', event);
                    console.log('team', this.team);
                    if(this.team.id !== 118){
                        if (this.form_changed) {
                            event.returnValue = 'You have unsaved changes. Are you sure you want to leave this page?';
                        }
                    }
                }
            }
        },
        shareLinkedin() {
            this.isActiveShareButton = true;
            this.formLinkedin.post(route('api.project.post.share.linkedin')).then((resp) => {
                this.isActiveShareButton = false;
                if (resp.status) {
                    this.getToast().fire({
                        type: 'success',
                        title: resp.message
                    });
                } else {
                    this.getToast().fire({
                        type: 'error',
                        title: resp.message
                    });
                }
                $("#projectShareLinkedIn").modal("hide");
                setTimeout(() => {
                    window.location.reload(true);
                }, 2000);
            }).catch((error) => {
                this.isActiveShareButton = false;
                console.log('error', error);
            });

        },
        debounceFilterDataForma: _.debounce(function (e) {
            const self = this;
            let payload = {
                select_object: self.selectedDFObject,
                search: e.target.value ? e.target.value : ""
            }
            self.dataforma_search_result = [];
            self.dataformaTableLoader = true
            if (e.target.value) {
                axios.post(route('api.dataforma.pull_data'), payload).then(response => {
                    if (!response.status){
                        this.getToast().fire({
                            type: 'error',
                            title: 'Action failed. Try re-generation and updating the API key'
                        });
                    }
                    self.dataformaTableLoader = false
                    self.dataforma_search_result = response.data.pull_data

                }).catch((error) => {
                    self.dataformaTableLoader = false
                    self.dataforma_search_result = []
                    this.getToast().fire({
                        type: 'error',
                        title: 'Action failed. Try re-generation and updating the API key'
                    });
                });
            } else {
                self.dataformaTableLoader = false
                self.dataforma_search_result = []
            }

        }, 600),
        selectDFProject(current_checkbox) {
            const self = this;
            let checkboxes = document.getElementsByName('dfProject')
            let path = current_checkbox.path || current_checkbox.composedPath()
            checkboxes.forEach((item) => {
                if (item !== path[0]) item.checked = false
            })
            self.pullDataError = ''
            if (path[0].checked) {
                self.selectedDFProject = path[0].value
            } else {
                self.selectedDFProject = ''
            }
        },
        selectDFOption(current_checkbox) {
            const self = this;
            self.selectedDFObject = ''
            self.dataforma_search = null
            self.selectedDFCompanyForContact = null
            self.dfObjectExist = ''
            self.pullDataError = ''
            self.dfErrors = [];
            self.createdSelectedDFOptions = '';
            self.dataformaType = '';
            self.selectedDFCompany = [];
            self.dataforma_search_result = [];
            let checkboxes = document.getElementsByName('dfOption')
            console.log(checkboxes);
            let path = current_checkbox.path || current_checkbox.composedPath()
            checkboxes.forEach((item) => {
                if (item !== path[0]) item.checked = false
            })
            if (path[0].checked) {
                self.selectedDFOption = path[0].value
            } else {
                self.selectedDFOption = ''
            }
            let dfObjects = document.getElementsByName('dfObject')
            dfObjects.forEach((item) => {
                item.checked = false
            })
        },
        selectDFObject(current_checkbox) {
            const self = this;
            self.dfObjectExist = ''
            self.pullDataError = ''
            self.dataforma_search = null
            self.selectedDFCompanyForContact = null
            self.dfErrors = [];
            self.selectedDFCompany = [];
            self.dataforma_search_result = [];
            let checkboxes = document.getElementsByName('dfObject')
            let path = current_checkbox.path || current_checkbox.composedPath()
            checkboxes.forEach((item) => {
                if (item !== path[0]) item.checked = false
            })
            if (path[0].checked) {
                self.selectedDFObject = path[0].value
            } else {
                self.selectedDFObject = ''
            }
        },
        getDataFormaTypes() {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            const self = this;
            let payload = {
                dataFormaTypes: self.createdSelectedDFOptions,
                projectId: self.project.id,
                dataforma_building_id: self.dataforma_building_id,
                dataforma_client_id: self.dataforma_client_id,
                dataforma_contact_id: self.dataforma_contact_id,
                name: self.form.name,
                address: self.form.address,
                city: self.form.city,
                state: self.form.state,
                zip: self.form.zip,
                lat: self.form.lat,
                lng: self.form.lng,
                project_google_image: self.form.project_google_image,
                office_id: self.form.office_id,
                contact_name: self.form.contact_name,
                contact_email: self.form.contact_email,
                contact_cell: self.form.contact_cell,
                contact_phone: self.form.contact_phone,
                contact_fax: self.form.contact_fax,
                dataforma_type_id: self.dataformaType,
            }
            axios.post(route('api.dataforma.get_types'), payload).then(response => {
                if (!response.status){
                    self.getToast().fire({
                        type: 'error',
                        title: 'Action failed. Try re-generation and updating the API key'
                    });
                }
                if (response.data.data.types){
                    console.log('response.data.data.types', response.data.data.types)
                    self.getDataformaTypesLoader = false;
                    self.dataforma_all_types = response.data.data.types
                }else {
                    self.getToast().fire({
                        type: 'error',
                        title: 'Action failed. Try re-generation and updating the API key'
                    });
                }

            }).catch(err => {
                Toast.fire({
                    type: 'error',
                    title: err.response.data.message
                });
            })
        },
        createDataForma(exist_project) {
            const self = this;
            self.dataformaLoader = true;
            if (!exist_project) {
                self.dfObjectExist = '';
                // for (let i = 0; i < self.createdSelectedDFOptions.length; i++) {
                    if (self.createdSelectedDFOptions === 'building') {
                        if (self.dataforma_building_id !== 0) {
                            if (self.dfObjectExist === '') {
                                self.dfObjectExist = self.createdSelectedDFOptions + ' already exists in DataForma'
                            } else {
                                self.dfObjectExist = self.dfObjectExist + '<br/> <span class="ml-2 mt-2 text-capitalize">' + self.createdSelectedDFOptions + ' already exists in DataForma </span>'
                            }
                        }
                    }
                    if (self.createdSelectedDFOptions === 'company') {
                        if (self.dataforma_client_id !== 0) {
                            if (self.dfObjectExist === '') {
                                self.dfObjectExist = self.createdSelectedDFOptions + ' already exists in DataForma'
                            } else {
                                self.dfObjectExist = self.dfObjectExist + '<br/> <span class="ml-2 mt-2 text-capitalize">' + self.createdSelectedDFOptions + ' already exists in DataForma </span>'
                            }
                        }
                    }
                    if (self.createdSelectedDFOptions === 'contact') {
                        if (self.dataforma_contact_id !== 0) {
                            if (self.dfObjectExist === '') {
                                self.dfObjectExist = self.createdSelectedDFOptions + ' already exists in DataForma'
                            } else {
                                self.dfObjectExist = self.dfObjectExist + '<br/> <span class="ml-2 mt-2 text-capitalize">' + self.createdSelectedDFOptions + ' already exists in DataForma </span>'
                            }
                        }
                    }
                // }
                if (self.dfObjectExist !== '') {
                    self.dataformaLoader = false;
                    return false;
                }
            }
            self.saveCreateDataforma();
        },

        saveCreateDataforma() {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            const self = this;
            let payload = {
                dataFormaTypes: self.createdSelectedDFOptions,
                projectId: self.project.id,
                dataforma_building_id: self.dataforma_building_id,
                dataforma_client_id: self.dataforma_client_id,
                dataforma_contact_id: self.dataforma_contact_id,
                name: self.form.name,
                address: self.form.address,
                city: self.form.city,
                state: self.form.state,
                zip: self.form.zip,
                lat: self.form.lat,
                lng: self.form.lng,
                project_google_image: self.form.project_google_image,
                office_id: self.form.office_id,
                contact_name: self.form.contact_name,
                contact_email: self.form.contact_email,
                contact_cell: self.form.contact_cell,
                contact_phone: self.form.contact_phone,
                contact_fax: self.form.contact_fax,
                dataforma_type_id: self.dataformaType,
            }
            axios.post(route('api.dataforma.create'), payload).then(response => {
                self.dataformaLoader = false;
                self.dfObjectExist = '';
                if (!response.status){
                    this.getToast().fire({
                        type: 'error',
                        title: 'Action failed. Try re-generation and updating the API key'
                    });
                }
                let createResponse = response.data.data;
                for (let i = 0; i < createResponse.length; i++) {
                    if (createResponse[i].type === 'contact') {
                        if (createResponse[i].status) {
                            self.dataforma_contact_id = createResponse[i].contactId
                        } else {
                            let err = createResponse[i].errors.messages;
                            self.pushErrorArray(err);
                        }
                    }
                    if (createResponse[i].type === 'company') {
                        if (createResponse[i].status) {
                            self.dataforma_client_id = createResponse[i].clientId
                        } else {
                            let err = createResponse[i].errors.messages;
                            self.pushErrorArray(err);
                        }
                    }
                    if (createResponse[i].type === 'building') {
                        if (createResponse[i].status) {
                            self.dataforma_building_id = createResponse[i].buildingId
                        } else {
                            let err = createResponse[i].errors.messages;
                            self.pushErrorArray(err);
                        }
                    }

                }
                if(createResponse.status  && createResponse.emailMatched){
                    Toast.fire({
                        type: 'error',
                        title: createResponse.message
                    });
                }else{
                    if (self.dfErrors.length === 0) {
                        self.closeDataFormaModal()
                        Toast.fire({
                            type: 'success',
                            title: 'Dataforma Record Created Successfully'
                        });
                    }
                }
            }).catch(err => {
                self.dataformaLoader = false;
                Toast.fire({
                    type: 'error',
                    title: err.response.data.message
                });
            })
        },
        changeDFOption(current_radio) {
            this.dfObjectExist = ''
            this.getDataformaTypesLoader = true;
            this.dataformaType = '';
            this.createdSelectedDFOptions = current_radio.target.value;
            this.getDataFormaTypes();

        },
        pushErrorArray(err) {
            const self = this;
            for (let i = 0; i < err.length; i++) {
                if (err[i] !== 'LAST_NAME: cannot be blank') {
                    self.dfErrors.push(err[i]);
                }
            }
        },
        pullDataForma(typeOfPull) {
            let self = this;
            self.saveDataformaLoader = true;
            self.pullDataError = ''
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            if (typeOfPull === 'building') {
                let selProject = ''
                let checkboxes = document.getElementsByName('dfProject')
                checkboxes.forEach((item) => {
                    if (item.checked) {
                        selProject = item.value
                    }
                })
                if (selProject === '') {
                    self.pullDataError = 'Please select any building'
                    self.saveDataformaLoader = false;
                    return false
                }
                let payload = {
                    pullType: typeOfPull,
                    projectId: self.project.id,
                    selProject: selProject
                }
                axios.post(route('api.dataforma.create-pull-data'), payload).then(response => {
                    self.saveDataformaLoader = false;
                    self.closeDataFormaModal();
                    self.form.address = response.data.project.address
                    self.form.city = response.data.project.city
                    self.form.state = response.data.project.state
                    self.form.zip = response.data.project.zip
                    Toast.fire({
                        type: 'success',
                        title: response.data.message
                    });

                }).catch(err => {
                    self.saveDataformaLoader = false;
                    console.log('err', err.response.data)
                    Toast.fire({
                        type: 'error',
                        title: err.response.data.message
                    });
                })
            }
            if (typeOfPull === 'company') {
                if (self.selectedDFCompany.length === 0) {
                    self.pullDataError = 'Please select any Company'
                    self.saveDataformaLoader = false;
                    return false
                }
                let payload = {
                    pullType: typeOfPull,
                    projectId: self.project.id,
                    selCompany: self.selectedDFCompany
                }
                axios.post(route('api.dataforma.create-pull-data'), payload).then(response => {
                    self.saveDataformaLoader = false;
                    self.closeDataFormaModal();
                    Toast.fire({
                        type: 'success',
                        title: response.data.message
                    });

                }).catch(err => {
                    // self.saveDataformaLoader = false;
                    console.log('err', err.response.data)
                    Toast.fire({
                        type: 'error',
                        title: err.response.data.message
                    });
                })
            }
            if (typeOfPull === 'contact') {
                if (self.selectedDFCompanyForContact === null) {
                    self.pullDataError = 'Please select any Company'
                    self.saveDataformaLoader = false;
                    return false
                }
                self.pullDataError = ''
                if (self.selectedDFContact.length === 0) {
                    self.pullDataError = 'Please select any Contact'
                    self.saveDataformaLoader = false;
                    return false
                }
                let payload = {
                    pullType: typeOfPull,
                    projectId: self.project.id,
                    companyId: self.selectedDFCompanyForContact,
                    selContacts: self.selectedDFContact
                }
                axios.post(route('api.dataforma.create-pull-data'), payload).then(response => {
                    self.saveDataformaLoader = false;
                    self.closeDataFormaModal();
                    Toast.fire({
                        type: 'success',
                        title: response.data.message
                    });
                    let projectContact = response.data.projectContact
                    if (projectContact) {
                        self.form.contact_name = projectContact.name;
                        self.form.contact_phone = projectContact.cell;
                        self.form.contact_email = projectContact.email;
                        self.form.contact_company_id = projectContact.company_id;
                    }
                    if (response.data.project.company_contacts.length > 0) {
                        self.form.company_contacts = response.data.companyContact;
                    }

                }).catch(err => {
                    self.saveDataformaLoader = false;
                    Toast.fire({
                        type: 'error',
                        title: err.response.data.message
                    });
                })
            }
        },
        saveEmailProject() {
            axios.post(route('api.project.email'), {
                project: this.project.id,
                email: this.form.contact_email
            }).then((response) => {
                console.log('response', response);

            }).catch(error => {
                console.log('error', error);
            });
        },

        initAutocomplete() {
            let input = document.getElementById('searchTextField');
            autocomplete = new google.maps.places.Autocomplete(input, {
                componentRestrictions: {
                    country: ['us','ca']
                }
            });

            google.maps.event.addListener(autocomplete, 'place_changed', this.getAddressComponents);
        },
        getAddressComponents() {
            let placeResultData = autocomplete.getPlace();
            this.form.lat = placeResultData.geometry.location.lat();
            this.form.lng = placeResultData.geometry.location.lng();
            this.form.zip = '';
            this.form.city = '';
            this.form.state = '';
            this.form.project_google_image = '';
            var mapOptions = {
                center: new google.maps.LatLng(this.form.lat, this.form.lng),
                zoom: 12,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };
            var photos = placeResultData.photos;
            placeResultData.address_components.map(res => {
                if (res.types[0] === 'postal_code') {
                    this.form.zip = res.short_name;
                }
                if (res.types[0] === 'locality') {
                    this.form.city = res.short_name;
                }
                if (res.types[0] === 'administrative_area_level_1') {
                    this.form.state = res.short_name;
                }
            });
            this.form.address = placeResultData.name;
            this.address = placeResultData.name

            if (photos) {
                this.form.project_google_image = photos[0].getUrl();
            } else {
                this.export(mapOptions);
            }
        },

        getAddress: function (addressData) {
            if (addressData.newVal === "") {
                this.form.state = '';
                this.form.city = '';
                this.form.zip = '';
            }
            this.address = addressData;
            const shortAddress = addressData.newVal.split(",");
            this.form.address = shortAddress[0];
        },

        export(mapOptions) {
            var staticMapUrl = "https://maps.googleapis.com/maps/api/staticmap";
            staticMapUrl += "?center=" + mapOptions.center.lat() + "," + mapOptions.center.lng();
            staticMapUrl += "&size=640x440";
            staticMapUrl += "&zoom=" + mapOptions.zoom;
            staticMapUrl += "&maptype=" + mapOptions.mapTypeId;
            staticMapUrl += "&markers=color:red%7C" + this.form.address.replace(/\s+/g, "+");
            staticMapUrl += "&key=AIzaSyC5C-qX6oo7TeQGsCWasvGgJvU5evBBpPg";
            this.form.project_google_image = staticMapUrl;
        },

        changeCustomField() {
            const vue = this;
            if (this.form_changed) {
                window.onbeforeunload = function (event) {
                    if (vue.form_changed) {
                        event.returnValue = false;
                    }
                };
            } else {
                this.form_changed = true
            }
        },
        loadPhone(phone) {
            if (!phone) {
                return phone;
            }

            // if (this.masks.v_mask_phone && this.masks.v_mask_phone.length > 0) {
            //     return phone.replace(/\D/g, '');
            // }

            return phone;
        },

        initForm(project) {
            this.formLinkedin.project_google_image = project.project_google_image ? project.project_google_image :'';
            this.formLinkedin.name = project.name ? project.name :'';
            this.formLinkedin.address = project.address ? project.address :'';
            this.change_orders = project.change_orders ? this.setProjectChangeOrders(project.change_orders) : this.change_orders;
            if(project.tenant_id !== null && project.bid_id !== null){
                this.edgeEstimateUrl = 'https://admin.edgeestimator.com/BidScenarios/Index/'+project.tenant_id+'?bidId='+project.bid_id;
            }
            this.$nextTick(() => {
                this.$refs.ProjectCompanyInformation.setContactStatusWonORLostDisabled(project.company_contacts);
            });
            return new Form({
                company_contacts: project.company_contacts,
                name: project.name,
                bid_bond: project.bid_bond || false,
                address: project.address,
                city: project.city,
                state: project.state,
                zip: project.zip,
                lat: project.lat ? project.lat : '',
                lng: project.lng ? project.lng : '',
                project_google_image: project.project_google_image ? project.project_google_image : '',
                contact_name: project.contact ? project.contact.name : '',
                contact_email: project.contact ? project.contact.email : '',
                contact_phone: project.contact ? this.loadPhone(project.contact.phone) : '',
                contact_cell: project.contact && project.contact.cell ? this.loadPhone(project.contact.cell) : '',
                contact_fax: project.contact && project.contact.fax ? this.loadPhone(project.contact.fax) : '',
                relate_and_connect_id: project.relate_and_connect,
                rules_of_engagement_id: project.rules_of_engagement,
                find_problems_id: project.find_problems,
                money_step_id: project.money_step,
                decision_process_id: project.decision_process,
                base_bid: this.baseBidPriceProject(this.selectedEstimate, project),
                base_bid_total: project.base_bid_total ? Number(project.base_bid_total.split(',').join('')) : this.selectedEstimate ? Number(this.selectedEstimate.selling_price) : null,
                contract_amount: project.contract_amount ? Number(project.contract_amount.split(',').join('')) : null,
                contract_amount_total: project.contract_amount_total ? Number(project.contract_amount_total.split(',').join('')) : null,
                estimated_contract_date: project.estimated_contract_date ? moment(project.estimated_contract_date, this.masks.moment_mask).format() : null,
                contract_date: project.contract_date ? moment(project.contract_date, this.masks.moment_mask).format() : null,
                gross_margin_percentage: project.gross_margin_percentage ? Number(project.gross_margin_percentage.split(',').join('')) : this.selectedEstimate ? this.getGrossMarginPercentage : null,
                labor_hours: project.labor_hours ? Number(project.labor_hours.split(',').join('')) : null,
                sales_status_id: project.sales_status,
                marketing_status_id: project.marketing_status,
                pre_bid: project.pre_bid ? moment(project.pre_bid, this.masks.moment_mask).format() : null,
                bid_date: project.bid_date ? moment(project.bid_date, this.masks.moment_mask).format('YYYY-MM-DD') : null,
                created_at: project.created_at ? moment(project.created_at, this.masks.moment_mask).format() : null,
                dead_date: project.dead_date ? moment(project.dead_date, this.masks.moment_mask).format('YYYY-MM-DD') : null,
                lead_from_id: project.lead_from,
                estimator_id: project.estimator,
                account_manager_id: project.account_manager,
                take_off_person_id: project.take_off_person,
                products_and_services_id: project.products_and_services,
                client_profile_id: project.client_profile,
                contract_type_id: project.contract_type,
                office_id: project.office,
                sales_behaviors: project.sales_behaviors.map(sb => {
                    if (this.hasCalendarAccess) {
                        if (sb.end_date != null) {
                            return {...sb, end_date: sb.end_date ? sb.end_date : null}
                        } else {
                            return {...sb, date: sb.date ? sb.date : ''}
                        }
                    } else {
                        //console.log('else called', moment(sb.date).format('YYYY-MM-DD'));
                        return {...sb, date: moment(sb.date).format('YYYY-MM-DD') ? sb.date : ''}
                    }
                }),
                custom_fields: [],
                login_date: project.login_date ? moment(project.login_date, this.masks.moment_mask).format() : null,
                hail_impact: project.hail_impact,
                related_projects: project.related_projects,
                deleted_related_projects: [],
                contact_company_id:project.contact ? project.contact.company_id : '',
                change_orders:this.change_orders,
                base_bid_update:project.base_bid_update,
                has_comment_on_in_sales_behavior:project.has_comment_on_in_sales_behavior,
                xscope_project_id: project.xscope_project_id,
                check_contact_in_address_book: project.check_contact_in_address_book,
                userTimeZoneName: null,
                userTimeZoneOffset: null,
                foundationContactSelectedContact: project.foundation_synced_customer_no,
                cost_code: (project.cost_code)? project.cost_code:0,
                complete_percentage: (project.complete_percentage)? project.complete_percentage:null,
                sageIntacctContactSelectedContact: project.sage_intacct_contact_id,
                recordDetailCustomFieldForm: null,
                recordDetailCustomFields: []
            });
        },

        baseBidPriceProject(selectedEstimate, project) {
            let price = null;
            if (project.base_bid_update === 1 && this.selectedEstimate) {
                price = project.base_bid ? Number(project.base_bid.split(',').join('')) : null;
            }
            if (project.base_bid && !this.selectedEstimate) {
                price = project.base_bid ? Number(project.base_bid.split(',').join('')) : null;
            }

            if (this.selectedEstimate && project.base_bid_update === 0) {
                price = this.selectedEstimate ? Number(this.selectedEstimate.selling_price) : null;
            }

            return price;
        },

        baseBidUpdate(event) {
            if (this.selectedEstimate) {
                if (this.project.base_bid !== event && this.selectedEstimate.selling_price !== event) {
                    this.form.base_bid_update = 1;
                }
            }
        },

        fetchCompanies(newCompany = null) {
            axios.get(route('api.project.companies')).then(({data}) => {
                this.allCompanies = data.data;

                if (newCompany) this.handleNewCompany(newCompany);
            })
        },

        fetchProjects() {
            axios.get(route('api.project.projects')).then(({data}) => {
                this.allProjects = data.data.filter(x => this.project.id !== x.id);
            })
        },

        fetchContacts() {
            if (this.selectedCompany) {
                axios.get(route('api.project.company-contacts', {
                    project: this.project.id,
                    company: this.selectedCompany.id
                })).then(({data}) => {
                    this.contacts = data.data;
                });
            } else {
                this.contacts = [];
            }
        },

        fetchTeamUsers() {
            axios.get(route('api.team-users')).then(({data}) => {
                this.users = data.filter((m) => (m.pivot.active && m.is_registered));
            })
        },

        getContactTypes() {
            let self = this;
            axios.get(route('api.settings.codes.contact-type.index')).then(({data}) => {
                self.all_contact_types = data;
                if(!self.isContactResidentialActive){
                    self.all_contact_types = data.filter(contactType => contactType.is_residential !== 1)
                }

                self.residential_contact_type = _.find(data, ['is_residential', 1]);
                self.contact_type_options = data.filter(x => !x.is_residential);
                self.contact_type_options.push({id: null, code: ""});
                self.all_contact_types.push({id: null, code: ""});
            });
        },

        goToPage(page) {
            this.page = page;
            this.fetchData();
        },
         fetchData() {
            let params = {
                filter: this.filter,
                page: this.page
            };
            this.searchContactsLoader = true;

            axios.get(route('api.contact.getAllCompaniesContacts'),{params}).then((data) => {
                this.searchContactsLoader = false;
                this.searchContacts = data.data.data;
                this.pagination = data;
            }).catch(error => {
                this.searchContactsLoader = false;
            });
        },

        debounceFilter: _.debounce(function (e) {
            if($('#contact_name').val().length == 0){
                this.form.contact_company_id = '';
            }
            this.filter = e.target.value;

            this.goToPage(1)
        }, 700),

        focusOn(){
             document.getElementById("searchContacts_list").style.display = "block";

        },
        focusOut(){
            var contactName = $('#contact_name').val();
            if(contactName == "" || contactName == null || contactName == undefined){
                document.getElementById("searchContacts_list").style.display = "none";
            }
        },

        populateContacts(contact) {
            if (this.form.contact_email) {
                if (this.contact) {
                    if (this.form.contact_email !== this.contact.email) {
                        this.removeCompanyContact(this.form.contact_email)
                    }
                } else {
                    this.removeCompanyContact(this.form.contact_email)
                }
            }
            this.form.contact_name = contact.name
            this.form.contact_email = contact.email
            this.form.contact_cell = contact.cell
            this.form.contact_company_id = contact.company.id;
            contact.id = contact.company_contact_id;
            if(!this.$refs.ProjectCompanyInformation.checkContactAlreadyExists(contact.id, contact.company_id)) {
                this.$refs.ProjectCompanyInformation.addContact(contact, true);
            }
            document.getElementById("searchContacts_list").style.display = "none";

        },

        focusOutOnBlur(){
            $("body").click(function(e) {
                if (e.target.id == "searchContacts_list" || $(e.target).parents("#searchContacts_list").length) {

                    // this.populateContacts(contact);
                } else {
                    document.getElementById("searchContacts_list").style.display = "none";

                }
            });
        },

        fetchCodes() {
            axios.get(route('api.project.codes')).then(({data}) => {
                this.selects = data;
                this.usersForContact = this.selects.users;
                this.$nextTick(() => {
                   Bus.$emit('updateEmailTemplateFields', true);
                });
            });
        },

        fetchCommentsRecursive() {
            // this.$refs.projectcomments.fetchComments();
        },

        saved(savedByComment = false, foundationAction = 'update', sageIntacctAction = 'update') {
            this.foundationSyncAction = foundationAction;
            this.sageIntacctSyncAction = sageIntacctAction;

            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            this.form.login_date = this.form.login_date == 'Invalid date' ? null : this.form.login_date;
            this.form.estimated_contract_date = this.form.estimated_contract_date == 'Invalid date' ? null : this.form.estimated_contract_date;
            this.form.contract_date = this.form.contract_date == 'Invalid date' ? null : this.form.contract_date;
            this.form.custom_fields = this.getCustomField();
            this.form.recordDetailCustomFields = this.$refs.ProjectRecordDetailCustomFields.getCustomFieldForm();

            if (this.checkValidations === true) {
                this.form.post(route('api.project.check-validations')).then((response) => {
                    this.checkValidations = false;
                    this.saveAfterValidationsCheck(savedByComment, foundationAction,sageIntacctAction)
                }).catch((err) => {
                    this.savingProject = false;
                    this.checkValidations = true;
                });
            } else {
                this.saveAfterValidationsCheck(savedByComment, foundationAction,sageIntacctAction)
            }

        },
        checkCompanyContactStatus() {
            this.companyWonStatusRequired = null;
            const salesStatus = this.getSalesStatus(this.form.sales_status_id);

            if (salesStatus && salesStatus.contract) {
                // if (this.form.company_contacts.length === 0) {
                //     this.companyWonStatusRequired = 'Please add company contact to project';
                //     this.getToast(2000).fire({
                //         type: 'error',
                //         title: 'Please add company contact to project'
                //     });
                //     return false;
                // }

                const wonCompanyContacts = this.form.company_contacts.filter(company_contact => company_contact.status === 'won');
                console.log('wonCompanyContacts', wonCompanyContacts);
                console.log('form', this.form.company_contacts);
                if (this.form.company_contacts.length > 0 && wonCompanyContacts.length === 0) {
                    this.companyWonStatusRequired = 'Please select the company contact who won the project';
                    this.getToast(2000).fire({
                        type: 'error',
                        title: 'Please select the company contact who won the project'
                    });
                    return false;
                }

              /*  if (this.form.company_contacts.length === 1) {
                    this.form.company_contacts[0].status = 'won';
                }*/

                this.companyWonStatusRequired = null;
                return true;
            } else if (salesStatus && salesStatus.dead) {
                this.form.company_contacts.forEach(company_contact => {
                    if (company_contact.status !== "lost-gc-awarded" && company_contact.status !== "lost-gc-not-awarded") {
                        company_contact.status = "lost";
                    }
                });

                this.companyWonStatusRequired = null;
                return true;
            }

            return true;
        },
        resetCompanyContactStatusValidation() {
            this.companyWonStatusRequired = null;
        },
        saveAfterValidationsCheck(savedByComment, foundationAction,sageIntacctAction) {

            // if(this.isValidateRequiredField.isRequired || this.isValidateRequiredField.isContractAmountRequired){
            //     return false;
            // }

            const isCompanyStatusRequired = this.checkCompanyContactStatus();
            if(!isCompanyStatusRequired){
                return false;
            }

            if (this.isValidateRequiredField.isContractAmountRequired) {
                this.xScopeLoading = false;
                return false;
            }

            if(this.changeOrderKey && this.change_orders && this.change_orders.length > 0){

                for (let index = 0; index < this.change_orders.length; index++) {
                    const key = `change_order_contract_amount${index}`;
                    const dateKey = `change_order_contract_date${index}`;

                    const changeOrder = this.change_orders[index];
                    const salesStatus = this.getSalesStatus(changeOrder.sales_status_id);
                    if(salesStatus && salesStatus.contract) {
                        if(!changeOrder.contract_date) {
                            this.$set(this.customErrors, dateKey, 'The contract date field is required');

                        }
                    }

                    if (this.customErrors[key] || this.customErrors[dateKey]) {
                        return false;
                    }
                }
            }

            // if (this.foundationContactSyncAccess && (foundationAction === 'create' || foundationAction === 'update')) {
            //     const salesStatus = this.getSalesStatus(this.form.sales_status_id);
            //     if (this.form.company_contacts.length === 0 && salesStatus !== undefined && salesStatus !== null && salesStatus.contract) {
            //         this.getToast(4000).fire({
            //             type: 'error',
            //             title: 'Please add a contact to the project before saving the sales status to Contract'
            //         });
            //         this.foundationLoading = false;
            //         return false;
            //     }
            // }
            // if (this.sageIntacctContactSyncAccess && (sageIntacctAction === 'create' || sageIntacctAction === 'update') && this.form.sageIntacctContactSelectedContact == null) {
            //     const salesStatus = this.getSalesStatus(this.form.sales_status_id);
            //     if (this.form.company_contacts.length === 0 && salesStatus !== undefined && salesStatus !== null && salesStatus.contract) {
            //         this.getToast(4000).fire({
            //             type: 'error',
            //             title: 'Please add a contact to the project before saving the sales status to Contract'
            //         });
            //         this.foundationLoading = false;
            //         return false;
            //     }
            //     if (this.form.sageIntacctContactSelectedContact == null && salesStatus !== undefined && salesStatus !== null && salesStatus.contract){
            //         this.getToast(4000).fire({
            //             type: 'error',
            //             title: 'Please select a contact to the project before saving the sales status to Contract'
            //         });
            //         this.foundationLoading = false;
            //         return false;
            //     }
            // }

            if (this.foundationContactSyncAccess && (foundationAction === 'create' || foundationAction === 'update')) {
                this.$refs.CustomFields.validateProjectManagerCustomField(this.foundationSyncAction);
                if (this.$refs.CustomFields.isRequiredProjectManagerCustomField) {
                    this.getToast(4000).fire({
                        type: 'error',
                        title: 'Please select a <Foundation >Project Manager and try again'
                    });
                    this.foundationLoading = false;
                    return false;
                }
            }

            // if(this.validateProposalDeliveredSalesBehaviorChecked()) {
            //     return false;
            // }

            this.validateCompanyContactStatus();

            if (this.isValidateRequiredField.isCompanyContactStatusRequired) {
                this.xScopeLoading = false;
                this.getToast(5000).fire({
                    type: 'error',
                    title: "Please update empty status of company contact"
                });
                this.foundationLoading = false;
                return false;
            }

            const salesStatus = this.checkIfProjectNeedsCommentBySalesStatus();

            if (salesStatus && !savedByComment) {
                this.sales_status = salesStatus;
                if (this.checkCommentStatus == 0) {
                    this.addComment();
                    // this.checkCommentStatus = 1;
                }
                return false;
            }

            let self = this;
            this.form.change_orders = this.change_orders;

            // this.form.post(route('api.project-contacts.check', {project: this.project.id})).then((response) => {
            //     if(response.status == 'error'){
            //         Swal.fire({
            //             title: 'Project Contact Already Exist',
            //             text: "Do you want to create a duplicate contact",
            //             type: 'warning',
            //             showCancelButton: true,
            //             confirmButtonColor: '#01B1AF',
            //             confirmButtonText: 'Continue creating!'
            //         }).then((result) => {
            //             if (result.value) {
            //                 this.savedAfterCheck();
            //             }else{
            //                 return false;
            //             }
            //         });
            //     }else{
            if (this.contactToAddressBook && this.form.check_contact_in_address_book) {
                this.checkContactInAddressBook(this.form.contact_email, this.form.contact_cell)
            } else {
                this.savedAfterCheck();
            }
            // this.savedAfterCheck();
            //     }
            // });
        },

        destroy() {
            let self = this;
            Swal.fire({
                title: "Are you sure?",
                text: "Once deleted, you will not be able to recover this project!",
                icon: "warning",
                buttons: true,
                showCancelButton: true,
                confirmButtonColor: 'red',
                confirmButtonText: 'I\'m sure!',
                closeOnConfirm: true,
                closeOnCancel: true,
            }).then(result => {
                if (result.value) {
                    axios.delete(route('api.project.destroy', self.project.id)).then(() => {
                            window.location = '/project'
                        }
                    )
                }
            });
        },

        openGenerateProposalModal() {
            $("#generateProposalModal").modal("show");
        },

        openCompanyCamModal() {
            $("#companyCamModal").modal("show");
            this.CompanyCamGetProjects();
        },
        checkProjectExistComapnyCam() {
            let companyCamProject = _.find(this.allCompanyCamProjects, {'name': this.project.name, 'status': 'active'});
            if (typeof companyCamProject !== "undefined") {
                this.projectExistComapnyCam = false
            }
        },
        openDataFormaModal() {
            $("#generateDataFormaModal").modal("show");
        },

        showDataFormaModal() {
            this.showDataformaModal = true
        },
        closeDataFormaModal() {
            this.showDataformaModal = false
            this.selectedDFOption = ''
            this.selectedDFObject = ''
            this.pullDataError = ''
            this.dfObjectExist = ''
            this.dataforma_search = null
            this.selectedDFCompanyForContact = null
            this.dataformaLoader = false;
            this.saveDataformaLoader = false;
            this.getDataformaTypesLoader = false;
            this.dataformaType = '';
            this.dfErrors = [];
            this.dataforma_search_result = [];
            this.selectedDFCompany = [];
        },

        generateProposal() {
            let type = 'company_contact';
            if (this.selectedContactForProposalGenerator.id === this.project.contact.id && this.selectedContactForProposalGenerator.type === "project_contact") {
                type = 'project_contact';
            }

            window.location = route('proposal-generator.create', {
                project: this.project,
                contact: this.selectedContactForProposalGenerator.id,
                type: type,
                company: this.selectedContactForProposalGenerator.company_id ?? '',
            });
        },

        generateDataForma() {
            let self = this;
            if (this.project.dataforma_client_id !== 0 && this.selectedDataForma.code === 'createClient') {
                Swal.fire({
                    text: "Address Already Exist in DataForma!",
                    icon: "warning",
                    buttons: true,
                    showCancelButton: true,
                    confirmButtonColor: '#01b1af',
                    confirmButtonText: 'Continue',
                    closeOnConfirm: true,
                    closeOnCancel: true,
                }).then(result => {
                    //console.log('result', result);
                    if (result.value) {
                        this.dataFormaApiCall();
                    }
                });
            } else if (this.project.dataforma_building_id !== 0 && this.selectedDataForma.code === 'createBuilding') {
                Swal.fire({
                    text: "Address Already Exist in DataForma!",
                    icon: "warning",
                    buttons: true,
                    showCancelButton: true,
                    confirmButtonColor: '#01b1af',
                    confirmButtonText: 'Continue',
                    closeOnConfirm: true,
                    closeOnCancel: true,
                }).then(result => {
                    //console.log('result', result);
                    if (result.value) {
                        if (this.form.address !== "" && this.form.city !== "") {
                            this.dataFormaApiCall();
                        } else {
                            Swal.fire({
                                icon: 'error',
                                title: 'Fields Required',
                                text: 'Address , city are required for creating building',
                            });
                        }
                    }
                });
            } else {
                //console.log('address', this.form.address);
                if (this.selectedDataForma.code === 'createBuilding') {
                    if (this.form.address !== null && this.form.city !== null) {
                        this.dataFormaApiCall();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Fields Required',
                            text: 'Address , city are required for creating building',
                        });
                    }
                } else {
                    this.dataFormaApiCall();
                }
            }
            $("#generateDataFormaModal").modal("hide");
        },
        dataFormaApiCall() {
            const dataFormaValue = this.selectedDataForma.code;
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            const dataFormaObj = {
                dataFormaType: dataFormaValue,
                projectId: this.project.id,
                dataforma_building_id: this.project.dataforma_building_id,
                dataforma_client_id: this.project.dataforma_client_id,
                name: this.form.name,
                address: this.form.address,
                city: this.form.city,
                state: this.form.state,
                zip: this.form.zip,
                office_id: this.form.office_id,
                contact_cell: this.form.contact_cell,
                contact_phone: this.form.contact_phone,
                contact_fax: this.form.contact_fax,
                dataforma_type_id: this.dataformaType,
            }
            axios.post(route('api.dataforma.create.client'), dataFormaObj).then(response => {
                //console.log('data', response);
                if (response.data.status) {
                    Toast.fire({
                        type: "success",
                        title: response.data.message
                    });
                    if (dataFormaValue === 'createClient') {
                        if (this.project.dataforma_client_id !== 0) {
                            this.viewDataFormaPath = `https://fcrm.dataforma.com/dflowslope/company_file.jsp?company_id=${this.project.dataforma_client_id}`
                        } else {
                            this.viewDataFormaPath = `https://fcrm.dataforma.com/dflowslope/company_file.jsp?company_id=${response.data.clientId.id}`
                        }
                        this.viewDataFormaFlag = true;
                    } else {
                        if (this.project.dataforma_building_id !== 0) {
                            this.viewDataFormaPath = `https://fcrm.dataforma.com/dflowslope/building_file.jsp?building_id=${this.project.dataforma_building_id}`
                        } else {
                            this.viewDataFormaPath = `https://fcrm.dataforma.com/dflowslope/building_file.jsp?building_id=${response.data.clientId.id}`
                        }
                        this.viewDataFormaFlag = true;
                    }
                } else {
                    Toast.fire({
                        type: "error",
                        title: response.data.message
                    });
                }
            }).catch((error) => {
                console.log('error', error);
            })
        },
        getStackURL() {
            const self = this;

            if (self.project.stack_project_id !== 0 && self.project.stack_project_direct_link !== null) {
                self.viewStackFlag = true;
                self.viewStackPath = self.project.stack_project_direct_link;
            } else {
                self.viewStackFlag = false;
                self.viewStackPath = null;
            }
        },
        getProcoreURL() {
            const self = this;
            if (self.project.procore_project_id !== 0) {
                self.viewProcoreFlag = true;
                let web_base_url = 'https://www.procore.com/';
                if (self.project.procore_web_base_url) {
                    web_base_url = self.project.procore_web_base_url;
                }
                let url = '';
                if (window.location.origin == 'https://app.followupcrm.com') {
                    url = web_base_url + '/' + self.project.procore_project_id + '/project/home'
                } else {
                    url = 'https://sandbox.procore.com/' + self.project.procore_project_id + '/project/home'
                }
                self.viewProcorePath = url;
            } else {
                self.viewProcoreFlag = false;
                self.viewProcorePath = null;
            }
        },
        getCompanyCamURL() {
            const self = this;
            if (self.project.company_cam_project_id !== 0 && self.project.company_cam_project_direct_link !== null) {
                self.viewCompanyCamFlag = true;
                self.viewCompanyCamPath = self.project.company_cam_project_direct_link;
                self.selectedCompanyCamProjectId = self.project.company_cam_project_id;
            } else {
                self.viewCompanyCamFlag = false;
                self.viewCompanyCamPath = null;
            }
        },
        createStack() {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            const self = this;
            if (!self.form.bid_date) {
                Toast.fire({
                    type: "error",
                    title: "Please add bid date then create in stack"
                });
                return
            }
            const stack = {
                projectId: self.project.id,
                bidDate: self.form.bid_date ? moment(self.form.bid_date).format('YYYY-MM-DD') : null
            }
            self.stackSaveLoading = true;
            axios.post(route('api.stack.create.project'), stack).then(response => {
                // console.log('data', response);
                self.stackSaveLoading = false;
                self.viewStackFlag = true;
                self.viewStackPath = response.data.projectDirectLink;
                Toast.fire({
                    type: "success",
                    title: response.data.message
                });
            }).catch(error => {
                self.stackSaveLoading = false;
                // console.log('error', error.response.data.message);
                Toast.fire({
                    type: "error",
                    title: error.response.data.message
                });
            })
        },
        addProcoreCompany(){
            window.location.href = '/settings#/integrations'
        },
        pushPocoreProject() {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
            });
            const self = this;
            if (self.user.procore_partner_selected_company == null){
                self.ProcoreSaveLoading = false;
                $("#procoreCompaniesModal").modal("show");
                return;
            }
            const procore = {
                projectId: self.project.id
            }
            self.ProcoreSaveLoading = true;
            axios.post(route('api.procore.create.project'), procore).then(response => {
                self.ProcoreSaveLoading = false;
                let url = '';
                if (response.data.status && response.data.status === true) {
                    if (window.location.origin == 'https://app.followupcrm.com') {
                        self.viewProcorePath = response.data.web_base_url + '/' + response.data.project_id + '/project/home'
                        self.viewProcoreFlag = true;
                    } else {
                        self.viewProcorePath = 'https://sandbox.procore.com/' + response.data.project_id + '/project/home'
                        self.viewProcoreFlag = true;
                    }
                    Toast.fire({
                        type: "success",
                        title: response.data.message
                    });
                }
                if (response.data.status === false) {
                    Toast.fire({
                        type: "error",
                        title: response.data.procore_error.errors.base[0]
                    });
                }

            }).catch(error => {
                self.ProcoreSaveLoading = false;
                // console.log('error', error.response.data.message);
                Toast.fire({
                    type: "error",
                    title: 'Something went wrong.!'
                });
            })
        },

        uploadPhotos() {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            const self = this;
            const payload = {
                projectId: self.project.id
            }
            self.companyCamSyncLoading = true;
            axios.post(route('api.company-cam.sync-photos.project'), payload).then(response => {
                self.companyCamSyncLoading = false;
                $("#companyCamModal").modal("hide");
                console.log('response', response)
                Toast.fire({
                    type: response.data.status,
                    title: response.data.message
                });
            }).catch(error => {
                // console.log('error', error.response.data.message);
                Toast.fire({
                    type: "error",
                    title: error.response.data.message
                });
            })
        },

        selectedCcProject(e) {
            let selProject = null
            let checkboxes = document.getElementsByName('CcProject')
            let path = e.path || e.composedPath()
            checkboxes.forEach((item) => {
                if (item !== path[0]) {
                    item.checked = false
                } else {
                    selProject = item.value
                }
            })
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            const self = this;
            const payload = {
                projectId: self.project.id,
                CcProjectId: selProject
            }
            self.companyCamSyncProjectLoading = true;
            axios.post(route('api.company-cam.sync.project'), payload).then(response => {
                self.companyCamSyncProjectLoading = false;
                self.viewCompanyCamFlag = true;
                if (response.data.project) {
                    self.viewCompanyCamPath = response.data.project.project_url;
                    self.selectedCompanyCamProjectId = response.data.project.id;
                } else {
                    self.viewCompanyCamPath = null;
                    self.selectedCompanyCamProjectId = null;
                }

                Toast.fire({
                    type: "success",
                    title: response.data.message
                });
            }).catch(error => {
                self.companyCamSyncProjectLoading = false;
                Toast.fire({
                    type: "error",
                    title: error.response.data.message
                });
            })
        },

        CompanyCamGetProjects() {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            const self = this;
            const payload = {
                projectId: self.project.id
            }
            self.companyCamSaveLoading = true;
            axios.post(route('api.company-cam.get.project'), payload).then(response => {
                self.companyCamSaveLoading = false;
                self.allCompanyCamProjects = response.data.projects;
                self.checkProjectExistComapnyCam();
            }).catch(error => {
                self.companyCamSaveLoading = false;
                // console.log('error', error.response.data.message);
                Toast.fire({
                    type: "error",
                    title: error.response.data.message
                });
            })
        },

        createCompanyCam() {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            const self = this;
            const payload = {
                projectId: self.project.id
            }
            self.companyCamSaveLoading = true;
            axios.post(route('api.company-cam.create.project'), payload).then(response => {
                self.viewCompanyCamFlag = true;
                self.viewCompanyCamPath = response.data.project_url;
                self.selectedCompanyCamProjectId = response.data.project_id;
                Toast.fire({
                    type: "success",
                    title: response.data.message
                });
                setTimeout(() => {
                    self.CompanyCamGetProjects();
                }, 2000);
            }).catch(error => {
                self.companyCamSaveLoading = false;
                // console.log('error', error.response.data.message);
                Toast.fire({
                    type: "error",
                    title: error.response.data.message
                });
            })
        },

        viewDataForma() {
            //console.log('viewDataFormaPath', this.viewDataFormaPath);
            window.open(this.viewDataFormaPath, '_blank').focus();
        }
        ,
        viewStack() {
            //console.log('viewStack', this.viewStackPath);
            window.open(this.viewStackPath, '_blank').focus();
        },
        viewProcore() {
            window.open(this.viewProcorePath, '_blank').focus();
        }
        ,
        viewCompanyCam() {
            window.open(this.viewCompanyCamPath, '_blank').focus();
        }
        ,
        showEstimatingButton() {
            return this.hasEstimatingAccess;
        }
        ,

        hasFCS() {
            return this.hasFcsConfigurated;
        }
        ,

        isFCSSynced() {
            this.is_fcs_sync = this.project.sync_fcs_at === this.project.updated_at;
        }
        ,

        estimatingEdgeCreate() {
            this.loading_estimating_edge = true;

            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });

            axios.post(route('api.project.estimating-edge.create',
                {project: this.project.id}
            )).then((res) => {
                Toast.fire({
                    type: "success",
                    title: "Your project has been updated."
                });
                this.project.has_bid_id = true;
                this.project.has_tenant_id = true;
                if (res.data.tenant_id !== null && res.data.bid_id !== null) {
                    this.edgeEstimateUrl = 'https://admin.edgeestimator.com/BidScenarios/Index/' + res.data.tenant_id + '?bidId=' + res.data.bid_id;
                }
            }).catch((error) => {
                Toast.fire({
                    type: "error",
                    title: error.response.data.error
                });
            }).finally(() => {
                this.loading_estimating_edge = false;
            });
        }
        ,
        estimatingEdgeDetail() {
            this.loading_estimating_edge = true;

            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });

            axios.get(route('api.project.estimating-edge.estimate',
                {project: this.project.id}
            )).then(({data}) => {
                Toast.fire({
                    type: "success",
                    title: "Your project has been updated."
                });
                this.estimates = data;
            }).catch((error) => {
                Toast.fire({
                    type: "error",
                    title: error.response.data.error
                });
            }).finally(() => {
                this.loading_estimating_edge = false;
            });
        }
        ,

        syncFCSIntegration() {
            this.loading_fcs = true;

            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });

            axios.post(route('api.project.fcs.sync', {project: this.project.id}
            )).then((res) => {
                Toast.fire({
                    type: "success",
                    title: "Your project has been synced."
                });

                setTimeout(() => {
                    window.location.reload(true);
                }, 2000);

            }).catch((error) => {
                Toast.fire({
                    type: "error",
                    title: error.response.data.error
                });
            }).finally(() => {
                this.loading_fcs = false;
            });
        }
        ,

        syncRoofChiefIntegration() {
            this.loading_roof_chief = true;

            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });

            axios.post(route('api.project.roof-chief.sync', {project: this.project.id}
            )).then((data) => {
                Toast.fire({
                    type: "success",
                    title: "Your project has been synced with Roof Chief."
                });
            }).catch((error) => {
                Toast.fire({
                    type: "error",
                    title: "Error to Sync data to Roof Chief."
                });
            }).finally(() => {
                this.loading_roof_chief = false;
            });
        }
        ,

        getEstimates() {
            if (!this.hasEstimatingAccess) return;
            axios.get(route('api.project.estimating-edge.index', {
                project: this.project.id
            })).then(({data}) => {
                this.estimates = data;
                if (data) {
                    if (data.length > 0) {
                        this.selectedEstimate = data[0] ?? null;
                        if (this.form.base_bid_update == 0) {
                            this.form.base_bid = data[0].selling_price ?? this.form.base_bid;
                            if (this.project.tenant_id !== null && this.project.bid_id !== null) {
                                this.edgeEstimateUrl = 'https://admin.edgeestimator.com/BidScenarios/Index/' + this.project.tenant_id + '?bidId=' + this.project.bid_id;
                            }
                        }
                    }
                }
            });
        }
        ,

        print() {
            let newwindow = window.open(`/project/print?project_id=${this.project.id}`, 'print', 'width=860,height=740,toolbar=0,menubar=0,location=0');
            if (window.focus) {
                newwindow.focus()
            }
        }
        ,

        goBack() {
            // let params = new URLSearchParams(window.location.search);
            // window.location = route('project.index')+ `${params.has('project') ? '?search=1' : ''}`;
         ///   return false;
           if (this.dashboard) {
               console.log('if called dashbaord');
                window.location = `${route('dashboard')}${this.dashboardTab ? `#${this.dashboardTab}` : ''}`;
            } else {
               console.log('else called dashbaord');
                let params = new URLSearchParams(window.location.search);
                if(params !=="" || this.company !=="" || this.reportCard !=="" || document.referrer !==""){
                    console.log('company ',this.company);
                    console.log('reportCard ',this.reportCard);
                    console.log('params ', params);
                    console.log('document.referrer ', document.referrer);
                    window.location = document.referrer ? document.referrer : this.company ?
                        route('company.show', {company: this.company}) :
                        this.reportCard ? route('report-card') : route('project.index') + `${params.has('project') ? '?search=1' : ''}`;
                }
            }

        }
        ,

        removeDate(item, index) {
            this.$refs[item][0].clearDate();
            this.form.sales_behaviors[index].completed = 0;
            this.form.sales_behaviors[index].completed_at = null;
            // this.validateProposalDeliveredSalesBehavior(this.form.sales_behaviors[index]);
        }
        ,
        removeDateTimePicker(index) {
            this.form.sales_behaviors[index].date = null;
            this.form.sales_behaviors[index].completed = 0;
            this.form.sales_behaviors[index].completed_at = null;
            // this.validateProposalDeliveredSalesBehavior(this.form.sales_behaviors[index]);
        }
        ,

        //
        // goToCompany(company) {
        //     window.location = route('company.show', {company: company.id});
        // },
        //
        // goToContact(company, contact) {
        //     window.location = route('contact.edit', {company: company.id, contact: contact.id});
        // },

        addProject(relatedProject) {
            this.form.related_projects.push(relatedProject);
        },

        removeProject(relatedProject) {
            this.form.related_projects = this.form.related_projects.filter(function (addedProject) {
                return addedProject.id !== relatedProject.id;
            });
            this.form.deleted_related_projects.push(relatedProject.id)
        },

        addOrRemoveProject(relatedProject) {
            this.projectAddedAlready(relatedProject) ? this.removeProject(relatedProject) : this.addProject(relatedProject);
        },

        projectAddedAlready(relatedProject) {
            return this.form.related_projects.filter(related_project => relatedProject.id === related_project.id).length > 0;
        },

        goToProject(relatedProject) {
            window.location = route('project.edit', {project: relatedProject.id}) + `?project=1`;
        },

        removeGoogleImage() {
            this.formLinkedin.project_google_image = '';
        },

        projectCommentSaved() {
            this.form_changed = false;
            window.onbeforeunload = null;
            let self = this;
            self.projectCommentForm.saving = true;

            if (self.company_contact) self.projectCommentForm.company_contact_id = self.company_contact.id;
            if (self.projectCommentForm.sales_status) self.projectCommentForm.sales_status_id = self.sales_status.id;

            if (self.editing) {
                self.projectCommentForm.put(route('api.project-comment.update', {projectComment: self.current_comment.id})).then((res) => {
                    self.projectCommentForm.saving = false;
                    $("#projectCommentModal").modal("hide");
                });
            } else {
                const salesStatus = this.checkIfProjectNeedsCommentBySalesStatus();

                if (salesStatus) {
                    self.projectCommentForm.sales_status_id = salesStatus.id;
                }

                self.projectCommentForm.post(route('api.project-comment.store', {project: self.project.id})).then((res) => {
                    this.form_changed = false;
                    self.projectCommentForm.saving = false;
                    self.checkCommentStatus = 1;
                    self.saved(true);
                    $("#projectCommentModal").modal("hide");

                    window.analytics.track('Project Comments', {
                        projectName: self.form.name,
                        timestamp: moment().format('YYYY-MM-DD  h:mm:ss a'),
                        userName: self.user.name,
                        userEmail: self.user.email,
                        comment: self.projectCommentForm.comment,
                        team: self.team.name
                    });

                    //load Notes comments
                    this.$refs.projectcomments.fetchCommentsBy('note');
                });
            }

            if (self.commentAddFrom == 'callLogs') {
                self.commentAddFrom = null;
                self.projectCommentForm.commentAddFrom = null;
                // window.open('tel:'+self.callTo);
                self.callTo = null;
            }
        }
        ,

        newContactSaved() {
            let self = this;

            self.newContactForm.post(route('api.company.contact.check', {
                company: self.selectedCompany.id,
                fromWhere: 'project'
            })).then((response) => {
                if (response.status == 'error') {
                    Swal.fire({
                        title: 'Company Contact Already Exists',
                        text: "Do you want to create a duplicate contact",
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#01B1AF',
                        confirmButtonText: 'Continue creating!'
                    }).then((result) => {
                        if (result.value) {
                            self.savedContactAfterCheck()
                        } else {
                            return false;
                        }
                    });
                } else {
                    self.savedContactAfterCheck()
                }
            });
        }
        ,

        addComment(contact = null) {
            $("#projectCommentModal").modal("show");
            this.projectCommentForm.reset();
            if (contact) this.company_contact = contact;
        }
        ,

        addNewContact() {
            this.newContactForm.reset();
            this.selectedTypeContact = null;
            this.selectedUserContact = null;
            if (this.selectedCompany && this.selectedCompany.is_residential) {
                this.selectedTypeContact = this.residential_contact_type;
                this.newContactForm.contact_types_id = this.residential_contact_type.id;
            }
            $("#newContactModal").modal("show");
        }
        ,

        removeCompanyContact(email) {
            this.form.company_contacts = this.form.company_contacts.filter(function (addedContact) {
                return addedContact.email !== email;
            });
        },

        addMention(replaced) {
            let mentionedUserId = replaced.pivot ? replaced.pivot.user_id : replaced.id;
            if (_.find(this.projectCommentForm.mentioned_users, o => o === mentionedUserId)) {
                return;
            }
            this.projectCommentForm.mentioned_users.push(mentionedUserId);
        }
        ,

        filterUsers(mentionText, cb) {
            const users = _.filter(this.users, (user) => user.name.indexOf(mentionText) !== -1);
            cb(users.slice(0, 5));
        }
        ,

        // removeMeeting(index) {
        //     this.form.company_contacts[index].date = null;
        //     this.form.company_contacts[index].completed = null;
        // }
        // ,

        openEmailModal(sales_behavior) {
            var project = {
                name: this.form.name,
                id: this.project.id,
                location: this.form.address,
                contact: this.project.contact
            };
            this.$refs.EmailFileModal.open(sales_behavior, project);
        }
        ,

        openEmailContactModal() {
            $('#exampleModal').modal('hide');
            this.$refs.EmailContactModal.open(this.project.id);
        }
        ,

        openCompanyContactModal(contact, index) {
            this.$refs.companyContactModal.open(contact, index);
        }
        ,

        findActiveProposalDelivered() {
            const sb = _.find(this.form.sales_behaviors, {
                completed: 1,
                proposal_delivered: 1
            });
            this.checked_proposal_delivered = sb ? sb.id : null;
        }
        ,

        checkIfLockableActivity(id) {
            const sb = _.find(this.form.sales_behaviors, {id: id, completed: 1, lockable_activity: 1});
            return !_.isEmpty(sb);
        }
        ,

        getLocalCurrentListData() {
            this.storage_project_list.list = localStorage.getItem('current_project_list') ?
                JSON.parse(localStorage.getItem('current_project_list')).data ?? JSON.parse(localStorage.getItem('current_project_list')) :
                [];
            this.storage_project_list.current_index = this.storage_project_list.list.indexOf(this.project.id);
        }
        ,

        changeProject(to) {
            if (to === 'previous' && this.storage_project_list.current_index !== 0) {
                window.location.href = `/project/${this.storage_project_list.list[this.storage_project_list.current_index - 1]}/edit?project=1`;
            } else if (to === 'next' && this.storage_project_list.current_index !== this.storage_project_list.list.length - 1) {
                window.location.href = `/project/${this.storage_project_list.list[this.storage_project_list.current_index + 1]}/edit?project=1`;
            }
        }
        ,

        openCompanyCreateModal(name) {
            this.$refs.CompanyCreateModal.open(name);
        }
        ,

        async handleNewCompany(company) {
            this.selectedCompany = _.find(this.allCompanies, {id: company.id});
            this.fetchContacts();
        }
        ,

        checkIfProjectNeedsCommentBySalesStatus() {
            const oldStatus = _.find(this.selects.sales_status, {id: this.project.sales_status});
            const newStatus = _.find(this.selects.sales_status, {id: this.form.sales_status_id});

            if ((this.noStatusToNewStatus(oldStatus, newStatus) || (this.bothStatusesUndefined(oldStatus, newStatus) && !this.isSameStatus(oldStatus, newStatus))) && newStatus.comment) {
                return newStatus;
            }
            return null;
        }
        ,

        noStatusToNewStatus(oldStatus, newStatus) {
            return typeof oldStatus === "undefined" && typeof newStatus !== "undefined";
        }
        ,

        bothStatusesUndefined(oldStatus, newStatus) {
            return typeof oldStatus !== "undefined" && typeof newStatus !== "undefined";
        }
        ,

        isSameStatus(oldStatus, newStatus) {
            return oldStatus !== undefined && newStatus !== undefined && oldStatus.id === newStatus.id;
        }
        ,

        removeNewContactDate() {
            this.newContactForm.date = null;
        }
        ,

        checkIsProposalDelivered(item) {
            if (item.proposal_delivered === 1 && item.completed === '1') {
                this.form.bid_date = item.date;
            }
        }
        ,
        checkIsSalesActivityCompleted(item){
            if(item.completed === '1'){
                this.completedSalesBehaviorsForSegment.push(item.name);
                if(item.complete_comment){
                    this.tempSalesActivity = item;
                    $('#projectSaleBehaviorCompleteCommentModal').modal('show');
                }
            }else {
                if(this.completedSalesBehaviorsForSegment.length > 0){
                    this.completedSalesBehaviorsForSegment = this.completedSalesBehaviorsForSegment.filter(x => x !== item.name)
                }
            }
        },
        openNewCompanyContactModal() {
            $('#exampleModal').modal('hide');
            this.$refs.CompanyContactModal.open();
        }
        ,
        openNewCompaniesContactModal() {
            $('#exampleModal').modal('hide');
            this.$refs.CompaniesContactModal.open();
        }
        ,
        parseCompanyContact(contact) {
            this.newContactForm.name = contact.name;
            if (contact.phone) {
                this.newContactForm.cell = contact.phone;
            } else {
                this.newContactForm.cell = contact.cell;
            }
            this.newContactForm.email = contact.email;
        }
        ,
        parseContacts(contact) {
            if ($('#newContactModal').hasClass('show')) {
                this.newContactForm.name = contact.name;
                if (contact.phone) {
                    this.newContactForm.cell = contact.phone;
                } else {
                    this.newContactForm.cell = contact.cell;
                }
                this.newContactForm.email = contact.email;
            } else {
                this.form.contact_name = contact.name;
                if (contact.phone) {
                    this.form.contact_cell = contact.phone;
                } else {
                    this.form.contact_cell = contact.cell;
                }
                this.form.contact_email = contact.email;
                this.form.contact_company_id = contact.company_id;
            }
            contact.id = contact.company_contact_id;
            if(!this.$refs.ProjectCompanyInformation.checkContactAlreadyExists(contact.id, contact.company_id)) {
                this.$refs.ProjectCompanyInformation.addContact(contact, true);
            }
        },
        openNewModal() {
            $('#exampleModal').modal('show');
        },

        editProposal(proposal) {
            window.location = '/proposal/' + proposal.id + '/proposal-generator';
        }
        ,
        getGrossMarginPercentage() {
            let GrossMarginPercentage = null;
            if (this.selectedEstimate.net_cost > 0 && this.form.base_bid) {
                GrossMarginPercentage = Number(((this.selectedEstimate.net_cost * 100) / this.form.base_bid).toFixed(2).split(',').join(''));
            } else {
                GrossMarginPercentage = null;
            }
            this.form.gross_margin_percentage = GrossMarginPercentage;
            return GrossMarginPercentage;
        },
        proposalSignedTime(signedDate, signedTime) {
            if (signedDate === null) {
                return 'N/A';
            }
            if (signedTime === null) {
                return moment(signedDate).format('MM/DD/YYYY');
            }
            const userDatetime = moment.utc(`${signedDate} ${signedTime}`).local();
            return userDatetime.format('MM/DD/YYYY hh:mm A');
        },
        projectContactCompany() {
            if ($('#contact_name').val().length == 0) {
                this.form.contact_company_id = '';
            }
        },
        off() {
            document.getElementById("overlayConfetti").style.display = "none";
            document.getElementById("confettiBox").style.display = "none";

            if(this.agaveErp && this.isProjectERPSynced() && this.isERPSyncSettingActionUpdate()) {
                this.syncProjectToEnabledERP();
            }
            else {
                window.location.reload();
            }
        },
        updateProposalName(id) {
            let name;
            name = $('#proposal' + id).val();
            axios.post(route('update-proposal-name'), {
                id: id,
                name: name
            }).then((response) => {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000
                });
                Toast.fire({
                    type: "success",
                    title: response.data.message
                });
            })
        },
        resetValidationErrors(field) {
            if (field) {
                let status = Array();
                // if(field === 'sales_status_id' && (this.validateSalesStatus() == 1)) {
                //     status.push(false);
                // }
                if (field === 'sales_status_id' && (this.validateContractAmount() == 1)) {
                    status.push(false);
                }
                if (status.includes(false)) {
                    return false;
                }
                if (this.form.errors.errors[field]) {
                    delete this.form.errors.errors[field];
                }
            }
        },

        getCustomField() {
            let customFields = [];
            let customFieldsArray = [];
            customFieldsArray = this.$refs.CustomFields.getCustomFieldForm();
            let customFieldsKeys = [];
            customFieldsKeys = Object.keys(customFieldsArray);

            if (customFieldsKeys.length > 0) {
                let filedsArray = [];
                customFieldsKeys.forEach((key, index) => {
                    filedsArray[key] = customFieldsArray[key];
                });
                let newCustomFiledsArray = [];
                newCustomFiledsArray.push(filedsArray);

                if (newCustomFiledsArray) {
                    customFields = newCustomFiledsArray[0];
                }
            }

            return customFields;
        },
        // validateProposalDeliveredSalesBehavior(item) {
        //     const self = this;
        //     if (item.proposal_delivered === 1 && (item.completed === '1' || item.completed === 1)) {
        //         const salesStatus = this.getSalesStatus(self.form.sales_status_id);
        //         if(salesStatus !== undefined && (salesStatus.pipeline || salesStatus.contract)) {
        //             self.form.errors.clear('sales_status_id');
        //             self.formErrorObj.field = '';
        //             self.formErrorObj.msg = '';
        //             self.isValidateRequiredField.isRequired = false;
        //             return 0;
        //         }
        //         else {
        //             self.isValidateRequiredField.isRequired = true;
        //             self.formErrorObj = {
        //                 field: 'sales_status_id',
        //                 msg: 'Please select the sale status of pipeline or contract'
        //             };
        //             self.form.errors.push(self.formErrorObj);
        //             return 1;
        //         }
        //     }
        //     else {
        //         self.form.errors.clear('sales_status_id');
        //         self.formErrorObj.field = '';
        //         self.formErrorObj.msg = '';
        //         self.isValidateRequiredField.isRequired = false;
        //         return 0;
        //     }
        // },
        // validateSalesStatus() {
        //     const self = this;
        //     let status = 0;
        //     _.each(self.form.sales_behaviors, function(item) {
        //         if(item.proposal_delivered === 1 && (item.completed === '1' || item.completed === 1)) {
        //             status = self.validateProposalDeliveredSalesBehavior(item);
        //         }
        //     });
        //     return status;
        // },
        validateContractAmount() {
            const self = this;
            const salesStatus = this.getSalesStatus(self.form.sales_status_id);
            if (salesStatus !== undefined && salesStatus !== null && salesStatus.contract) {

                if (self.form.contract_amount && self.form.contract_amount !== 0) {
                    self.form.errors.clear('contract_amount');
                    self.isValidateRequiredField.isContractAmountRequired = false;
                    self.foundationLoading = false;
                    return 0;
                }
            } else {
                self.form.errors.clear('contract_amount');
                self.isValidateRequiredField.isContractAmountRequired = false;
                self.foundationLoading = false;
                return 0;
            }
        },
        getSalesStatus(salesStatusId) {
            const self = this;
            return _.find(self.selects.sales_status, function (sale_status) {
                return sale_status.id === salesStatusId;
            });
        },
        validateCompanyContactStatus() {
            const self = this;
            const salesStatus = this.getSalesStatus(self.form.sales_status_id);
            self.companyContactIds = [];
            if (salesStatus !== undefined && salesStatus !== null && salesStatus.contract) {
                if (self.form.company_contacts.length > 0) {
                    _.each(self.form.company_contacts, function (contact) {
                        if (contact.status === "" || contact.status == null) {
                            self.companyContactIds.push(contact.id);
                        }
                    });
                    self.isValidateRequiredField.isCompanyContactStatusRequired = self.companyContactIds.length > 0;
                } else {
                    self.isValidateRequiredField.isCompanyContactStatusRequired = false;
                }
            } else {
                self.isValidateRequiredField.isCompanyContactStatusRequired = false;
            }
        },
        // validateProposalDeliveredSalesBehaviorChecked() {
        //     const self = this;
        //     const salesStatus = this.getSalesStatus(self.form.sales_status_id);
        //     let status = 0;
        //     if(salesStatus !== undefined && salesStatus.dead) {
        //         _.each(self.form.sales_behaviors, function(item) {
        //             if(item.proposal_delivered === 1 && (item.completed === '1' || item.completed === 1)) {
        //                 status = 1;
        //                 self.getToast(5000).fire({
        //                     type: 'error',
        //                     title: "Please checked off completed status of proposal delivered sales behavior"
        //                 });
        //             }
        //         });
        //     }
        //     if(status) {
        //         console.log('Proposal Delivered Sales Behavior Checked OFF');
        //     }
        //     return status;
        // }

        ChangeOrder() {
            let co_index = this.change_orders.length + 1;
            let change_order_name = `Change Order ${co_index}`;
            const itemObject = {
                id: '',
                sales_status_id: '',
                base_bid: 0,
                contract_amount: 0,
                contract_date: '',
                bid_date: '',
                gross_margin_percentage: 0,
                name: change_order_name,
                cost_code: 0,
                complete_percentage: null,
                edit_change_order_name: false,
                vista_aco_no: null,
                spectrum_change_request_no: null,
                agave_foundation_change_order: null,
                agave_foundation_change_order_no: null,
                custom_field_data: {},
            };
            console.log(itemObject);
            this.change_orders.push(itemObject)
        },
        deleteOrder(data){
          this.change_orders.splice(data, 1);
          const key = `change_order_contract_amount${data}`;
          this.$set(this.customErrors, key, null);
          this.form.change_orders = this.change_orders;
        },
        pushToHover() {
            let self = this;
            self.hoverLoading = true;
            let payload = {
                'projectData': self.form,
                'projectId': self.project.id
            };
            if (self.user.hover_user_email) {
                axios.post(route('api.hover.push-to-hover'), payload).then((response) => {
                    self.hoverLoading = false;
                    self.hoverJobId = response.data.jobId;
                    self.getToast(3000).fire({
                        type: response.data.type,
                        title: response.data.message
                    });
                }).catch((error) => {
                    self.hoverLoading = false;
                    self.getToast(3000).fire({
                        type: 'error',
                        title: 'Some error occurred!'
                    });
                });
            } else {
                self.hoverLoading = false;
                self.getToast(3000).fire({
                    type: 'error',
                    title: 'Please connect hover user email in integration section'
                });
            }
        },
        showHoverProperty() {
            let url = process.env.MIX_HOVER_URL + 'ui/#/property/' + this.hoverJobId;
            window.open(url, '_blank').focus();
        },
        adjustTextColor(project, status_id) {
            let element, bgColor, broderColor;
            element = 'sales_status_id';
            if (status_id === null || status_id === '') {
                return;
            }
            let saleStatus = this.mapSaleStatus(status_id);
            bgColor = this.increaseBrightness(saleStatus.color, 70);
            broderColor = this.darkColor(saleStatus.color, -20);

            $('#' + element).css("cssText", "background-color: " + bgColor + " !important;");
            $('#' + element).css("border", broderColor + ' 1px solid');

        },
        mapSaleStatus(status_id) {
            return _.find(this.selects.sales_status, function (obj) {
                return obj.id == status_id
            });
        },

        increaseBrightness(hex, percent) {
            hex = hex.replace(/^\s*#|\s*$/g, '');

            if (hex.length == 3) {
                hex = hex.replace(/(.)/g, '$1$1');
            }

            var r = parseInt(hex.substr(0, 2), 16),
                g = parseInt(hex.substr(2, 2), 16),
                b = parseInt(hex.substr(4, 2), 16);

            return '#' +
                ((0 | (1 << 8) + r + (256 - r) * percent / 100).toString(16)).substr(1) +
                ((0 | (1 << 8) + g + (256 - g) * percent / 100).toString(16)).substr(1) +
                ((0 | (1 << 8) + b + (256 - b) * percent / 100).toString(16)).substr(1);
        },

        darkColor(color, percent) {

            var R = parseInt(color.substring(1, 3), 16);
            var G = parseInt(color.substring(3, 5), 16);
            var B = parseInt(color.substring(5, 7), 16);

            R = parseInt(R * (100 + percent) / 100);
            G = parseInt(G * (100 + percent) / 100);
            B = parseInt(B * (100 + percent) / 100);

            R = (R < 255) ? R : 255;
            G = (G < 255) ? G : 255;
            B = (B < 255) ? B : 255;

            var RR = ((R.toString(16).length == 1) ? "0" + R.toString(16) : R.toString(16));
            var GG = ((G.toString(16).length == 1) ? "0" + G.toString(16) : G.toString(16));
            var BB = ((B.toString(16).length == 1) ? "0" + B.toString(16) : B.toString(16));

            return "#" + RR + GG + BB;
        },
        savedContactAfterCheck() {
            let self = this;
            self.newContactForm.post(route('api.contact.store', {company: self.selectedCompany.id})).then((res) => {
                $("#newContactModal").modal("hide");
                self.fetchContacts()
            });
        },
        showViewButton(proposalId) {
            $('#proposal-view-' + proposalId).show();
            $('#proposal-sign-info-' + proposalId).hide();
        },
        showSignInformation(proposalId) {
            $('#proposal-view-' + proposalId).hide();
            $('#proposal-sign-info-' + proposalId).show();
        },
        deleteProposal(proposal) {
            let self = this;
            Swal.fire({
                title: "Are you sure?",
                text: "Once deleted, you will not be able to recover this proposal!",
                icon: "warning",
                buttons: true,
                showCancelButton: true,
                confirmButtonColor: 'red',
                confirmButtonText: 'I\'m sure!',
                closeOnConfirm: true,
                closeOnCancel: true,
            }).then(result => {
                if (result.value) {
                    axios.delete(route('proposal.destroy', proposal.id))
                        .then((response) => {
                            if (response.data.status === 'success') {
                                $('#proposal-single-div-' + proposal.id).remove();
                            }else{
                                self.getToast(4000).fire({
                                    type: 'error',
                                    title: response.data.message
                                });
                            }
                        });
                }
            });
        },
        callLogs(phoneNumber, makeCallTo) {
            this.sendCallLog();
            this.callTo = phoneNumber;
            window.open('tel:' + this.callTo);

            if (this.form.has_comment_on_in_sales_behavior) {
                this.commentAddFrom = 'callLogs';
                this.projectCommentForm.commentAddFrom = 'callLogs';
                setTimeout(() => $("#projectCommentModal").modal("show"), 10000);
            }
        },
        sendCallLog() {
            axios.post(route('api.project.call-log.add'), {projectId: this.project.id});
        },
        closeProjectCommentModal() {
            let self = this;
            $("#projectCommentModal").modal("hide");
            self.commentAddFrom = null;
            self.projectCommentForm.commentAddFrom = null;
        },
        sendToXScope() {
            let self = this;

            self.xScopeLoading = true;
            self.saved(false);
        },
        pushDataToXScope() {
            let self = this;

            let payload = {
                'projectId': self.project.id
            };

            axios.post(route('api.xscope.push.project'), payload).then((response) => {
                self.xScopeLoading = false;
                self.getToast(4000).fire({
                    type: response.data.status,
                    title: response.data.message
                });
                self.form.xscope_project_id = response.data.xscope_project_id;
                self.form_changed = false;
                window.onbeforeunload = null;
            }).catch((error) => {
                self.xScopeLoading = false;
                self.getToast(3000).fire({
                    type: 'error',
                    title: 'Some error occurred!'
                });
                self.form_changed = false;
                window.onbeforeunload = null;
            });
        },
        checkContactInAddressBook(email, cell) {
            axios.post(route('api.company.contact.check-email', {email: email, cell: cell})).then((response) => {
                if (response.data.status === 'success') {
                    $("#addToAddressBookModal").modal("show");
                } else {
                    this.savedAfterCheck();
                }
            }).catch((err) => {
                this.saveButtonDisabled = false;
            });
        },
        addContactToAddressBook() {
            this.newAddressBookContactForm.reset();
            this.newAddressBookContactForm.name = this.form.contact_name
            this.newAddressBookContactForm.email = this.form.contact_email
            this.newAddressBookContactForm.cell = this.form.contact_cell
            this.newAddressBookContactForm.existing_company = null
            this.newAddressBookContactForm.new_company = null
            $("#addToAddressBookModal").modal("hide");
            $("#newContactToAddressBookModal").modal("show");
        },
        remove_validations() {
            if (this.newAddressBookContactForm.existing_company !== null || this.newAddressBookContactForm.new_company !== '') {
                this.customErrors.existing_company = '';
                this.customErrors.new_company = '';
            }
        },
        addressBookContactSaved() {
            let self = this;
            self.addressBookContactSavedButton = true;
            self.adding_contact = true;
            self.form.contact_name = self.newAddressBookContactForm.name
            self.form.contact_email = self.newAddressBookContactForm.email
            self.form.contact_cell = self.newAddressBookContactForm.cell
            if ((self.residential_contact_type.id !== self.newAddressBookContactForm.contact_types_id) && (self.newAddressBookContactForm.existing_company === null || self.newAddressBookContactForm.existing_company === "") && (self.newAddressBookContactForm.new_company === null || self.newAddressBookContactForm.new_company.trim() === "")) {
                self.customErrors.existing_company = 'You have to choose the Existing Company or New Company!';
                self.customErrors.new_company = 'You have to choose the Existing Company or New Company!';
                self.addressBookContactSavedButton = false;
                self.adding_contact = false;
                return false
            }
            self.saveButtonDisabled = false;
            let data = {
                existing_company: self.newAddressBookContactForm.existing_company ? self.newAddressBookContactForm.existing_company.id : null,
                new_company: self.newAddressBookContactForm.new_company
            }

            self.newAddressBookContactForm.post(route('api.add-contact', {data: data})).then(async (res) => {
                if(res.new_contact) {
                    await this.$refs.ProjectCompanyInformation.addContact(res.new_contact, true);
                    await this.$refs.ProjectCompanyInformation.triggerCompanyContactsWatcher();
                }
                self.addressBookContactSavedButton = false;
                self.adding_contact = false;
                $("#newContactToAddressBookModal").modal("hide");
                self.savedAfterCheck();
            }).catch((error) => {
                self.addressBookContactSavedButton = false;
                self.adding_contact = false;
            });
        },
        disableToggle() {
            document.getElementById("new_company").disabled = true;
        },
        removeDisable() {
            document.getElementById("new_company").disabled = false;
        },
        disableExistingCompany() {
            this.is_true = true;
        },
        enableDropdown() {
            let newCompanyText = $('#new_company').val();
            if (newCompanyText === "") {
                this.is_true = false;
            }
        },
        onPaste() {
            this.is_true = true;
        },
        saveWithoutContact() {
            this.form.check_contact_in_address_book = false;
            this.savedAfterCheck();
        },
        redirectToXScopeProject() {
            window.open(process.env.MIX_XSCOPE_PROJECT_URL + '/' + this.form.xscope_project_id, '_blank');
        },
        pushPullDataFoundation() {
            let self = this;
            self.foundationLoading = true;
            self.saved(false, 'sync');
        },
        getFoundationSyncedProject() {
            let self = this;
            let record = _.find(self.project.company_contacts, function (contact) {
                return contact.id === self.project.foundation_synced_customer_no
            });
            if (record !== undefined && record !== null && record !== "") {
                self.form.foundationContactSelectedContact = record.id;
            }
        },
        projectCustomFieldResponse(data, response) {
            let self = this;
            self.foundationLocationReload = false;

            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            // self.savingProject = false;
            Toast.fire({
                type: 'success',
                title: 'Your project has been updated'
            });

            if(this.completedSalesBehaviorsForSegment.length > 0){
                this.completedSalesBehaviorsForSegment.map(item => {
                    window.analytics.track('Behavior Completed', {
                        projectName: this.form.name,
                        timestamp: moment().format('YYYY-MM-DD  h:mm:ss a'),
                        userName: this.user.name,
                        userEmail: this.user.email,
                        team: this.team.name,
                        salesBehavior: item
                    });
                });
            }

            self.showConfettiResponse(data);
            self.foundationLoading = false;
            if (response.showMsg && !self.sageIntacctContactSyncAccess) {
                if (response.redirect) {
                    Swal.fire({
                        title: response.msgType.charAt(0).toUpperCase() + response.msgType.slice(1),
                        type: response.msgType,
                        showCancelButton: false,
                        showConfirmButton: false,
                        html: `
                            <p>${response.message}</p>
                            <br>
                            <button type="button" id="routeBtn" class="btn btn-primary ml-2" style="background-color:#01B1AF;">Go to Settings</button>`,
                        onBeforeOpen: () => {
                            const routeBtn = document.querySelector('#routeBtn')
                            routeBtn.addEventListener('click', () => {
                                window.location = response.redirectUrl;
                            });
                        }
                    }).then((result) => {
                        self.showConfettiResponse(data);
                    });
                } else {
                    self.getToast(4000).fire({
                        type: response.msgType,
                        title: response.message
                    });
                    if (self.foundationContactSyncAccess && !response.foundationJobNo && response.hasOwnProperty('foundationMessage') && response.foundationMessage !== '' && self.foundationSyncAction !== 'sync') {
                        if (self.form.sales_status_id){
                            const salesContractStatus = self.getSalesStatus(self.form.sales_status_id);
                            if (salesContractStatus.contract === 1){
                                self.getToast(4000).fire({
                                    type: 'error',
                                    title: response.foundationMessage
                                });
                            }
                        }

                        self.showConfettiResponse(data);
                        // if (response.msgType !== 'error') {
                        //     window.location.reload();
                        // }
                    } else {
                        self.showConfettiResponse(data);
                        // if (response.msgType !== 'error') {
                        //     window.location.reload();
                        // }
                    }
                }
            } else {
                self.getToast().fire({
                    type: 'success',
                    title: data.message
                });
                self.showConfettiResponse(data);
                // window.location.reload();

            }
        },
        validateContactWithContractSaleStatus(saleStatusId, oldSaleStatusId) {
            let self = this;
            let salesStatus = self.getSalesStatus(saleStatusId);
            if (salesStatus !== null && salesStatus !== undefined && salesStatus.contract === 1) {
                if (self.form.company_contacts.length === 0) {
                    self.form.sales_status_id = oldSaleStatusId;
                    self.validateContractAmount();
                    this.getToast(4000).fire({
                        type: 'error',
                        title: 'Please add a contact to the project before changing the status to Contract'
                    });
                }
            }
        },
        // syncFoundation() {
        //     let self = this;
        //
        //     let payload = {'projectId': self.project.id, 'teamId': self.team.id};
        //
        //     axios.post(route('api.foundation.sync.project'), payload).then((response) => {
        //         self.foundationLoading = false;
        //         if(response.data.status) {
        //             self.getToast(4000).fire({
        //                 type: response.data.type,
        //                 title: response.data.message
        //             });
        //         }
        //         self.form_changed = false;
        //         window.onbeforeunload = null;
        //     }).catch((error) => {
        //         self.foundationLoading = false;
        //         self.getToast(3000).fire({
        //             type: 'error',
        //             title: 'Some error occurred!'
        //         });
        //         self.form_changed = false;
        //         window.onbeforeunload = null;
        //     });
        // }
        savedAfterCheck() {
            if (this.user.external_email_service && this.form.name !== this.project.name) {
                event.preventDefault();
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: false,
                    showConfirmButton: false,
                    html: `<br>
                            <p>Changing project name will unsync old emails associated with the project. You will need to create a new email thread to track emails to this project.</p>
                            <br>
                            <button type="button" id="cancelBtn" class="btn btn-secondary mr-2">Cancel</button>
                            <button type="button" id="proceedBtn" class="btn btn-primary ml-2" style="background-color:#01B1AF;">Yes, Proceed</button>`,
                    onBeforeOpen: () => {
                        const proceedBtn = document.querySelector('#proceedBtn')
                        const cancelBtn = document.querySelector('#cancelBtn')

                        proceedBtn.addEventListener('click', () => {
                            this.saveAfterWarning();
                            Swal.close();
                        })
                        cancelBtn.addEventListener('click', () => {
                            Swal.close();
                        })
                    }
                })
            } else {
                this.saveAfterWarning();
            }

        },
        saveAfterDeadProjectCheck() {
            const salesStatus = this.getSalesStatus(this.form.sales_status_id);
            if (salesStatus && (salesStatus.dead || salesStatus.contract) && this.form.company_contacts.length === 0) {
                let divData = `<br>
                            <p>You are saving the project with status dead and no company and contact is selected for this project.</p>
                            <br>
                            <button type="button" id="cancelBtn" class="btn btn-secondary mr-2">Cancel (I want to add Contact)</button>
                            <button type="button" id="proceedBtn" class="btn btn-primary ml-2" style="background-color:#01B1AF;">Yes, Proceed</button>`;
                if(salesStatus.contract) {
                    divData = `<br>
                            <p>You are saving the project with status contract and no company and contact is selected for this project.</p>
                            <br>
                            <button type="button" id="cancelBtn" class="btn btn-secondary mr-2">Cancel (I want to add Contact)</button>
                            <button type="button" id="proceedBtn" class="btn btn-primary ml-2" style="background-color:#01B1AF;">Yes, Proceed</button>`;
                }
                event.preventDefault();
                Swal.fire({
                    title: 'Proceed without adding contact?',
                    text: "",
                    type: 'warning',
                    showCancelButton: false,
                    showConfirmButton: false,
                    html: divData,
                    onBeforeOpen: () => {
                        const proceedBtn = document.querySelector('#proceedBtn')
                        const cancelBtn = document.querySelector('#cancelBtn')

                        proceedBtn.addEventListener('click', () => {
                            this.saveAfterWarning();
                            Swal.close();
                        })
                        cancelBtn.addEventListener('click', () => {
                            Swal.close();
                        })
                    }
                })
            } else {
                this.saveAfterWarning();
            }

        },
        saveAfterWarning() {
            let self = this;
            self.savingProject = true;
            self.form.userTimeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
            self.form.userTimeZoneOffset = new Date().getTimezoneOffset();
            this.form.recordDetailCustomFieldForm = this.$refs.ProjectRecordDetailCustomFields.form;
            this.form.put(route('api.project.update', {project: this.project.id})).then((response) => {
                this.$refs.CustomFields.submit(self.project.id, response, self.foundationSyncAction);
                self.form = self.initForm(response.data);
                self.findActiveProposalDelivered();

                // set updated contact to project
                self.project.contact = response.data.contact;
                this.form_changed = false;
                window.onbeforeunload = null;
                if (self.xScopeLoading) {
                    self.pushDataToXScope();
                }
            }).catch(error => {
                this.flash(error.message, 'error');
                if (Object.keys(error.errors).length === 1 && error.errors.contract_date) {
                    const top = document.getElementById('record-details').offsetTop - document.querySelector('.navbar').offsetHeight - 5;
                    window.scrollTo({top, behavior: 'smooth'});
                }
                this.xScopeLoading = false;
                this.foundationLoading = false;
                this.savingProject = false;
            });
        },
        showConfettiResponse(data) {
            this.savingProject = false;
            if (data.confetti.length > 0 && data.notificationExist !== 1) {
                setTimeout(() => {
                    document.getElementById("overlayConfetti").style.display = "block";
                    document.getElementById("confettiBox").style.display = "block";
                }, 2000);

                axios.post(route('api.project.update-celebration-key', {project_id: this.project.id}));
            }
            else {
                if(this.agaveErp && this.isERPSyncSettingActionUpdate() && this.isProjectERPSynced()) {
                    this.syncProjectToEnabledERP();
                }
                else {
                    setTimeout(() => {
                        window.location.reload();
                    }, 1500);
                }
            }
        },
        contactPushToFoundation(contact) {
            let self = this;
            $('.push-to-foundation-loader-' + contact.id).show();
            if (!contact.is_contact_residential && contact.is_any_contact_synced_to_foundation) {
                Swal.fire({
                    title: 'Push Contact to Foundation',
                    text: "A customer record already exists on Foundation with this customer number & company name. Do you want to replace this customer record with this contact?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#01B1AF',
                    confirmButtonText: 'Continue push!'
                }).then((result) => {
                    if (result.value) {
                        self.selectedContactForPushFoundation = contact;
                        if (contact.is_contact_residential) {
                            if (self.isContactHasCustomCustomerNoField && !self.isContactCustomCustomerNoAutoGenerated) {
                                self.external_custom_fields = self.contact_custom_fields;
                                self.externalCustomFieldModalTitle = 'Foundation Custom Customer #';
                                $('#pushContactToFoundationModal').modal('show');
                            } else {
                                self.sendPushContactToFoundationRequest();
                            }
                        } else {
                            if (!contact.is_any_contact_synced_to_foundation && self.isCompanyHasCustomCustomerNoField && !self.isCompanyCustomCustomerNoAutoGenerated) {
                                self.external_custom_fields = self.company_custom_fields;
                                self.externalCustomFieldModalTitle = 'Foundation Custom Customer #';
                                $('#pushContactToFoundationModal').modal('show');
                            } else {
                                self.sendPushContactToFoundationRequest();
                            }
                        }
                    } else {
                        $('.push-to-foundation-loader-' + contact.id).hide();
                    }
                });
            } else {
                self.selectedContactForPushFoundation = contact;
                if (contact.is_contact_residential) {
                    if (self.isContactHasCustomCustomerNoField && !self.isContactCustomCustomerNoAutoGenerated) {
                        self.external_custom_fields = self.contact_custom_fields;
                        self.externalCustomFieldModalTitle = 'Foundation Custom Customer #';
                        $('#pushContactToFoundationModal').modal('show');
                    } else {
                        self.sendPushContactToFoundationRequest();
                    }
                } else {
                    if (self.isCompanyHasCustomCustomerNoField && !self.isCompanyCustomCustomerNoAutoGenerated) {
                        self.external_custom_fields = self.company_custom_fields;
                        self.externalCustomFieldModalTitle = 'Foundation Custom Customer #';
                        $('#pushContactToFoundationModal').modal('show');
                    } else {
                        self.sendPushContactToFoundationRequest();
                    }
                }
            }
        },
        contactPushToSageIntacct(contact) {
            let self = this;
            $('.push-to-foundation-loader-' + contact.id).show();
            if (!contact.is_contact_residential && contact.contact_synced_to_sage_intacct) {
                Swal.fire({
                    title: 'Push Contact in Sage Intacct',
                    text: "A customer record already exists on Sage Intacct with this customer number & company name. Do you want to replace the existing Primary Contact on Sage Intaact?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#01B1AF',
                    confirmButtonText: 'Continue push!'
                }).then((result) => {
                    if (result.value) {
                        self.selectedContactForPushSageIntacct = contact;
                        let payload = {'team': self.team, 'company': contact.company, 'contact': contact,'sageIntactSyncedContact': contact.contact_synced_to_sage_intacct};
                        axios.post(route('api.company.sync-sage-intact-contact'), payload).then((result) => {
                            $('.push-to-foundation-loader-' + contact.id).show();
                            self.getToast().fire({
                                type: result.data.sageInacctCustomerNo ? 'success' : 'error',
                                title: result.data.sageInacctCustomerNo ? result.data.sageInacctMsg : result.data.message,
                            });
                            $('.push-to-foundation-loader-' + contact.id).hide();
                            if(result.data.sageInacctCustomerNo) {
                                let addedContactIds = _.map(self.form.company_contacts, 'id');
                                self.updateAddedContactsAfterFoundationPush(addedContactIds);
                            }
                        }).catch(() => {
                            $('.push-to-foundation-loader-' + contact.id).hide();
                            self.getToast().fire({
                                type: 'error',
                                title: "Create on Sage Intacct Failed.",
                            });
                        });
                        } else {
                            $('.push-to-foundation-loader-' + contact.id).hide();
                        }
                });
            } else {
                self.selectedContactForPushSageIntacct = contact;
                if (contact.is_contact_residential) {
                    let payload = {
                        'contact': contact,
                        'company': contact.company
                    };
                    axios.post(route('api.contact.sage-intacct.push-residential-contact'), payload).then((result) => {
                        if (result.data.sageInatcctCustomerNo) {
                            let addedContactIds = _.map(self.form.company_contacts, 'id');
                            self.updateAddedContactsAfterFoundationPush(addedContactIds);
                        }
                        self.getToast().fire({
                            type: result.data.sageInatcctCustomerNo ? 'success' : 'error',
                            title: result.data.message,
                        });
                    }).catch(() => {
                        self.getToast().fire({
                            type: 'error',
                            title: "Create on Sage Intact Failed.",
                        });
                    });
                    $('.push-to-foundation-loader-' + contact.id).hide();
                }else {
                    self.selectedContactForPushSageIntacct = contact;
                    let payload = {'team': self.team, 'company': contact.company, 'contact': contact,'sageIntactSyncedContact': null};
                    axios.post(route('api.company.sync-sage-intact-contact'), payload).then((result) => {
                        $('.push-to-foundation-loader-' + contact.id).show();
                        self.getToast().fire({
                            type: result.data.sageInatcctCustomerNo ? 'success' : 'error',
                            title: result.data.sageInacctCustomerNo ? result.data.sageInacctMsg : result.data.message,
                        });
                        $('.push-to-foundation-loader-' + contact.id).hide();
                        if (result.data.sageInacctCustomerNo) {
                            let addedContactIds = _.map(self.form.company_contacts, 'id');
                            self.updateAddedContactsAfterFoundationPush(addedContactIds);
                        }
                    }).catch(() => {
                        $('.push-to-foundation-loader-' + contact.id).hide();
                        self.getToast().fire({
                            type: 'error',
                            title: "Create on Sage Intacct Failed.",
                        });
                    });
                }
            }
        },
        sendPushContactToFoundationRequest(isCustomFieldRequired = false) {
            let self = this;
            self.foundationContactPushLoader = true;
            if (isCustomFieldRequired && (self.externalFoundationCustomFieldValue === undefined || self.externalFoundationCustomFieldValue === null || self.externalFoundationCustomFieldValue === '')) {
                self.foundationContactPushLoader = false;
                self.getToast().fire({
                    type: 'error',
                    title: "Please enter Foundation customer #",
                });
            } else {
                let addedContactIds = _.map(self.form.company_contacts, 'id');
                let payload = {
                    'contact': self.selectedContactForPushFoundation,
                    'customerNo': self.externalFoundationCustomFieldValue,
                    'isContactHasCustomCustomerNoField': self.isContactHasCustomCustomerNoField,
                    'isContactCustomCustomerNoAutoGenerated': self.isContactCustomCustomerNoAutoGenerated,
                    'isCompanyHasCustomCustomerNoField': self.isCompanyHasCustomCustomerNoField,
                    'isCompanyCustomCustomerNoAutoGenerated': self.isCompanyCustomCustomerNoAutoGenerated,
                };
                axios.post(route('api.project.foundation.push-contact'), payload).then((result) => {
                    self.foundationContactPushLoader = false;
                    self.closePushContactToFoundationModal();
                    $('#pushContactToFoundationModal').modal('hide');
                    $('.push-to-foundation-loader-' + self.selectedContactForPushFoundation.id).hide();
                    self.updateAddedContactsAfterFoundationPush(addedContactIds);
                    self.getToast().fire({
                        type: result.data.foundationCustomerNo ? 'success' : 'error',
                        title: result.data.message,
                    });
                }).catch(() => {
                    self.foundationContactPushLoader = false;
                    self.closePushContactToFoundationModal();
                    $('#pushContactToFoundationModal').modal('hide');
                    $('.push-to-foundation-loader-' + self.selectedContactForPushFoundation.id).hide();
                    self.getToast().fire({
                        type: 'error',
                        title: "Create/Update on Foundation Failed.",
                    });
                });
            }
        },

        fetchContactCustomFields() {
            let self = this;
            let params = `?contact=true`;
            axios.get(route('api.contact-custom-field.index') + params).then(({data}) => {
                self.contact_custom_fields = data.data;
            });
        },
        fetchCompanyCustomFields() {
            let self = this;
            let params = `?company=true`;
            axios.get(route('api.company-custom-field.index') + params).then(({data}) => {
                self.company_custom_fields = data.data;
            });
        },
        validateFoundationCustomerNumber() {
            let self = this;
            if (self.externalFoundationCustomFieldValue && self.externalFoundationCustomFieldValue.length > 10) {
                self.externalFoundationCustomFieldValue = self.externalFoundationCustomFieldValue.slice(0, 10);
                self.getToast(2000).fire({
                    type: 'error',
                    title: 'Customer ID cannot exceed 10 characters'
                });
            }
        },
        closePushContactToFoundationModal() {
            this.externalFoundationCustomFieldValue = null;
            $('.push-to-foundation-loader-' + this.selectedContactForPushFoundation.id).hide();
        },
        updateAddedContactsAfterFoundationPush(addedContactIds) {
            let self = this;
            axios.post(route('api.contact.get-details'), {contactIds: JSON.stringify(addedContactIds)}).then(({data}) => {
                _.forEach(addedContactIds, function (contactId) {
                    let contactData = _.find(data.data, {id: contactId});
                    self.form.company_contacts = self.form.company_contacts.map(item => {
                        if (item.id === contactId) {
                            item.foundation_customer_no = contactData.foundation_customer_no;
                            item.sage_intacct_customer_no = contactData.sage_intacct_customer_no;
                            item.sage_intacct_record_no = contactData.sage_intacct_record_no;
                            item.contact_synced_to_sage_intacct = contactData.contact_synced_to_sage_intacct;
                        }
                        return item;
                    });
                });
            });
        },
        proposalSenderTime(signedDate) {
            let proposaldate;
            proposaldate = moment.utc(signedDate).local().format('M/D/YYYY hh:mm A');
            return proposaldate;
        },
        setProjectChangeOrders(projectChangeOrders) {
            return projectChangeOrders.map(changeOrder => {
                let custom = {};
                this.change_order_custom_fields.forEach(field => {
                    custom[field.id+''] = '';
                });
                changeOrder.custom_field_values.forEach(fieldValue => {
                    custom[fieldValue.change_order_custom_field_id+''] = fieldValue.value;
                });
                return {
                    id: changeOrder.id ?? null,
                    sales_status_id: changeOrder.sales_status_id ?? null,
                    base_bid: changeOrder.base_bid ? Number(changeOrder.base_bid.split(',').join('')) : null,
                    contract_amount: changeOrder.contract_amount ? Number(changeOrder.contract_amount.split(',').join('')) : null,
                    gross_margin_percentage: changeOrder.gross_margin_percentage ? Number(changeOrder.gross_margin_percentage.split(',').join('')) : null,
                    contract_date: changeOrder.contract_date ?? null,
                    bid_date: changeOrder.bid_date ?? null,
                    name: changeOrder.name ?? null,
                    cost_code: changeOrder.cost_code ? Number(changeOrder.cost_code.split(',').join('')) : null,
                    complete_percentage: changeOrder.complete_percentage ?? null,
                    vista_aco_no: changeOrder.vista_aco_no ?? null,
                    spectrum_change_request_no: changeOrder.spectrum_change_request_no ?? null,
                    agave_change_order: changeOrder.agave_change_order ?? null,
                    agave_id: changeOrder.agave_id ?? null,
                    agave_foundation_change_order: changeOrder.agave_foundation_change_order ?? null,
                    agave_foundation_change_order_no: changeOrder.agave_foundation_change_order_no ?? null,
                    custom_field_data: custom,
                    agave_contract_id: changeOrder.agave_contract_id ?? null,
                    vista_contract_id: changeOrder.vista_contract_id ?? null,
                }
            })
        },
        editChangeOrderName(index){
            this.$set(this.change_orders[index], 'edit_change_order_name', true);
        },
        saveChangeOrderName(index){
            this.$set(this.change_orders[index], 'edit_change_order_name', false);
        },
        qbEmailBilling(){
            $([document.documentElement, document.body]).animate({
                scrollTop: $("#externalEmailSectionDiv").offset().top - 40
            }, 1000);
            setTimeout(()=>{
                this.$refs.ExternalEmailSectionReference.composing = true;
            }, 1300);
            setTimeout(()=>{
                this.$refs.ExternalEmailSectionReference.openEmailTemplateModal();
            }, 1000);
            setTimeout(()=>{
                this.$refs.ExternalEmailSectionReference.$refs.EmailTemplateModal.openTemplate();
            }, 1000);
        },
        disableFieldIfInactiveUserSelected(fieldName) {
            let self = this;
            let result = false;
            if(self.form[fieldName] !== null && self.form[fieldName] !== undefined) {
                let userData = _.find(self.selects.all_users, function(user) { return user.id === self.form[fieldName]; });
                if(userData !== null && userData !== undefined && userData.hasOwnProperty('pivot')) {
                    result = parseInt(userData.pivot.active) === 0;
                }
            }
            return result;
        },
        resetChangeOrderValidations(index) {
            let self = this;
            let filteredChangeOrder = self.change_orders.find((order, i) => i === index);
            const filteredSalesStatus = _.find(self.selects.sales_status, {id: filteredChangeOrder.sales_status_id});
            const key = `change_order_contract_amount${index}`;

            if (filteredSalesStatus.contract) {
                filteredChangeOrder.contract_date = moment().format('YYYY-MM-DD');
            }

            if (filteredSalesStatus.pipeline || filteredSalesStatus.dead) {
                filteredChangeOrder.contract_amount = null;
                filteredChangeOrder.contract_date = null;
                self.$set(self.customErrors, key, null);
            }

            self.change_orders[index] = filteredChangeOrder
        },
        resetChangeOrderContractAmountValidations(index, key) {

            this.$nextTick(() => {
                const filteredChangeOrder = this.change_orders.find((order, i) => i === index);
                if (key === `change_order_contract_date${index}`) {
                        if (filteredChangeOrder.contract_date) {
                            this.$set(this.customErrors, key, null);
                        }

                }else if (filteredChangeOrder.contract_amount && filteredChangeOrder.contract_amount !== 0) {
                    this.$set(this.customErrors, key, null);
                }
            });
        },
      /*  pushProjectToVista(){
            if(this.vistaJobNumberCustomFieldId && !this.$refs.CustomFields.form[this.vistaJobNumberCustomFieldId]){
                this.getToast().fire({
                    type: 'error',
                    title: 'Vista Job # is required'
                });
            }else{
                let jobNumber = this.$refs.CustomFields.form[this.vistaJobNumberCustomFieldId] ?? null;
                this.$refs.ProjectVistaComponent.pushOrUpdateProjectToVista(jobNumber);
            }
            // this.$refs.ProjectVistaComponent.openVistaDepartmentAndLiabTemplateModal();
        },*/
        syncProjectFromVista(){
            this.$refs.ProjectVistaComponent.syncProjectFromVista();
        },
        syncProjectFromFoundation(){
            this.$refs.ProjectVistaComponent.syncProjectFromVista();
        },
        syncChangeOrderFromVista(index){
            this.$refs.ProjectVistaComponent.syncProjectChangeOrdersFromVista(index);
        },
        syncChangeOrderFromVistaContract(index, item){
            this.$refs.ProjectVistaComponent.syncProjectChangeOrdersFromVistaContract(index, item.agave_contract_id ?? null);
        },
        openVistaConnectionSelection(syncingChangeOrder = false, projectAutomaticErpSyncWithSalesStatus = null){
            this.$refs.ProjectVistaComponent.openVistaConnectionSelection(syncingChangeOrder, 'connect', projectAutomaticErpSyncWithSalesStatus);
        },
        vistaJobNumberChanged(data){
            this.$refs.ProjectVistaComponent.pushOrUpdateProjectToVista(data.jobNumber);
        },
        spectrumJobNumberChanged(data){
            this.$refs.ProjectSpectrumComponent.pushOrUpdateProjectToSpectrum(data.jobNumber);
        },
        syncChangeOrderFromSpectrum(index){
            const changeOrder = this.change_orders[index]
            this.$refs.ProjectSpectrumComponent.syncProjectChangeOrdersFromSpectrum(index, changeOrder);
        },
        pushChangeOrderToSpectrum(index){
            const changeOrder = this.change_orders[index]
            this.$refs.ProjectSpectrumComponent.pushChangeOrderToSpectrum(index, changeOrder);
        },
        updateChangeOrderToSpectrum(index){
            const changeOrder = this.change_orders[index]
            this.$refs.ProjectSpectrumComponent.updateChangeOrderToSpectrum(index, changeOrder);
        },
        createQBEstimateModal(){
            // const salesStatus = this.getSalesStatus(this.form.sales_status_id);
            // if (salesStatus !== undefined && salesStatus !== null && salesStatus.contract) {
                this.$refs.QuickBookEstimateModal.openQuickBookCreateModal();
            // }else{
            //     this.getToast().fire({
            //         type: 'error',
            //         title: 'Please change project sales status to contract type'
            //     });
            // }
        },
        editQBEstimateModal(){
            this.$refs.QuickBookEstimateModal.openQuickBookEstimateListModal();
        },
        fetchQBInvoicesModal(){
            this.$refs.QuickBookEstimateModal.openListQBAllProjectsModal();
        },
        syncQBProjectInvoice(){
            this.loadingQB = true;
            this.getToast().fire({
                type: 'success',
                title: 'Syncing income summary'
            });
            axios.post(route('quick-book.sync-quick-book-project-invoices'), {projectId: this.project.id}).then((response) => {
                let data = {};
                if(response.data.invoiceData.invoiceData){
                    data = {
                        invoiceData: Object.entries(response.data.invoiceData.invoiceData),
                        invoiceTotal: response.data.invoiceData.invoiceTotal - response.data.invoiceDiscountData
                    };
                }else{
                    data = {
                        invoiceData: null,
                        invoiceTotal: response.data.invoiceData.invoiceTotal - response.data.invoiceDiscountData
                    }
                }
                this.quickBookInvoiceData = data;
                let cost = {};
                let costTotal = 0;
                if(response.data.costData.invoiceData){
                    if(response.data.billData){
                        costTotal = response.data.costData.costTotal + response.data.billData.billTotal;
                    }else{
                        costTotal = response.data.costData.costTotal;
                    }
                    if(response.data.hourlyTimeCostData){
                        costTotal = costTotal + response.data.hourlyTimeCostData.hourlyTimeCostTotal;
                    }
                    cost = {
                        costData: Object.entries(response.data.costData.costData),
                        costTotal: costTotal
                    };
                }else{
                    if(response.data.billData){
                        costTotal = response.data.costData.costTotal + response.data.billData.billTotal;
                    }else{
                        costTotal = response.data.costData.costTotal;
                    }
                    if(response.data.hourlyTimeCostData){
                        costTotal = costTotal + response.data.hourlyTimeCostData.hourlyTimeCostTotal;
                    }
                    cost = {
                        costData: null,
                        costTotal: costTotal
                    }
                }

                this.quickBookCostData = cost;
                this.$refs.QuickBookIncomeCost.fetchQBIncomeCostData();
                this.loadingQB = false;
            });
        },
        initAutocompleteContact() {
            let input = document.getElementById('searchTextFieldContact');
            autocompleteContact = new google.maps.places.Autocomplete(input, {
                componentRestrictions: {
                    country: ['us','ca']
                }
            });

            google.maps.event.addListener(autocompleteContact, 'place_changed', this.getAddressComponentsContact);
        },

        getAddressComponentsContact() {
            let placeResultData = autocompleteContact.getPlace();
            this.newAddressBookContactForm.lat = placeResultData.geometry.location.lat();
            this.newAddressBookContactForm.lng = placeResultData.geometry.location.lng();
            this.newAddressBookContactForm.zip = '';
            this.newAddressBookContactForm.city = '';
            this.newAddressBookContactForm.state = '';
            placeResultData.address_components.map(res=>{
                if(res.types[0]==='postal_code'){
                    this.newAddressBookContactForm.zip = res.short_name;
                }
                if(res.types[0]==='locality'){
                    this.newAddressBookContactForm.city = res.short_name;
                }
                if(res.types[0]==='administrative_area_level_1'){
                    this.newAddressBookContactForm.state = res.short_name;
                }
            });
            this.newAddressBookContactForm.address = placeResultData.name;
        },
        openQuickBookInvoiceCostDetailModal(){
            this.$refs.QuickBookIncomeCost.openNewQBFlowModal();
        },
        getDeadReasonCustomField() {
            let self = this;
            let payload = {
                columnName: 'is_dead_reason_field',
                value: 1
            };

            axios.post(route('api.project-custom-field.get-specific-field'), payload).then((data) => {
                self.deadReasonCustomField = data.data.data;
            }).catch((error) => {

            });
        },
        refreshProjectCompanyContacts() {
            this.$refs.ProjectCompanyInformation.fetchState();
        },
        foundationJobNumberChanged(data) {
            this.$refs.ProjectFoundationComponent.pushOrUpdateProjectToFoundation(data.jobNumber);
        },
        initializePricingFlatFile(){
            this.projectDropdownsIndex = this.$root.currentTeam.custom_project_id_check ? 1 : 0;
            console.log('fafa', this.getAllPricingFields);
            const status = this.status.map(statusObj => {
                return ({
                    value: statusObj.id,
                    label: statusObj.value.trim()
                })
            });
            const sale_status = this.getAllPricingFields['sale_statuses'].map(salesObj => {
                return ({
                    value: salesObj.id,
                    label: salesObj.code.trim()
                })
            });
            const marketing_status = this.getAllPricingFields['marketing_statuses'].map(marketingObj => {
                return ({
                    value: marketingObj.id,
                    label: marketingObj.code.trim()
                })
            });
            const client_profile = this.getAllPricingFields['client_profiles'].map(clientObj => {
                return ({
                    value: clientObj.id,
                    label: clientObj.full_description.trim()
                })
            });
            const contract_type = this.getAllPricingFields['contract_types'].map(contractObj => {
                return ({
                    value: contractObj.id,
                    label: contractObj.full_description.trim()
                })
            });
            const lead_from = this.getAllPricingFields['lead_froms'].map(leadFromObj => {
                return ({
                    value: leadFromObj.id,
                    label: leadFromObj.full_description.trim()
                })
            });
            const esstimator_acc_manager_take_off_person = this.getAllPricingFields['esstimator_acc_manager_take_off_person'].map(esstimaterAccountManagerTakeOffPersonObj => {
                return ({
                    value: esstimaterAccountManagerTakeOffPersonObj.id,
                    label: esstimaterAccountManagerTakeOffPersonObj.name.trim()
                })
            });
            const office = this.getAllPricingFields['offices'].map(officeObj => {
                return ({
                    value: officeObj.id,
                    label: officeObj.full_description.trim()
                })
            });
            const product_service = this.getAllPricingFields['product_services'].map(productServicesObj => {
                return ({
                    value: productServicesObj.id,
                    label: productServicesObj.full_description.trim()
                })
            });
            this.importerClients.registerRecordHook(record => {
                let out = {}
                if (record.custom_project_id) {
                    out.custom_project_id = this.formatCustomProjectId(record.custom_project_id, record.name)
                }
                if (record.proposal_delivered) {
                    out.proposal_delivered = this.formatDate(record.proposal_delivered)
                }
                if (record.site_visit) {
                    out.site_visit = this.formatDate(record.site_visit)
                }
                if (record.contract_amount) {
                    out.contract_amount = this.formatFloatValue(record.contract_amount);
                }
                if (record.base_bid) {
                    out.base_bid = this.formatFloatValue(record.base_bid);
                }
                if (record.gross_margin) {
                    out.gross_margin = this.formatFloatValue(record.gross_margin);
                }
                if (record.labor_hours) {
                    out.labor_hours = this.formatFloatValue(record.labor_hours);
                }
                if (record.name) {
                    out.name = this.formatStringValue(record.name);
                }
                if (record.address) {
                    out.address = this.formatStringValue(record.address);
                }
                if (record.city) {
                    out.city = this.formatStringValue(record.city);
                }
                if (record.state) {
                    out.state = {
                        value: record.state.toUpperCase()
                    }
                }
                if (record.contact_name) {
                    out.contact_name = this.formatStringValue(record.contact_name)
                }
                if (record.contact_email) {
                    out.contact_email = this.trimSpaces(record.contact_email)
                }
                if (record.contact_phone) {
                    out.contact_phone = this.formatPhoneValue(record.contact_phone)
                }
                if (record.contact_cell) {
                    out.contact_cell = this.formatPhoneValue(record.contact_cell)
                }
                if (record.contact_fax) {
                    out.contact_fax = this.formatPhoneValue(record.contact_fax)
                }
                if (record.pre_bid_date) {
                    out.pre_bid_date = this.formatDate(record.pre_bid_date)
                }
                if (record.bid_date) {
                    out.bid_date = this.formatDate(record.bid_date)
                }
                if (record.dead_date) {
                    out.dead_date = this.formatDate(record.dead_date)
                }
                if (record.login_date) {
                    out.login_date = this.formatDate(record.login_date)
                }
                if (record.contract_date) {
                    out.contract_date = this.formatDate(record.contract_date)
                }
                if (record.proposal_delivered) {
                    out.proposal_delivered = this.formatDate(record.proposal_delivered)
                }
                for (let i = 1; i <= 20; i++) {
                    if (record['company_name_' + i]) {
                        out['company_name_' + i] = this.formatStringValue(record['company_name_' + i])
                    }
                    if (record['company_contact_name_' + i]) {
                        out['company_contact_name_' + i] = this.formatStringValue(record['company_contact_name_' + i])
                    }
                    if (record['company_contact_title_' + i]) {
                        out['company_contact_title_' + i] = this.formatStringValue(record['company_contact_title_' + i])
                    }
                    if (record['company_contact_email_' + i]) {
                        out['company_contact_email_' + i] = this.trimSpaces(record['company_contact_email_' + i])
                    }
                    if (record['followup_' + i]) {
                        out['followup_' + i] = this.formatDate(record['followup_' + i])
                    }
                    if (record['company_contact_phone_' + i]) {
                        out['company_contact_phone_' + i] = this.formatPhoneValue(record['company_contact_phone_' + i])
                    }
                    if (record['company_phone_' + i]) {
                        out['company_phone_' + i] = this.formatPhoneValue(record['company_phone_' + i])
                    }
                }
                if (!record.address && (record.address1 && record.address2)) {
                    out.address = {
                        value: record.address1 + ", " + record.address2,
                        info: [{
                            message: "Address was generated by combining address line 1 and  address line 2",
                            level: "warning"
                        }]
                    }
                } else if (!record.address && (record.address1 || record.address2)) {
                    // Handle the case when either address1 or address2 or both exist
                    out.address = {
                        value: (record.address1 || '') + (record.address1 && record.address2 ? ', ' : '') + (record.address2 || ''),
                        info: [{
                            message: "Address was generated from address line 1 and address line 2",
                            level: "warning"
                        }]
                    };
                } else if (!record.address && record.full_address) {
                    let parsedAddress = parser.parseLocation(record.full_address);
                    if (parsedAddress.sec_unit_type === "PO Box") {
                        out.address = {
                            value: parsedAddress.sec_unit_type + " " + parsedAddress.sec_unit_num
                        };
                    } else {
                        if (parsedAddress.sec_unit_num) {
                            out.address = {
                                value: this.checkAddress(parsedAddress) + ", " + parsedAddress.sec_unit_type + " " + parsedAddress.sec_unit_num
                            };
                        } else {
                            out.address = {value: this.checkAddress(parsedAddress)};
                        }
                    }
                    out.city = {value: parsedAddress.city};
                    out.state = {value: parsedAddress.state};
                    out.zip = {value: parsedAddress.zip};
                }
                for (let j = 1; j <= 20; j++) {
                    if (!record['company_contact_name_' + j] && record['company_name_' + j]) {
                        out['company_contact_name_' + j] = this.getContactNeeded(j)
                    }
                }
                for (let i = 1; i <= 20; i++) {
                    if (!record['company_name_' + i] &&
                        ((record['company_contact_name_' + i] && !!record['company_contact_name_' + i].trim()) ||
                            (record['company_contact_title_' + i] && !!record['company_contact_title_' + i].trim()) ||
                            (record['company_contact_title_' + i] && !!record['company_contact_email_' + i].trim()) ||
                            (record['company_contact_phone_' + i] && !!record['company_contact_phone_' + i].trim()) ||
                            (record['followup_' + i] && !!record['followup_' + i].trim()) ||
                            (record['status_' + i] && !!record['status_' + i].trim()))) {
                        out['company_name_' + i] = {
                            info: [{
                                message: "Company Name " + i + " is required",
                                level: "error"
                            }]
                        }
                    }
                }
                if (this.project_sales_behaviors_name.length > 0) {
                    this.project_sales_behaviors_name.forEach(item => {
                        if (record[item]) {
                            out[item] = this.formatBehaviorDate(record[item])
                        }
                    })
                }
                this.fileDataCustomDateFields.map( customField => {
                    if (record[customField]) {
                        out[customField] = this.formatDate(record[customField])
                    }
                })
                return out
            })
            this.importerClients.options.fields[(10 + this.projectDropdownsIndex)].options = sale_status;
            this.importerClients.options.fields[(11 + this.projectDropdownsIndex)].options = marketing_status;
            this.importerClients.options.fields[(19 + this.projectDropdownsIndex)].options = client_profile;
            this.importerClients.options.fields[(20 + this.projectDropdownsIndex)].options = contract_type;
            this.importerClients.options.fields[(14 + this.projectDropdownsIndex)].options = lead_from;
            this.importerClients.options.fields[(15 + this.projectDropdownsIndex)].options = esstimator_acc_manager_take_off_person;
            this.importerClients.options.fields[(16 + this.projectDropdownsIndex)].options = esstimator_acc_manager_take_off_person;
            this.importerClients.options.fields[(17 + this.projectDropdownsIndex)].options = esstimator_acc_manager_take_off_person;
            this.importerClients.options.fields[(21 + this.projectDropdownsIndex)].options = office;
            this.importerClients.options.fields[(18 + this.projectDropdownsIndex)].options = product_service;
            this.importerClients.options.fields[(40 + this.projectDropdownsIndex)].options = status;
            this.importerClients.options.fields[(48 + this.projectDropdownsIndex)].options = status;
            this.importerClients.options.fields[(56 + this.projectDropdownsIndex)].options = status;
            this.importerClients.options.fields[(64 + this.projectDropdownsIndex)].options = status;
            this.importerClients.options.fields[(72 + this.projectDropdownsIndex)].options = status;
            this.getAllPricingFields['project_sales_behaviors'].forEach((behavior) => {
                const projectBehaviorName = behavior.name.trim().toLowerCase().replace(/\s/g, '_')
                this.importerClients.options.fields.push({key: projectBehaviorName, label: behavior.name})
                this.project_sales_behaviors_name.push(projectBehaviorName);
            })
            const projectFieldOptions = this.project_custom_field_options;
            const teamUsers = this.team_users;
            console.log('project_custom_fields', this.project_custom_fields);
            this.project_custom_fields.forEach((element) => {
                if (element.enabled) {
                    if (element.type == 1) {
                        const options = teamUsers.filter((user) => {
                            return user
                        }).map(user => ({value: user.id, label: user.name}))
                        this.importerClients.options.fields.push({
                            key: element.name.trim().toLowerCase().replace(/\s/g, '_'),
                            label: element.name,
                            type: "select",
                            options: options
                        })
                    } else if (element.type == 3) {
                        const options = projectFieldOptions.filter((option) => {
                            if (option.project_custom_field_id == element.id && option.enabled) {
                                return option
                            }
                        }).map(option => ({value: option.id, label: option.name}))
                        this.importerClients.options.fields.push({
                            key: element.name.trim().toLowerCase().replace(/\s/g, '_'),
                            label: element.name,
                            type: "select",
                            options: options
                        })
                    } else if (element.type == 4) {
                        const key = element.name.trim().toLowerCase().replace(/\s/g, '_')
                        this.importerClients.options.fields.push({
                            key: key,
                            label: element.name
                        })
                        this.fileDataCustomDateFields.push(key);
                    } else {
                        this.importerClients.options.fields.push({
                            key: element.name.trim().toLowerCase().replace(/\s/g, '_'),
                            label: element.name
                        })
                    }
                }
            });
        },
        formatCustomProjectId(value, name) {
            const matchedProject = this.team_custom_project_ids.find(project => project.id === value);
            if (matchedProject && this.formatStringValue(name).value !== matchedProject.name) {
                return {
                    info: [{
                        message: "A project with this project custom ID already exists, but the names don't match. Enter another ID and try again.",
                        level: "error",
                    }]
                };
            }
            if(this.customProjectIdRegExp && !value.match(this.customProjectIdRegExp)){
                return {
                    info:[{
                        message: "Project custom ID needs to match format set in the settings",
                        level: "error",
                    }]
                }
            }
            return value;
        },
        formatStringValue(value) {
            if (!!value.trim()) {
                return {
                    value: value.trim()
                        .replace(/(\s-)+/g, '-').replace(/(-\s)+/g, '-').replace(/-/g, ' - ')
                        .replace(/(^\w|\s\w)(\S*)/g, (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase())
                }
            }else{
                return {
                    value:''
                };
            }
        },
        formatFloatValue(value) {
            value = parseFloat(value.replace(/[\$,]/g, "")).toFixed(2)
            if(!isNaN(value)) {
                return {
                    value: parseFloat(value.replace(/[\$,]/g, "")).toFixed(2),
                    info: [{
                        message: "Formatted value to 2 decimals",
                        level: "warning"
                    }]
                }
            }else{
                return {
                    value: value,
                    info: [{
                        message: "Invalid number value",
                        level: "error"
                    }]
                }
            }
        },
        formatPhoneValue(value) {
            return {
                value: value.replace(/\D/gi, ''),
                info: [{
                    message: "Phone number formatted",
                    level: "warning"
                }]
            }
        },
        formatDate(value) {
            value = value.replace(/\s[AP]M$/, '');
            const isValidFormat = this.checkDateFormats(value);
            if (isValidFormat && moment.utc(value).isValid()) {
                return {
                    value: moment.utc(value).format('M/D/yyyy'),
                    info: [{
                        message: "Dates reformatted",
                        level: "warning"
                    }]
                }
            }else{
                return {
                    value: value,
                    info: [{
                        message: "Date is invalid (Supported Formats are M/D/yyyy, MM/DD/yyyy, M/D/yyyy hh:mm:ss, MM/DD/yyyy hh:mm:ss, M-D-yyyy, MM-DD-yyyy, M-D-yyyy hh:mm:ss, MM-DD-yyyy hh:mm:ss, MM-DD-yyyy hh:mm)",
                        level: "error"
                    }]
                }
            }
        },
        formatBehaviorDate(value) {
            const isValidFormat = this.checkDateFormats(value, true);
            value = value.replace(/\s[AP]M$/, '');
            if (isValidFormat && moment.utc(value).isValid()) {
                return {
                    value: moment.utc(value).format('M/D/yyyy hh:mm A'),
                    info: [{
                        message: "Dates reformatted",
                        level: "warning"
                    }]
                }
            }else{
                return {
                    info:[{
                        message: "Date is invalid (Supported Formats are M/D/yyyy, MM/DD/yyyy, M/D/yyyy hh:mm:ss, MM/DD/yyyy hh:mm:ss, M-D-yyyy, MM-DD-yyyy, M-D-yyyy hh:mm:ss, MM-DD-yyyy hh:mm:ss, MM-DD-yyyy hh:mm A)",
                        level: "error",
                    }]
                }
            }
        },
        trimSpaces(value) {
            return {
                value: value.trim().toLowerCase().replace(/,\s*$/, ""),
                info: [{
                    message: "Spaces removed",
                    level: "warning"
                }]
            }
        },
        getContactNeeded(index = null) {
            if (index) {
                return {
                    value: "Contact Needed " + index,
                    info: [{
                        message: "Contact Needed " + index,
                        level: "warning"
                    }]
                }
            } else {
                return {
                    value: "Contact Needed",
                    info: [{
                        message: "Contact Needed",
                        level: "warning"
                    }]
                }
            }
        },
        checkAddress(address) {
            const prefix = address.prefix || "";
            const number = address.number || "";
            const street = address.street || "";
            const type = address.type || "";
            const suffix = address.suffix || "";
            let outAddress =
                prefix + " " + number + " " + street + " " + type + " " + suffix;
            let addressArray = outAddress.split("");
            if (addressArray[addressArray.length - 1] === " ") {
                addressArray.pop();
            }
            if (addressArray[0] === " ") {
                addressArray.shift();
            }
            outAddress = addressArray.join("");
            return outAddress;
        },
        checkDateFormats(value, isBehaviorDate = false) {
            const dateReFormats = [
                /^\d{1,2}\/\d{1,2}\/\d{2}$/,
                /^\d{1,2}\/\d{1,2}\/\d{2} \d{1,2}:\d{1,2}:\d{1,2}$/,
                /^\d{1,2}\/\d{1,2}\/\d{2} \d{1,2}:\d{1,2}$/,
                /^\d{1,2}\/\d{1,2}\/\d{2} \d{1,2}:\d{1,2} ?[AP]M$/,
                /^\d{1,2}-\d{1,2}-\d{2}$/,
                /^\d{1,2}-\d{1,2}-\d{2} \d{1,2}:\d{1,2}:\d{1,2}$/,
                /^\d{1,2}-\d{1,2}-\d{2} \d{1,2}:\d{1,2}$/,
                /^\d{1,2}-\d{1,2}-\d{2} \d{1,2}:\d{1,2} ?[AP]M$/
            ];
            const needToReformat = dateReFormats.some(regex => regex.test(value));
            if (needToReformat) {
                let lastPart = '';
                if (isBehaviorDate) {
                    if (value.includes('AM')) {
                        lastPart = ' AM';
                    } else if (value.includes('PM')) {
                        lastPart = ' PM';
                    }
                    value = value.replace(/\s[AP]M$/, '');
                }
                const parts = value.split(/[\/-]/);
                const currentYear = new Date().getFullYear().toString().substring(0, 2);
                parts[2] = currentYear + parts[2];
                value = parts.join('/');
                if (isBehaviorDate) {
                    value = value + lastPart;
                }
            }
            const dateFormats = [
                /^\d{1,2}\/\d{1,2}\/\d{4}$/,
                /^\d{1,2}\/\d{1,2}\/\d{4} \d{1,2}:\d{1,2}:\d{1,2}$/,
                /^\d{1,2}\/\d{1,2}\/\d{4} \d{1,2}:\d{1,2}$/,
                /^\d{1,2}-\d{1,2}-\d{4}$/,
                /^\d{1,2}-\d{1,2}-\d{4} \d{1,2}:\d{1,2}:\d{1,2}$/,
                /^\d{1,2}-\d{1,2}-\d{4} \d{1,2}:\d{1,2}$/
            ];
            if (isBehaviorDate) {
                dateFormats.push(/^\d{1,2}\/\d{1,2}\/\d{4} \d{1,2}:\d{1,2} ?[AP]M$/);
                dateFormats.push(/^\d{1,2}-\d{1,2}-\d{4} \d{1,2}:\d{1,2} ?[AP]M$/);
            }
            return dateFormats.some(regex => regex.test(value));
        },
        launchProject() {
            const $v = this;
            this.batch_id = 1;
            this.importerClients.setCustomer({userId: this.user.id});
            this.importerClients
                .requestDataFromUser()
                .then(function (results) {
                    $v.results = JSON.stringify(results.$data, null, 2);
                    $v.importerClients.displaySuccess("Success!");
                    console.log('results.$data', results.$data);
                    $v.savingPricingData(results.$data);
                })
                .catch(function (error) {
                    console.info(error || "window close");
                });
        },
        savingPricingData(data) {
            console.log('result', data);
            console.log('form', this.project.id);
            let payload = {
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                name: this.form.name,
                project_id: this.project.id,
                records: data
            }
            console.log('pricing', payload);
            axios.post(route('api.project.pricing'), payload).then(response => {
                console.log('response', response);
                if (response.status === 200) {
                    this.getToast().fire({
                        type: 'success',
                        title: 'Pricing updated successfully'
                    });
                } else {
                    this.getToast().fire({
                        type: 'error',
                        title: 'Column Mapping is not valid'
                    });
                }
                window.location.reload();
            }).catch((error) => {
                console.log('error', error);
            });
        },
        syncChangeOrderFromFoundation(index) {
            this.$refs.ProjectFoundationComponent.syncProjectChangeOrdersFromFoundation(index);
        },
        getFieldLabelForFlatFile(labels, slug) {
            slug = slug.replace(/_/g, '-')
            if(labels && labels.hasOwnProperty(slug)){
                return labels[slug];
            }else{
                return slug.replace(/-/g, ' ').toLowerCase().replace(/(^|\s)\S/g, (letter) => letter.toUpperCase());
            }
        },

        projectSalesActivityCommentSaved() {
            this.form_changed = false;
            window.onbeforeunload = null;
            let self = this;
            self.projectCommentForm.saving = true;
            self.projectCommentForm.post(route('api.project-comment.store', {project: self.project.id})).then((res) => {
                this.form_changed = false;
                self.projectCommentForm.saving = false;
                self.checkCommentStatus = 1;
                self.saved(true);
                $("#projectCommentModal").modal("hide");
                $("#projectSaleBehaviorCompleteCommentModal").modal("hide");
                self.tempSalesActivity = null;
                window.analytics.track('Project Comments', {
                    projectName: self.form.name,
                    timestamp: moment().format('YYYY-MM-DD  h:mm:ss a'),
                    userName: self.user.name,
                    userEmail: self.user.email,
                    comment: self.projectCommentForm.comment,
                    team: self.team.name
                });
                //load Notes comments
                this.$refs.projectcomments.fetchCommentsBy('note');
            });
        },
        getERPSyncSettingSalesStatusId() {
            let self = this;

            axios.get(route('api.erp.sync-setting.get-sales-status-id')).then((response) => {
                self.erpSyncSettingSalesStatusId = response.data.salesStatusId;
                self.erpSyncSettingWorkOrderSalesStatusId = response.data.workOrderSalesStatusId;
            }).catch((error) => {
                console.log("Error: " + error);
            });
        },
        pushProjectToEnabledERP() {
            // if(this.agaveErp.third_party_name === 'vista' && this.vistaProjectMapping && this.vistaProjectMapping.direction !== 'one-way-followup') {
            //     if(!this.project.vista_project_no) {
            //         this.$refs.ProjectVistaComponent.pushProjectToVista();
            //     }
            // }
            if(this.agaveErp.third_party_name === 'spectrum' && this.spectrumProjectMapping && this.spectrumProjectMapping.direction !== 'one-way-followup') {
                if(!this.project.spectrum_project_no) {
                    this.$refs.ProjectSpectrumComponent.pushProjectToSpectrum();
                }
            }
            if(this.agaveErp.third_party_name === 'foundationNew' && this.foundationProjectMapping && this.foundationProjectMapping.direction !== 'one-way-followup') {
                if(!this.project.foundation_project_no) {
                    this.$refs.ProjectFoundationComponent.pushProjectToFoundation();
                }
            }
            if(this.agaveErp.third_party_name === 'sage-300-cre' && this.agaveErp.project_field && this.agaveErp.project_field.direction !== 'one-way-followup') {
                if(!this.project.sage_cre_project_no) {
                    this.$refs.Sage300Project.pushProject();
                }
            }
            if(this.agaveErp.third_party_name === 'sage-100-contractor' && this.sageProjectMapping && this.sageProjectMapping.direction !== 'one-way-followup') {
                if(!this.project.sage_project_no) {
                    this.$refs.ProjectSageComponent.pushProjectToAgave();
                }
            }
        },
        pushProjectCancelled() {
            if(this.erpPushProjectInitiatedBySalesStatus) {
                this.form.sales_status_id = this.previousSelectedSalesStatusId;
                if(this.vistaAccess){
                  if((this.vistaProjectConnectionData.erpSyncSettingSalesStatusId || this.vistaProjectConnectionData.erpSyncSettingWorkOrderSalesStatusId) && this.previousSelectedSalesStatusId) {
                    this.adjustTextColor(this.project, this.previousSelectedSalesStatusId);
                  }
                }else{
                  if((this.erpSyncSettingSalesStatusId || this.erpSyncSettingWorkOrderSalesStatusId) && this.previousSelectedSalesStatusId) {
                      this.adjustTextColor(this.project, this.previousSelectedSalesStatusId);
                  }
                }
                this.erpPushProjectInitiatedBySalesStatus = false;
            }
        },
        isERPSyncSettingActionUpdate() {
            let self = this;
            const settingIndex = _.findIndex(self.projectErpSyncSettings, { 'entity_action': 'sync', 'entity_action_type': 'automatic', 'entity_action_depends_on': 'update' });

            return settingIndex !== -1;
        },
        isProjectERPSynced() {
            if(this.vistaAccess && this.project.vista_project_no
                && this.vistaProjectConnectionData.hasVistaProjectMapped && this.vistaProjectConnectionData.vistaProjectDirection !== 'one-way-followup') {
                return true;
            }
            if(this.agaveErp.third_party_name === 'spectrum' && this.project.spectrum_project_no
                && this.spectrumProjectMapping && this.spectrumProjectMapping.direction !== 'one-way-followup') {
                return true;
            }
            if(this.agaveErp.third_party_name === 'foundationNew' && this.project.foundation_project_no
                && this.foundationProjectMapping && this.foundationProjectMapping.direction !== 'one-way-followup') {
                return true;
            }
            if(this.agaveErp.third_party_name === 'sage-300-cre' && this.project.sage_cre_project_no
                && this.agaveErp.project_field && this.agaveErp.project_field.direction !== 'one-way-followup') {
                return true;
            }
            if(this.agaveErp.third_party_name === 'sage-100-contractor' && this.project.sage_project_no
                && this.sageProjectMapping && this.sageProjectMapping.direction !== 'one-way-followup') {
                return true;
            }
        },
        syncProjectToEnabledERP() {
            if(this.vistaAccess && this.project.vista_project_no) {
                this.$refs.ProjectVistaComponent.pushProjectToVista();
            }
            if(this.agaveErp.third_party_name === 'spectrum' && this.project.spectrum_project_no) {
                this.$refs.ProjectSpectrumComponent.pushProjectToSpectrum();
            }
            if(this.agaveErp.third_party_name === 'foundationNew' && this.project.foundation_project_no) {
                this.$refs.ProjectFoundationComponent.pushOrUpdateProjectToFoundation(null);
            }
            if(this.agaveErp.third_party_name === 'sage-300-cre' && this.project.sage_cre_project_no) {
                this.$refs.Sage300Project.showUpdateProjectPopup();
            }
            if(this.agaveErp.third_party_name === 'sage-100-contractor' && this.project.sage_project_no) {
                this.$refs.ProjectSageComponent.showUpdateProjectPopup();
            }
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

.vdatetime-popup{

    height: 500px !important;
}
.modal-backdrop {
    background-color: #2625258f !important;
}

@media only screen and (max-width: 700px) {
    .chmln-list-trigger {
        bottom: 85px !important;
    }
    .chmln-list {
        bottom: 165px !important;
    }
}

img.qb-small-logo-project {
    width: 20px;
    height: auto;
    background: white;
    border-radius: 50%;
    padding: 1px;
}
</style>
<style lang="scss" scoped>
.max-width{
    width: 97% !important
}

.input-select-design{
    padding: 5px;
    margin-bottom: 20px;
    border-radius: 15px;
    width: 100%;
    max-width: 97%;
}

.loader-center{
    position: absolute;
    top: 50%;
    left: 50%;
}
.dataforma-overlay {
    position: absolute; /* Sit on top of the page content */
    width: 100%; /* Full width (cover the whole page) */
    height: 100%; /* Full height (cover the whole page) */
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.5); /* Black background with opacity */
    z-index: 2;
}

div.companyCam > label > input {
    visibility: hidden;
    display: none;
}
.companyCam-label-style{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 95% !important;
    display:inline;
}

div.companyCam > label {
    display: block;
    width: 150px;
}

div.companyCam > label > img {
    display: inline-block;
    padding: 0;
    height:20px;
    width:20px;
    background: none;
}

div.companyCam > label > input:checked +img {
    background: url('/images/check-box.png');
    background-repeat: no-repeat;
    background-position:center center;
    background-size:15px 15px;
}

.tribute-container {
    z-index: 2000;
    margin: 0.4rem 0 0 0.9rem;
    background-color: #ffffff;
    border: 0.5px solid #dae7e7;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.08);
    -webkit-border-radius: 0.1rem;
    -moz-border-radius: 0.1rem;
    border-radius: 0.1rem;

    ul {
        padding: 0;

        li {
            list-style-type: none;
            cursor: pointer;
            color: black;
            width: 100%;
            text-align: left;
            padding: 0.3rem 3rem 0.3rem 0.7rem;
            border-top: 0.1px solid #dae7e7;
        }
    }
}

.selected-mention {
    background-color: #01b1af;
    color: white !important;
}

.vdp-datepicker {
    &.fullscreen-when-on-mobile {
        @media (max-width: 767px) {
            position: static;
            .vdp-datepicker__calendar {
                position: fixed;
                top: 50%;
                left: 5%;
                margin-top: -25%;
                width: 90%;
                z-index: 2000;
                outline: rgba(0, 0, 0, 0.5) solid 9999px;
            }
        }
    }

    .cell {
        &.today {
            background-color: rgb(220, 245, 252);
        }
    }
}

.sales-behavior-checkbox {
    width: 1.3rem;
    height: 1.3rem;
}

.bg-qualified {
    background-color: #00ff8f;
}

.contactDiv:hover {
    background-color: #e3e3e3;
}

.ql-editor {
    background-color: #fff;
    min-height: 200px;
}

.text-xxs {
    font-size: 0.70rem;
}

@media  only screen and (max-width: 1024px) {
    .input-select-design{
        max-width: 95%;
    }
    .max-width{
        width: 95% !important
    }
}
.frozen-form-button{
    position: fixed;
    background: #fcfcfc;
    padding: 15px;
    z-index: 999;
    width: 96vw;
    max-width: 1370px;
    margin: 0 auto;
    margin-top: -72px;
}
#overlayConfetti {
    position: fixed;
    display: none;
    width: 100%;
    height: 100%;
    top:18px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    cursor: pointer;
    margin-top: 56px;
}
.proposal-name-list{
    background:transparent !important;
    width: 100%;
}
.p-name{
    width: 50%;
}
.proposal-name-list-disabled {
    width: 45% !important;
}
.required-field-color {
    border: 1px solid #e3342f;
}
.signed-div{
    display:none;
}
@media only screen and (min-width: 992px) {
    .field-height-update{
        height: 30px;
    }
}

img.qb-small-logo-project {
    width: 20px;
}

.disabled-field-class {
    background-color: #dbdbdb !important;
}
.pac-container {
    z-index: 1055 !important;
}
#searchContacts_list {
    display: none;
    z-index: 999;
    width: 160%;
    box-shadow: 0px 0px 3px 2px #dcdcdc;
    background-color: #f7f7f7;
    margin-top: 5px;
    font-weight: 500;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    border-top: 0px !important;
    overflow-y: scroll;
    height: 300px;
    position: relative;
}
.searchContactsListContactDetail {
    padding: 5px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 12px;
    width: 200px;
}
.search-contacts-loader {
    position: absolute;
    top: 50%;
    left: 50%;
}
</style>
